var cov_1jnbbceoql = function () {
  var path = '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/user/userCtrl.js',
      hash = '45326a37ce6f9ec17fcdc80f428f494a0d0f5261',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/lampp/htdocs/www/omcg/apps/delta-monitoring/client/src/app/views/user/userCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 1187,
          column: 3
        }
      },
      '1': {
        start: {
          line: 6,
          column: 15
        },
        end: {
          line: 6,
          column: 21
        }
      },
      '2': {
        start: {
          line: 7,
          column: 22
        },
        end: {
          line: 7,
          column: 31
        }
      },
      '3': {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 36
        }
      },
      '4': {
        start: {
          line: 9,
          column: 2
        },
        end: {
          line: 9,
          column: 18
        }
      },
      '5': {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 33
        }
      },
      '6': {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 301,
          column: 4
        }
      },
      '7': {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 45,
          column: 37
        }
      },
      '8': {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 51,
          column: 8
        }
      },
      '9': {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 45
        }
      },
      '10': {
        start: {
          line: 53,
          column: 6
        },
        end: {
          line: 53,
          column: 48
        }
      },
      '11': {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 48
        }
      },
      '12': {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 51
        }
      },
      '13': {
        start: {
          line: 57,
          column: 6
        },
        end: {
          line: 57,
          column: 27
        }
      },
      '14': {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 30
        }
      },
      '15': {
        start: {
          line: 65,
          column: 17
        },
        end: {
          line: 65,
          column: 21
        }
      },
      '16': {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 51
        }
      },
      '17': {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 71,
          column: 7
        }
      },
      '18': {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 68
        }
      },
      '19': {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 15
        }
      },
      '20': {
        start: {
          line: 73,
          column: 26
        },
        end: {
          line: 73,
          column: 89
        }
      },
      '21': {
        start: {
          line: 74,
          column: 26
        },
        end: {
          line: 74,
          column: 27
        }
      },
      '22': {
        start: {
          line: 75,
          column: 6
        },
        end: {
          line: 80,
          column: 9
        }
      },
      '23': {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 79,
          column: 9
        }
      },
      '24': {
        start: {
          line: 77,
          column: 10
        },
        end: {
          line: 77,
          column: 60
        }
      },
      '25': {
        start: {
          line: 78,
          column: 10
        },
        end: {
          line: 78,
          column: 26
        }
      },
      '26': {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 52
        }
      },
      '27': {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 45
        }
      },
      '28': {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 42
        }
      },
      '29': {
        start: {
          line: 96,
          column: 17
        },
        end: {
          line: 96,
          column: 21
        }
      },
      '30': {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 38
        }
      },
      '31': {
        start: {
          line: 97,
          column: 31
        },
        end: {
          line: 97,
          column: 38
        }
      },
      '32': {
        start: {
          line: 99,
          column: 26
        },
        end: {
          line: 99,
          column: 27
        }
      },
      '33': {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 106,
          column: 7
        }
      },
      '34': {
        start: {
          line: 101,
          column: 33
        },
        end: {
          line: 101,
          column: 101
        }
      },
      '35': {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 105,
          column: 11
        }
      },
      '36': {
        start: {
          line: 103,
          column: 10
        },
        end: {
          line: 103,
          column: 68
        }
      },
      '37': {
        start: {
          line: 104,
          column: 10
        },
        end: {
          line: 104,
          column: 26
        }
      },
      '38': {
        start: {
          line: 107,
          column: 6
        },
        end: {
          line: 113,
          column: 7
        }
      },
      '39': {
        start: {
          line: 108,
          column: 31
        },
        end: {
          line: 108,
          column: 97
        }
      },
      '40': {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 112,
          column: 11
        }
      },
      '41': {
        start: {
          line: 110,
          column: 10
        },
        end: {
          line: 110,
          column: 66
        }
      },
      '42': {
        start: {
          line: 111,
          column: 10
        },
        end: {
          line: 111,
          column: 26
        }
      },
      '43': {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 58
        }
      },
      '44': {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 48
        }
      },
      '45': {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 122,
          column: 45
        }
      },
      '46': {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 86
        }
      },
      '47': {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 134,
          column: 7
        }
      },
      '48': {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 131,
          column: 30
        }
      },
      '49': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 32
        }
      },
      '50': {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 92
        }
      },
      '51': {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 146,
          column: 7
        }
      },
      '52': {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 33
        }
      },
      '53': {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 145,
          column: 35
        }
      },
      '54': {
        start: {
          line: 153,
          column: 6
        },
        end: {
          line: 153,
          column: 79
        }
      },
      '55': {
        start: {
          line: 153,
          column: 70
        },
        end: {
          line: 153,
          column: 79
        }
      },
      '56': {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 156,
          column: 16
        }
      },
      '57': {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 155,
          column: 81
        }
      },
      '58': {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 163,
          column: 82
        }
      },
      '59': {
        start: {
          line: 163,
          column: 73
        },
        end: {
          line: 163,
          column: 82
        }
      },
      '60': {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 166,
          column: 16
        }
      },
      '61': {
        start: {
          line: 165,
          column: 8
        },
        end: {
          line: 165,
          column: 84
        }
      },
      '62': {
        start: {
          line: 173,
          column: 6
        },
        end: {
          line: 173,
          column: 45
        }
      },
      '63': {
        start: {
          line: 173,
          column: 32
        },
        end: {
          line: 173,
          column: 45
        }
      },
      '64': {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 174,
          column: 83
        }
      },
      '65': {
        start: {
          line: 174,
          column: 70
        },
        end: {
          line: 174,
          column: 83
        }
      },
      '66': {
        start: {
          line: 176,
          column: 24
        },
        end: {
          line: 176,
          column: 69
        }
      },
      '67': {
        start: {
          line: 177,
          column: 24
        },
        end: {
          line: 177,
          column: 80
        }
      },
      '68': {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 181,
          column: 25
        }
      },
      '69': {
        start: {
          line: 188,
          column: 17
        },
        end: {
          line: 188,
          column: 21
        }
      },
      '70': {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 189,
          column: 56
        }
      },
      '71': {
        start: {
          line: 191,
          column: 6
        },
        end: {
          line: 194,
          column: 7
        }
      },
      '72': {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 54
        }
      },
      '73': {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 193,
          column: 15
        }
      },
      '74': {
        start: {
          line: 196,
          column: 20
        },
        end: {
          line: 198,
          column: 51
        }
      },
      '75': {
        start: {
          line: 197,
          column: 32
        },
        end: {
          line: 197,
          column: 87
        }
      },
      '76': {
        start: {
          line: 198,
          column: 28
        },
        end: {
          line: 198,
          column: 48
        }
      },
      '77': {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 207,
          column: 7
        }
      },
      '78': {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 204,
          column: 54
        }
      },
      '79': {
        start: {
          line: 203,
          column: 34
        },
        end: {
          line: 203,
          column: 92
        }
      },
      '80': {
        start: {
          line: 204,
          column: 30
        },
        end: {
          line: 204,
          column: 50
        }
      },
      '81': {
        start: {
          line: 206,
          column: 8
        },
        end: {
          line: 206,
          column: 67
        }
      },
      '82': {
        start: {
          line: 209,
          column: 22
        },
        end: {
          line: 209,
          column: 60
        }
      },
      '83': {
        start: {
          line: 210,
          column: 25
        },
        end: {
          line: 210,
          column: 66
        }
      },
      '84': {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 228,
          column: 9
        }
      },
      '85': {
        start: {
          line: 225,
          column: 8
        },
        end: {
          line: 227,
          column: 9
        }
      },
      '86': {
        start: {
          line: 226,
          column: 10
        },
        end: {
          line: 226,
          column: 69
        }
      },
      '87': {
        start: {
          line: 235,
          column: 17
        },
        end: {
          line: 235,
          column: 21
        }
      },
      '88': {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 236,
          column: 31
        }
      },
      '89': {
        start: {
          line: 237,
          column: 6
        },
        end: {
          line: 237,
          column: 32
        }
      },
      '90': {
        start: {
          line: 239,
          column: 6
        },
        end: {
          line: 299,
          column: 9
        }
      },
      '91': {
        start: {
          line: 247,
          column: 8
        },
        end: {
          line: 247,
          column: 34
        }
      },
      '92': {
        start: {
          line: 248,
          column: 8
        },
        end: {
          line: 290,
          column: 9
        }
      },
      '93': {
        start: {
          line: 249,
          column: 10
        },
        end: {
          line: 254,
          column: 12
        }
      },
      '94': {
        start: {
          line: 256,
          column: 10
        },
        end: {
          line: 267,
          column: 13
        }
      },
      '95': {
        start: {
          line: 262,
          column: 12
        },
        end: {
          line: 266,
          column: 13
        }
      },
      '96': {
        start: {
          line: 264,
          column: 14
        },
        end: {
          line: 264,
          column: 45
        }
      },
      '97': {
        start: {
          line: 265,
          column: 14
        },
        end: {
          line: 265,
          column: 30
        }
      },
      '98': {
        start: {
          line: 269,
          column: 10
        },
        end: {
          line: 279,
          column: 12
        }
      },
      '99': {
        start: {
          line: 281,
          column: 10
        },
        end: {
          line: 281,
          column: 31
        }
      },
      '100': {
        start: {
          line: 282,
          column: 10
        },
        end: {
          line: 282,
          column: 34
        }
      },
      '101': {
        start: {
          line: 284,
          column: 10
        },
        end: {
          line: 289,
          column: 13
        }
      },
      '102': {
        start: {
          line: 292,
          column: 8
        },
        end: {
          line: 292,
          column: 34
        }
      },
      '103': {
        start: {
          line: 293,
          column: 8
        },
        end: {
          line: 298,
          column: 11
        }
      },
      '104': {
        start: {
          line: 303,
          column: 2
        },
        end: {
          line: 307,
          column: 4
        }
      },
      '105': {
        start: {
          line: 309,
          column: 2
        },
        end: {
          line: 498,
          column: 4
        }
      },
      '106': {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 326,
          column: 69
        }
      },
      '107': {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 327,
          column: 34
        }
      },
      '108': {
        start: {
          line: 330,
          column: 6
        },
        end: {
          line: 332,
          column: 7
        }
      },
      '109': {
        start: {
          line: 331,
          column: 8
        },
        end: {
          line: 331,
          column: 48
        }
      },
      '110': {
        start: {
          line: 333,
          column: 6
        },
        end: {
          line: 333,
          column: 34
        }
      },
      '111': {
        start: {
          line: 336,
          column: 6
        },
        end: {
          line: 338,
          column: 7
        }
      },
      '112': {
        start: {
          line: 337,
          column: 8
        },
        end: {
          line: 337,
          column: 49
        }
      },
      '113': {
        start: {
          line: 339,
          column: 6
        },
        end: {
          line: 339,
          column: 34
        }
      },
      '114': {
        start: {
          line: 342,
          column: 6
        },
        end: {
          line: 344,
          column: 7
        }
      },
      '115': {
        start: {
          line: 343,
          column: 8
        },
        end: {
          line: 343,
          column: 81
        }
      },
      '116': {
        start: {
          line: 345,
          column: 6
        },
        end: {
          line: 354,
          column: 7
        }
      },
      '117': {
        start: {
          line: 346,
          column: 8
        },
        end: {
          line: 351,
          column: 11
        }
      },
      '118': {
        start: {
          line: 347,
          column: 10
        },
        end: {
          line: 349,
          column: 11
        }
      },
      '119': {
        start: {
          line: 348,
          column: 12
        },
        end: {
          line: 348,
          column: 24
        }
      },
      '120': {
        start: {
          line: 350,
          column: 10
        },
        end: {
          line: 350,
          column: 97
        }
      },
      '121': {
        start: {
          line: 353,
          column: 8
        },
        end: {
          line: 353,
          column: 81
        }
      },
      '122': {
        start: {
          line: 359,
          column: 6
        },
        end: {
          line: 365,
          column: 9
        }
      },
      '123': {
        start: {
          line: 360,
          column: 8
        },
        end: {
          line: 364,
          column: 12
        }
      },
      '124': {
        start: {
          line: 360,
          column: 54
        },
        end: {
          line: 364,
          column: 9
        }
      },
      '125': {
        start: {
          line: 368,
          column: 20
        },
        end: {
          line: 368,
          column: 54
        }
      },
      '126': {
        start: {
          line: 369,
          column: 6
        },
        end: {
          line: 373,
          column: 7
        }
      },
      '127': {
        start: {
          line: 370,
          column: 8
        },
        end: {
          line: 370,
          column: 40
        }
      },
      '128': {
        start: {
          line: 372,
          column: 8
        },
        end: {
          line: 372,
          column: 45
        }
      },
      '129': {
        start: {
          line: 377,
          column: 6
        },
        end: {
          line: 377,
          column: 73
        }
      },
      '130': {
        start: {
          line: 377,
          column: 66
        },
        end: {
          line: 377,
          column: 71
        }
      },
      '131': {
        start: {
          line: 383,
          column: 6
        },
        end: {
          line: 389,
          column: 9
        }
      },
      '132': {
        start: {
          line: 384,
          column: 8
        },
        end: {
          line: 388,
          column: 12
        }
      },
      '133': {
        start: {
          line: 384,
          column: 54
        },
        end: {
          line: 388,
          column: 9
        }
      },
      '134': {
        start: {
          line: 392,
          column: 6
        },
        end: {
          line: 392,
          column: 71
        }
      },
      '135': {
        start: {
          line: 393,
          column: 6
        },
        end: {
          line: 393,
          column: 34
        }
      },
      '136': {
        start: {
          line: 396,
          column: 6
        },
        end: {
          line: 396,
          column: 64
        }
      },
      '137': {
        start: {
          line: 396,
          column: 57
        },
        end: {
          line: 396,
          column: 62
        }
      },
      '138': {
        start: {
          line: 400,
          column: 6
        },
        end: {
          line: 402,
          column: 7
        }
      },
      '139': {
        start: {
          line: 401,
          column: 8
        },
        end: {
          line: 401,
          column: 83
        }
      },
      '140': {
        start: {
          line: 403,
          column: 6
        },
        end: {
          line: 412,
          column: 7
        }
      },
      '141': {
        start: {
          line: 404,
          column: 8
        },
        end: {
          line: 409,
          column: 11
        }
      },
      '142': {
        start: {
          line: 405,
          column: 10
        },
        end: {
          line: 407,
          column: 11
        }
      },
      '143': {
        start: {
          line: 406,
          column: 12
        },
        end: {
          line: 406,
          column: 24
        }
      },
      '144': {
        start: {
          line: 408,
          column: 10
        },
        end: {
          line: 408,
          column: 87
        }
      },
      '145': {
        start: {
          line: 411,
          column: 8
        },
        end: {
          line: 411,
          column: 83
        }
      },
      '146': {
        start: {
          line: 416,
          column: 20
        },
        end: {
          line: 416,
          column: 60
        }
      },
      '147': {
        start: {
          line: 417,
          column: 6
        },
        end: {
          line: 421,
          column: 7
        }
      },
      '148': {
        start: {
          line: 418,
          column: 8
        },
        end: {
          line: 418,
          column: 46
        }
      },
      '149': {
        start: {
          line: 420,
          column: 8
        },
        end: {
          line: 420,
          column: 47
        }
      },
      '150': {
        start: {
          line: 424,
          column: 6
        },
        end: {
          line: 424,
          column: 67
        }
      },
      '151': {
        start: {
          line: 424,
          column: 57
        },
        end: {
          line: 424,
          column: 65
        }
      },
      '152': {
        start: {
          line: 428,
          column: 6
        },
        end: {
          line: 430,
          column: 7
        }
      },
      '153': {
        start: {
          line: 429,
          column: 8
        },
        end: {
          line: 429,
          column: 79
        }
      },
      '154': {
        start: {
          line: 431,
          column: 6
        },
        end: {
          line: 440,
          column: 7
        }
      },
      '155': {
        start: {
          line: 432,
          column: 8
        },
        end: {
          line: 437,
          column: 11
        }
      },
      '156': {
        start: {
          line: 433,
          column: 10
        },
        end: {
          line: 435,
          column: 11
        }
      },
      '157': {
        start: {
          line: 434,
          column: 12
        },
        end: {
          line: 434,
          column: 24
        }
      },
      '158': {
        start: {
          line: 436,
          column: 10
        },
        end: {
          line: 436,
          column: 89
        }
      },
      '159': {
        start: {
          line: 439,
          column: 8
        },
        end: {
          line: 439,
          column: 79
        }
      },
      '160': {
        start: {
          line: 445,
          column: 6
        },
        end: {
          line: 458,
          column: 7
        }
      },
      '161': {
        start: {
          line: 447,
          column: 10
        },
        end: {
          line: 447,
          column: 35
        }
      },
      '162': {
        start: {
          line: 448,
          column: 10
        },
        end: {
          line: 448,
          column: 16
        }
      },
      '163': {
        start: {
          line: 450,
          column: 10
        },
        end: {
          line: 450,
          column: 35
        }
      },
      '164': {
        start: {
          line: 451,
          column: 10
        },
        end: {
          line: 451,
          column: 38
        }
      },
      '165': {
        start: {
          line: 452,
          column: 10
        },
        end: {
          line: 452,
          column: 16
        }
      },
      '166': {
        start: {
          line: 454,
          column: 10
        },
        end: {
          line: 454,
          column: 37
        }
      },
      '167': {
        start: {
          line: 455,
          column: 10
        },
        end: {
          line: 455,
          column: 16
        }
      },
      '168': {
        start: {
          line: 463,
          column: 6
        },
        end: {
          line: 467,
          column: 7
        }
      },
      '169': {
        start: {
          line: 464,
          column: 8
        },
        end: {
          line: 466,
          column: 9
        }
      },
      '170': {
        start: {
          line: 465,
          column: 10
        },
        end: {
          line: 465,
          column: 23
        }
      },
      '171': {
        start: {
          line: 468,
          column: 17
        },
        end: {
          line: 468,
          column: 78
        }
      },
      '172': {
        start: {
          line: 469,
          column: 6
        },
        end: {
          line: 477,
          column: 7
        }
      },
      '173': {
        start: {
          line: 470,
          column: 8
        },
        end: {
          line: 470,
          column: 79
        }
      },
      '174': {
        start: {
          line: 471,
          column: 8
        },
        end: {
          line: 476,
          column: 9
        }
      },
      '175': {
        start: {
          line: 472,
          column: 10
        },
        end: {
          line: 472,
          column: 84
        }
      },
      '176': {
        start: {
          line: 473,
          column: 10
        },
        end: {
          line: 475,
          column: 11
        }
      },
      '177': {
        start: {
          line: 474,
          column: 12
        },
        end: {
          line: 474,
          column: 25
        }
      },
      '178': {
        start: {
          line: 479,
          column: 22
        },
        end: {
          line: 481,
          column: 8
        }
      },
      '179': {
        start: {
          line: 480,
          column: 8
        },
        end: {
          line: 480,
          column: 49
        }
      },
      '180': {
        start: {
          line: 483,
          column: 6
        },
        end: {
          line: 488,
          column: 7
        }
      },
      '181': {
        start: {
          line: 484,
          column: 8
        },
        end: {
          line: 486,
          column: 9
        }
      },
      '182': {
        start: {
          line: 485,
          column: 10
        },
        end: {
          line: 485,
          column: 37
        }
      },
      '183': {
        start: {
          line: 487,
          column: 8
        },
        end: {
          line: 487,
          column: 20
        }
      },
      '184': {
        start: {
          line: 490,
          column: 6
        },
        end: {
          line: 494,
          column: 7
        }
      },
      '185': {
        start: {
          line: 491,
          column: 8
        },
        end: {
          line: 493,
          column: 9
        }
      },
      '186': {
        start: {
          line: 492,
          column: 10
        },
        end: {
          line: 492,
          column: 23
        }
      },
      '187': {
        start: {
          line: 496,
          column: 6
        },
        end: {
          line: 496,
          column: 18
        }
      },
      '188': {
        start: {
          line: 500,
          column: 2
        },
        end: {
          line: 518,
          column: 4
        }
      },
      '189': {
        start: {
          line: 507,
          column: 19
        },
        end: {
          line: 507,
          column: 46
        }
      },
      '190': {
        start: {
          line: 508,
          column: 16
        },
        end: {
          line: 508,
          column: 18
        }
      },
      '191': {
        start: {
          line: 509,
          column: 6
        },
        end: {
          line: 515,
          column: 7
        }
      },
      '192': {
        start: {
          line: 510,
          column: 8
        },
        end: {
          line: 514,
          column: 9
        }
      },
      '193': {
        start: {
          line: 511,
          column: 10
        },
        end: {
          line: 513,
          column: 11
        }
      },
      '194': {
        start: {
          line: 512,
          column: 12
        },
        end: {
          line: 512,
          column: 39
        }
      },
      '195': {
        start: {
          line: 516,
          column: 6
        },
        end: {
          line: 516,
          column: 15
        }
      },
      '196': {
        start: {
          line: 520,
          column: 2
        },
        end: {
          line: 991,
          column: 4
        }
      },
      '197': {
        start: {
          line: 523,
          column: 6
        },
        end: {
          line: 523,
          column: 37
        }
      },
      '198': {
        start: {
          line: 524,
          column: 6
        },
        end: {
          line: 524,
          column: 67
        }
      },
      '199': {
        start: {
          line: 532,
          column: 6
        },
        end: {
          line: 534,
          column: 7
        }
      },
      '200': {
        start: {
          line: 533,
          column: 8
        },
        end: {
          line: 533,
          column: 21
        }
      },
      '201': {
        start: {
          line: 535,
          column: 26
        },
        end: {
          line: 535,
          column: 66
        }
      },
      '202': {
        start: {
          line: 536,
          column: 6
        },
        end: {
          line: 536,
          column: 96
        }
      },
      '203': {
        start: {
          line: 539,
          column: 6
        },
        end: {
          line: 541,
          column: 7
        }
      },
      '204': {
        start: {
          line: 540,
          column: 8
        },
        end: {
          line: 540,
          column: 21
        }
      },
      '205': {
        start: {
          line: 543,
          column: 6
        },
        end: {
          line: 545,
          column: 7
        }
      },
      '206': {
        start: {
          line: 544,
          column: 8
        },
        end: {
          line: 544,
          column: 52
        }
      },
      '207': {
        start: {
          line: 547,
          column: 6
        },
        end: {
          line: 549,
          column: 7
        }
      },
      '208': {
        start: {
          line: 548,
          column: 8
        },
        end: {
          line: 548,
          column: 59
        }
      },
      '209': {
        start: {
          line: 550,
          column: 6
        },
        end: {
          line: 550,
          column: 19
        }
      },
      '210': {
        start: {
          line: 600,
          column: 6
        },
        end: {
          line: 600,
          column: 28
        }
      },
      '211': {
        start: {
          line: 601,
          column: 6
        },
        end: {
          line: 601,
          column: 67
        }
      },
      '212': {
        start: {
          line: 602,
          column: 6
        },
        end: {
          line: 607,
          column: 7
        }
      },
      '213': {
        start: {
          line: 603,
          column: 8
        },
        end: {
          line: 606,
          column: 9
        }
      },
      '214': {
        start: {
          line: 604,
          column: 10
        },
        end: {
          line: 604,
          column: 32
        }
      },
      '215': {
        start: {
          line: 605,
          column: 10
        },
        end: {
          line: 605,
          column: 16
        }
      },
      '216': {
        start: {
          line: 611,
          column: 6
        },
        end: {
          line: 631,
          column: 7
        }
      },
      '217': {
        start: {
          line: 612,
          column: 8
        },
        end: {
          line: 618,
          column: 9
        }
      },
      '218': {
        start: {
          line: 613,
          column: 10
        },
        end: {
          line: 615,
          column: 11
        }
      },
      '219': {
        start: {
          line: 614,
          column: 12
        },
        end: {
          line: 614,
          column: 70
        }
      },
      '220': {
        start: {
          line: 617,
          column: 10
        },
        end: {
          line: 617,
          column: 68
        }
      },
      '221': {
        start: {
          line: 620,
          column: 8
        },
        end: {
          line: 624,
          column: 9
        }
      },
      '222': {
        start: {
          line: 621,
          column: 10
        },
        end: {
          line: 621,
          column: 46
        }
      },
      '223': {
        start: {
          line: 623,
          column: 10
        },
        end: {
          line: 623,
          column: 100
        }
      },
      '224': {
        start: {
          line: 625,
          column: 13
        },
        end: {
          line: 631,
          column: 7
        }
      },
      '225': {
        start: {
          line: 626,
          column: 8
        },
        end: {
          line: 628,
          column: 9
        }
      },
      '226': {
        start: {
          line: 627,
          column: 10
        },
        end: {
          line: 627,
          column: 97
        }
      },
      '227': {
        start: {
          line: 630,
          column: 8
        },
        end: {
          line: 630,
          column: 66
        }
      },
      '228': {
        start: {
          line: 634,
          column: 6
        },
        end: {
          line: 636,
          column: 7
        }
      },
      '229': {
        start: {
          line: 635,
          column: 8
        },
        end: {
          line: 635,
          column: 29
        }
      },
      '230': {
        start: {
          line: 637,
          column: 6
        },
        end: {
          line: 639,
          column: 7
        }
      },
      '231': {
        start: {
          line: 638,
          column: 8
        },
        end: {
          line: 638,
          column: 29
        }
      },
      '232': {
        start: {
          line: 640,
          column: 19
        },
        end: {
          line: 640,
          column: 21
        }
      },
      '233': {
        start: {
          line: 642,
          column: 6
        },
        end: {
          line: 646,
          column: 7
        }
      },
      '234': {
        start: {
          line: 643,
          column: 8
        },
        end: {
          line: 645,
          column: 9
        }
      },
      '235': {
        start: {
          line: 644,
          column: 10
        },
        end: {
          line: 644,
          column: 24
        }
      },
      '236': {
        start: {
          line: 647,
          column: 6
        },
        end: {
          line: 647,
          column: 18
        }
      },
      '237': {
        start: {
          line: 661,
          column: 6
        },
        end: {
          line: 661,
          column: 39
        }
      },
      '238': {
        start: {
          line: 662,
          column: 6
        },
        end: {
          line: 668,
          column: 9
        }
      },
      '239': {
        start: {
          line: 671,
          column: 6
        },
        end: {
          line: 673,
          column: 9
        }
      },
      '240': {
        start: {
          line: 672,
          column: 8
        },
        end: {
          line: 672,
          column: 42
        }
      },
      '241': {
        start: {
          line: 678,
          column: 6
        },
        end: {
          line: 678,
          column: 30
        }
      },
      '242': {
        start: {
          line: 680,
          column: 22
        },
        end: {
          line: 682,
          column: 8
        }
      },
      '243': {
        start: {
          line: 681,
          column: 8
        },
        end: {
          line: 681,
          column: 50
        }
      },
      '244': {
        start: {
          line: 684,
          column: 22
        },
        end: {
          line: 686,
          column: 8
        }
      },
      '245': {
        start: {
          line: 685,
          column: 8
        },
        end: {
          line: 685,
          column: 49
        }
      },
      '246': {
        start: {
          line: 687,
          column: 6
        },
        end: {
          line: 698,
          column: 9
        }
      },
      '247': {
        start: {
          line: 688,
          column: 8
        },
        end: {
          line: 692,
          column: 9
        }
      },
      '248': {
        start: {
          line: 689,
          column: 10
        },
        end: {
          line: 689,
          column: 43
        }
      },
      '249': {
        start: {
          line: 690,
          column: 10
        },
        end: {
          line: 690,
          column: 45
        }
      },
      '250': {
        start: {
          line: 691,
          column: 10
        },
        end: {
          line: 691,
          column: 56
        }
      },
      '251': {
        start: {
          line: 693,
          column: 8
        },
        end: {
          line: 695,
          column: 11
        }
      },
      '252': {
        start: {
          line: 694,
          column: 10
        },
        end: {
          line: 694,
          column: 36
        }
      },
      '253': {
        start: {
          line: 696,
          column: 8
        },
        end: {
          line: 696,
          column: 42
        }
      },
      '254': {
        start: {
          line: 697,
          column: 8
        },
        end: {
          line: 697,
          column: 33
        }
      },
      '255': {
        start: {
          line: 699,
          column: 6
        },
        end: {
          line: 699,
          column: 24
        }
      },
      '256': {
        start: {
          line: 702,
          column: 6
        },
        end: {
          line: 713,
          column: 9
        }
      },
      '257': {
        start: {
          line: 720,
          column: 6
        },
        end: {
          line: 720,
          column: 36
        }
      },
      '258': {
        start: {
          line: 723,
          column: 6
        },
        end: {
          line: 735,
          column: 7
        }
      },
      '259': {
        start: {
          line: 724,
          column: 8
        },
        end: {
          line: 724,
          column: 79
        }
      },
      '260': {
        start: {
          line: 725,
          column: 8
        },
        end: {
          line: 725,
          column: 73
        }
      },
      '261': {
        start: {
          line: 726,
          column: 8
        },
        end: {
          line: 726,
          column: 73
        }
      },
      '262': {
        start: {
          line: 727,
          column: 18
        },
        end: {
          line: 727,
          column: 96
        }
      },
      '263': {
        start: {
          line: 728,
          column: 8
        },
        end: {
          line: 730,
          column: 9
        }
      },
      '264': {
        start: {
          line: 729,
          column: 10
        },
        end: {
          line: 729,
          column: 44
        }
      },
      '265': {
        start: {
          line: 732,
          column: 8
        },
        end: {
          line: 732,
          column: 38
        }
      },
      '266': {
        start: {
          line: 734,
          column: 8
        },
        end: {
          line: 734,
          column: 39
        }
      },
      '267': {
        start: {
          line: 738,
          column: 6
        },
        end: {
          line: 740,
          column: 7
        }
      },
      '268': {
        start: {
          line: 739,
          column: 8
        },
        end: {
          line: 739,
          column: 20
        }
      },
      '269': {
        start: {
          line: 741,
          column: 6
        },
        end: {
          line: 743,
          column: 7
        }
      },
      '270': {
        start: {
          line: 742,
          column: 8
        },
        end: {
          line: 742,
          column: 21
        }
      },
      '271': {
        start: {
          line: 744,
          column: 6
        },
        end: {
          line: 746,
          column: 7
        }
      },
      '272': {
        start: {
          line: 745,
          column: 8
        },
        end: {
          line: 745,
          column: 20
        }
      },
      '273': {
        start: {
          line: 747,
          column: 6
        },
        end: {
          line: 751,
          column: 7
        }
      },
      '274': {
        start: {
          line: 748,
          column: 8
        },
        end: {
          line: 750,
          column: 9
        }
      },
      '275': {
        start: {
          line: 749,
          column: 10
        },
        end: {
          line: 749,
          column: 23
        }
      },
      '276': {
        start: {
          line: 752,
          column: 6
        },
        end: {
          line: 752,
          column: 18
        }
      },
      '277': {
        start: {
          line: 755,
          column: 6
        },
        end: {
          line: 758,
          column: 8
        }
      },
      '278': {
        start: {
          line: 760,
          column: 6
        },
        end: {
          line: 760,
          column: 44
        }
      },
      '279': {
        start: {
          line: 761,
          column: 6
        },
        end: {
          line: 766,
          column: 7
        }
      },
      '280': {
        start: {
          line: 762,
          column: 8
        },
        end: {
          line: 762,
          column: 41
        }
      },
      '281': {
        start: {
          line: 764,
          column: 22
        },
        end: {
          line: 764,
          column: 67
        }
      },
      '282': {
        start: {
          line: 765,
          column: 8
        },
        end: {
          line: 765,
          column: 74
        }
      },
      '283': {
        start: {
          line: 768,
          column: 6
        },
        end: {
          line: 768,
          column: 41
        }
      },
      '284': {
        start: {
          line: 769,
          column: 20
        },
        end: {
          line: 769,
          column: 22
        }
      },
      '285': {
        start: {
          line: 771,
          column: 27
        },
        end: {
          line: 773,
          column: 8
        }
      },
      '286': {
        start: {
          line: 772,
          column: 8
        },
        end: {
          line: 772,
          column: 26
        }
      },
      '287': {
        start: {
          line: 775,
          column: 6
        },
        end: {
          line: 777,
          column: 7
        }
      },
      '288': {
        start: {
          line: 776,
          column: 8
        },
        end: {
          line: 776,
          column: 41
        }
      },
      '289': {
        start: {
          line: 779,
          column: 6
        },
        end: {
          line: 786,
          column: 9
        }
      },
      '290': {
        start: {
          line: 780,
          column: 8
        },
        end: {
          line: 784,
          column: 9
        }
      },
      '291': {
        start: {
          line: 781,
          column: 10
        },
        end: {
          line: 783,
          column: 13
        }
      },
      '292': {
        start: {
          line: 782,
          column: 12
        },
        end: {
          line: 782,
          column: 40
        }
      },
      '293': {
        start: {
          line: 785,
          column: 8
        },
        end: {
          line: 785,
          column: 44
        }
      },
      '294': {
        start: {
          line: 788,
          column: 6
        },
        end: {
          line: 788,
          column: 69
        }
      },
      '295': {
        start: {
          line: 789,
          column: 6
        },
        end: {
          line: 789,
          column: 71
        }
      },
      '296': {
        start: {
          line: 790,
          column: 6
        },
        end: {
          line: 790,
          column: 90
        }
      },
      '297': {
        start: {
          line: 791,
          column: 6
        },
        end: {
          line: 791,
          column: 125
        }
      },
      '298': {
        start: {
          line: 792,
          column: 6
        },
        end: {
          line: 794,
          column: 7
        }
      },
      '299': {
        start: {
          line: 793,
          column: 8
        },
        end: {
          line: 793,
          column: 66
        }
      },
      '300': {
        start: {
          line: 796,
          column: 6
        },
        end: {
          line: 796,
          column: 113
        }
      },
      '301': {
        start: {
          line: 797,
          column: 6
        },
        end: {
          line: 799,
          column: 7
        }
      },
      '302': {
        start: {
          line: 798,
          column: 8
        },
        end: {
          line: 798,
          column: 81
        }
      },
      '303': {
        start: {
          line: 801,
          column: 6
        },
        end: {
          line: 806,
          column: 7
        }
      },
      '304': {
        start: {
          line: 802,
          column: 8
        },
        end: {
          line: 802,
          column: 54
        }
      },
      '305': {
        start: {
          line: 803,
          column: 8
        },
        end: {
          line: 803,
          column: 97
        }
      },
      '306': {
        start: {
          line: 805,
          column: 8
        },
        end: {
          line: 805,
          column: 82
        }
      },
      '307': {
        start: {
          line: 808,
          column: 6
        },
        end: {
          line: 810,
          column: 7
        }
      },
      '308': {
        start: {
          line: 809,
          column: 8
        },
        end: {
          line: 809,
          column: 49
        }
      },
      '309': {
        start: {
          line: 811,
          column: 6
        },
        end: {
          line: 811,
          column: 59
        }
      },
      '310': {
        start: {
          line: 812,
          column: 6
        },
        end: {
          line: 812,
          column: 71
        }
      },
      '311': {
        start: {
          line: 813,
          column: 6
        },
        end: {
          line: 813,
          column: 83
        }
      },
      '312': {
        start: {
          line: 815,
          column: 6
        },
        end: {
          line: 815,
          column: 108
        }
      },
      '313': {
        start: {
          line: 820,
          column: 6
        },
        end: {
          line: 820,
          column: 33
        }
      },
      '314': {
        start: {
          line: 823,
          column: 6
        },
        end: {
          line: 823,
          column: 30
        }
      },
      '315': {
        start: {
          line: 826,
          column: 6
        },
        end: {
          line: 826,
          column: 68
        }
      },
      '316': {
        start: {
          line: 827,
          column: 6
        },
        end: {
          line: 833,
          column: 8
        }
      },
      '317': {
        start: {
          line: 835,
          column: 6
        },
        end: {
          line: 835,
          column: 88
        }
      },
      '318': {
        start: {
          line: 836,
          column: 6
        },
        end: {
          line: 836,
          column: 97
        }
      },
      '319': {
        start: {
          line: 837,
          column: 6
        },
        end: {
          line: 837,
          column: 107
        }
      },
      '320': {
        start: {
          line: 838,
          column: 6
        },
        end: {
          line: 842,
          column: 7
        }
      },
      '321': {
        start: {
          line: 839,
          column: 8
        },
        end: {
          line: 839,
          column: 40
        }
      },
      '322': {
        start: {
          line: 840,
          column: 8
        },
        end: {
          line: 840,
          column: 43
        }
      },
      '323': {
        start: {
          line: 841,
          column: 8
        },
        end: {
          line: 841,
          column: 15
        }
      },
      '324': {
        start: {
          line: 844,
          column: 6
        },
        end: {
          line: 848,
          column: 7
        }
      },
      '325': {
        start: {
          line: 845,
          column: 8
        },
        end: {
          line: 845,
          column: 36
        }
      },
      '326': {
        start: {
          line: 846,
          column: 8
        },
        end: {
          line: 846,
          column: 43
        }
      },
      '327': {
        start: {
          line: 847,
          column: 8
        },
        end: {
          line: 847,
          column: 15
        }
      },
      '328': {
        start: {
          line: 851,
          column: 18
        },
        end: {
          line: 854,
          column: 8
        }
      },
      '329': {
        start: {
          line: 852,
          column: 8
        },
        end: {
          line: 853,
          column: 90
        }
      },
      '330': {
        start: {
          line: 856,
          column: 6
        },
        end: {
          line: 860,
          column: 7
        }
      },
      '331': {
        start: {
          line: 857,
          column: 8
        },
        end: {
          line: 857,
          column: 32
        }
      },
      '332': {
        start: {
          line: 858,
          column: 8
        },
        end: {
          line: 858,
          column: 43
        }
      },
      '333': {
        start: {
          line: 859,
          column: 8
        },
        end: {
          line: 859,
          column: 15
        }
      },
      '334': {
        start: {
          line: 863,
          column: 6
        },
        end: {
          line: 867,
          column: 7
        }
      },
      '335': {
        start: {
          line: 864,
          column: 8
        },
        end: {
          line: 864,
          column: 30
        }
      },
      '336': {
        start: {
          line: 865,
          column: 8
        },
        end: {
          line: 865,
          column: 43
        }
      },
      '337': {
        start: {
          line: 866,
          column: 8
        },
        end: {
          line: 866,
          column: 15
        }
      },
      '338': {
        start: {
          line: 868,
          column: 6
        },
        end: {
          line: 872,
          column: 7
        }
      },
      '339': {
        start: {
          line: 869,
          column: 8
        },
        end: {
          line: 869,
          column: 31
        }
      },
      '340': {
        start: {
          line: 870,
          column: 8
        },
        end: {
          line: 870,
          column: 43
        }
      },
      '341': {
        start: {
          line: 871,
          column: 8
        },
        end: {
          line: 871,
          column: 15
        }
      },
      '342': {
        start: {
          line: 873,
          column: 19
        },
        end: {
          line: 873,
          column: 63
        }
      },
      '343': {
        start: {
          line: 874,
          column: 6
        },
        end: {
          line: 874,
          column: 70
        }
      },
      '344': {
        start: {
          line: 876,
          column: 6
        },
        end: {
          line: 876,
          column: 25
        }
      },
      '345': {
        start: {
          line: 877,
          column: 6
        },
        end: {
          line: 877,
          column: 41
        }
      },
      '346': {
        start: {
          line: 878,
          column: 6
        },
        end: {
          line: 880,
          column: 7
        }
      },
      '347': {
        start: {
          line: 879,
          column: 8
        },
        end: {
          line: 879,
          column: 27
        }
      },
      '348': {
        start: {
          line: 881,
          column: 6
        },
        end: {
          line: 885,
          column: 7
        }
      },
      '349': {
        start: {
          line: 882,
          column: 8
        },
        end: {
          line: 882,
          column: 43
        }
      },
      '350': {
        start: {
          line: 884,
          column: 8
        },
        end: {
          line: 884,
          column: 27
        }
      },
      '351': {
        start: {
          line: 886,
          column: 6
        },
        end: {
          line: 888,
          column: 7
        }
      },
      '352': {
        start: {
          line: 887,
          column: 8
        },
        end: {
          line: 887,
          column: 27
        }
      },
      '353': {
        start: {
          line: 890,
          column: 6
        },
        end: {
          line: 892,
          column: 7
        }
      },
      '354': {
        start: {
          line: 891,
          column: 8
        },
        end: {
          line: 891,
          column: 77
        }
      },
      '355': {
        start: {
          line: 893,
          column: 6
        },
        end: {
          line: 908,
          column: 7
        }
      },
      '356': {
        start: {
          line: 894,
          column: 8
        },
        end: {
          line: 907,
          column: 9
        }
      },
      '357': {
        start: {
          line: 895,
          column: 10
        },
        end: {
          line: 906,
          column: 11
        }
      },
      '358': {
        start: {
          line: 896,
          column: 12
        },
        end: {
          line: 898,
          column: 13
        }
      },
      '359': {
        start: {
          line: 897,
          column: 14
        },
        end: {
          line: 897,
          column: 23
        }
      },
      '360': {
        start: {
          line: 899,
          column: 12
        },
        end: {
          line: 901,
          column: 13
        }
      },
      '361': {
        start: {
          line: 900,
          column: 14
        },
        end: {
          line: 900,
          column: 23
        }
      },
      '362': {
        start: {
          line: 902,
          column: 12
        },
        end: {
          line: 904,
          column: 13
        }
      },
      '363': {
        start: {
          line: 903,
          column: 14
        },
        end: {
          line: 903,
          column: 23
        }
      },
      '364': {
        start: {
          line: 905,
          column: 12
        },
        end: {
          line: 905,
          column: 59
        }
      },
      '365': {
        start: {
          line: 910,
          column: 6
        },
        end: {
          line: 910,
          column: 50
        }
      },
      '366': {
        start: {
          line: 911,
          column: 6
        },
        end: {
          line: 911,
          column: 62
        }
      },
      '367': {
        start: {
          line: 913,
          column: 6
        },
        end: {
          line: 920,
          column: 9
        }
      },
      '368': {
        start: {
          line: 914,
          column: 8
        },
        end: {
          line: 914,
          column: 40
        }
      },
      '369': {
        start: {
          line: 915,
          column: 8
        },
        end: {
          line: 918,
          column: 9
        }
      },
      '370': {
        start: {
          line: 916,
          column: 10
        },
        end: {
          line: 916,
          column: 45
        }
      },
      '371': {
        start: {
          line: 917,
          column: 10
        },
        end: {
          line: 917,
          column: 17
        }
      },
      '372': {
        start: {
          line: 919,
          column: 8
        },
        end: {
          line: 919,
          column: 36
        }
      },
      '373': {
        start: {
          line: 923,
          column: 6
        },
        end: {
          line: 951,
          column: 9
        }
      },
      '374': {
        start: {
          line: 935,
          column: 8
        },
        end: {
          line: 937,
          column: 9
        }
      },
      '375': {
        start: {
          line: 936,
          column: 10
        },
        end: {
          line: 936,
          column: 17
        }
      },
      '376': {
        start: {
          line: 938,
          column: 8
        },
        end: {
          line: 938,
          column: 32
        }
      },
      '377': {
        start: {
          line: 939,
          column: 8
        },
        end: {
          line: 950,
          column: 11
        }
      },
      '378': {
        start: {
          line: 940,
          column: 10
        },
        end: {
          line: 947,
          column: 11
        }
      },
      '379': {
        start: {
          line: 941,
          column: 12
        },
        end: {
          line: 944,
          column: 15
        }
      },
      '380': {
        start: {
          line: 945,
          column: 12
        },
        end: {
          line: 945,
          column: 37
        }
      },
      '381': {
        start: {
          line: 946,
          column: 12
        },
        end: {
          line: 946,
          column: 19
        }
      },
      '382': {
        start: {
          line: 948,
          column: 10
        },
        end: {
          line: 948,
          column: 48
        }
      },
      '383': {
        start: {
          line: 949,
          column: 10
        },
        end: {
          line: 949,
          column: 38
        }
      },
      '384': {
        start: {
          line: 955,
          column: 6
        },
        end: {
          line: 955,
          column: 31
        }
      },
      '385': {
        start: {
          line: 957,
          column: 6
        },
        end: {
          line: 957,
          column: 30
        }
      },
      '386': {
        start: {
          line: 958,
          column: 6
        },
        end: {
          line: 971,
          column: 7
        }
      },
      '387': {
        start: {
          line: 959,
          column: 8
        },
        end: {
          line: 961,
          column: 9
        }
      },
      '388': {
        start: {
          line: 960,
          column: 10
        },
        end: {
          line: 960,
          column: 19
        }
      },
      '389': {
        start: {
          line: 962,
          column: 25
        },
        end: {
          line: 962,
          column: 30
        }
      },
      '390': {
        start: {
          line: 963,
          column: 8
        },
        end: {
          line: 965,
          column: 9
        }
      },
      '391': {
        start: {
          line: 964,
          column: 10
        },
        end: {
          line: 964,
          column: 83
        }
      },
      '392': {
        start: {
          line: 966,
          column: 8
        },
        end: {
          line: 970,
          column: 11
        }
      },
      '393': {
        start: {
          line: 972,
          column: 6
        },
        end: {
          line: 972,
          column: 22
        }
      },
      '394': {
        start: {
          line: 975,
          column: 6
        },
        end: {
          line: 975,
          column: 30
        }
      },
      '395': {
        start: {
          line: 976,
          column: 6
        },
        end: {
          line: 976,
          column: 22
        }
      },
      '396': {
        start: {
          line: 979,
          column: 20
        },
        end: {
          line: 979,
          column: 22
        }
      },
      '397': {
        start: {
          line: 980,
          column: 6
        },
        end: {
          line: 984,
          column: 7
        }
      },
      '398': {
        start: {
          line: 981,
          column: 8
        },
        end: {
          line: 983,
          column: 9
        }
      },
      '399': {
        start: {
          line: 982,
          column: 10
        },
        end: {
          line: 982,
          column: 28
        }
      },
      '400': {
        start: {
          line: 986,
          column: 6
        },
        end: {
          line: 986,
          column: 57
        }
      },
      '401': {
        start: {
          line: 987,
          column: 6
        },
        end: {
          line: 989,
          column: 9
        }
      },
      '402': {
        start: {
          line: 988,
          column: 8
        },
        end: {
          line: 988,
          column: 40
        }
      },
      '403': {
        start: {
          line: 993,
          column: 2
        },
        end: {
          line: 1069,
          column: 4
        }
      },
      '404': {
        start: {
          line: 1003,
          column: 6
        },
        end: {
          line: 1007,
          column: 7
        }
      },
      '405': {
        start: {
          line: 1004,
          column: 8
        },
        end: {
          line: 1006,
          column: 9
        }
      },
      '406': {
        start: {
          line: 1005,
          column: 10
        },
        end: {
          line: 1005,
          column: 22
        }
      },
      '407': {
        start: {
          line: 1008,
          column: 6
        },
        end: {
          line: 1010,
          column: 7
        }
      },
      '408': {
        start: {
          line: 1009,
          column: 8
        },
        end: {
          line: 1009,
          column: 20
        }
      },
      '409': {
        start: {
          line: 1011,
          column: 6
        },
        end: {
          line: 1015,
          column: 7
        }
      },
      '410': {
        start: {
          line: 1012,
          column: 8
        },
        end: {
          line: 1014,
          column: 9
        }
      },
      '411': {
        start: {
          line: 1013,
          column: 10
        },
        end: {
          line: 1013,
          column: 23
        }
      },
      '412': {
        start: {
          line: 1016,
          column: 6
        },
        end: {
          line: 1016,
          column: 18
        }
      },
      '413': {
        start: {
          line: 1019,
          column: 19
        },
        end: {
          line: 1019,
          column: 21
        }
      },
      '414': {
        start: {
          line: 1020,
          column: 6
        },
        end: {
          line: 1026,
          column: 7
        }
      },
      '415': {
        start: {
          line: 1021,
          column: 8
        },
        end: {
          line: 1025,
          column: 11
        }
      },
      '416': {
        start: {
          line: 1027,
          column: 6
        },
        end: {
          line: 1029,
          column: 7
        }
      },
      '417': {
        start: {
          line: 1028,
          column: 8
        },
        end: {
          line: 1028,
          column: 15
        }
      },
      '418': {
        start: {
          line: 1030,
          column: 6
        },
        end: {
          line: 1030,
          column: 25
        }
      },
      '419': {
        start: {
          line: 1031,
          column: 6
        },
        end: {
          line: 1031,
          column: 30
        }
      },
      '420': {
        start: {
          line: 1032,
          column: 6
        },
        end: {
          line: 1034,
          column: 9
        }
      },
      '421': {
        start: {
          line: 1033,
          column: 8
        },
        end: {
          line: 1033,
          column: 33
        }
      },
      '422': {
        start: {
          line: 1035,
          column: 6
        },
        end: {
          line: 1035,
          column: 20
        }
      },
      '423': {
        start: {
          line: 1038,
          column: 6
        },
        end: {
          line: 1038,
          column: 26
        }
      },
      '424': {
        start: {
          line: 1039,
          column: 6
        },
        end: {
          line: 1039,
          column: 25
        }
      },
      '425': {
        start: {
          line: 1040,
          column: 6
        },
        end: {
          line: 1042,
          column: 7
        }
      },
      '426': {
        start: {
          line: 1041,
          column: 8
        },
        end: {
          line: 1041,
          column: 36
        }
      },
      '427': {
        start: {
          line: 1043,
          column: 6
        },
        end: {
          line: 1043,
          column: 22
        }
      },
      '428': {
        start: {
          line: 1046,
          column: 6
        },
        end: {
          line: 1048,
          column: 7
        }
      },
      '429': {
        start: {
          line: 1047,
          column: 8
        },
        end: {
          line: 1047,
          column: 20
        }
      },
      '430': {
        start: {
          line: 1049,
          column: 6
        },
        end: {
          line: 1051,
          column: 7
        }
      },
      '431': {
        start: {
          line: 1050,
          column: 8
        },
        end: {
          line: 1050,
          column: 21
        }
      },
      '432': {
        start: {
          line: 1052,
          column: 6
        },
        end: {
          line: 1052,
          column: 18
        }
      },
      '433': {
        start: {
          line: 1055,
          column: 6
        },
        end: {
          line: 1055,
          column: 26
        }
      },
      '434': {
        start: {
          line: 1056,
          column: 6
        },
        end: {
          line: 1056,
          column: 90
        }
      },
      '435': {
        start: {
          line: 1057,
          column: 6
        },
        end: {
          line: 1057,
          column: 25
        }
      },
      '436': {
        start: {
          line: 1058,
          column: 6
        },
        end: {
          line: 1066,
          column: 7
        }
      },
      '437': {
        start: {
          line: 1059,
          column: 19
        },
        end: {
          line: 1059,
          column: 34
        }
      },
      '438': {
        start: {
          line: 1060,
          column: 21
        },
        end: {
          line: 1060,
          column: 96
        }
      },
      '439': {
        start: {
          line: 1061,
          column: 8
        },
        end: {
          line: 1063,
          column: 9
        }
      },
      '440': {
        start: {
          line: 1062,
          column: 10
        },
        end: {
          line: 1062,
          column: 87
        }
      },
      '441': {
        start: {
          line: 1064,
          column: 8
        },
        end: {
          line: 1064,
          column: 30
        }
      },
      '442': {
        start: {
          line: 1065,
          column: 8
        },
        end: {
          line: 1065,
          column: 31
        }
      },
      '443': {
        start: {
          line: 1067,
          column: 6
        },
        end: {
          line: 1067,
          column: 22
        }
      },
      '444': {
        start: {
          line: 1072,
          column: 19
        },
        end: {
          line: 1077,
          column: 4
        }
      },
      '445': {
        start: {
          line: 1078,
          column: 2
        },
        end: {
          line: 1081,
          column: 4
        }
      },
      '446': {
        start: {
          line: 1079,
          column: 4
        },
        end: {
          line: 1079,
          column: 42
        }
      },
      '447': {
        start: {
          line: 1080,
          column: 4
        },
        end: {
          line: 1080,
          column: 22
        }
      },
      '448': {
        start: {
          line: 1082,
          column: 2
        },
        end: {
          line: 1088,
          column: 4
        }
      },
      '449': {
        start: {
          line: 1083,
          column: 4
        },
        end: {
          line: 1085,
          column: 5
        }
      },
      '450': {
        start: {
          line: 1084,
          column: 6
        },
        end: {
          line: 1084,
          column: 83
        }
      },
      '451': {
        start: {
          line: 1087,
          column: 4
        },
        end: {
          line: 1087,
          column: 43
        }
      },
      '452': {
        start: {
          line: 1089,
          column: 2
        },
        end: {
          line: 1091,
          column: 4
        }
      },
      '453': {
        start: {
          line: 1090,
          column: 4
        },
        end: {
          line: 1090,
          column: 43
        }
      },
      '454': {
        start: {
          line: 1093,
          column: 2
        },
        end: {
          line: 1102,
          column: 5
        }
      },
      '455': {
        start: {
          line: 1094,
          column: 4
        },
        end: {
          line: 1094,
          column: 27
        }
      },
      '456': {
        start: {
          line: 1095,
          column: 4
        },
        end: {
          line: 1095,
          column: 89
        }
      },
      '457': {
        start: {
          line: 1095,
          column: 48
        },
        end: {
          line: 1095,
          column: 86
        }
      },
      '458': {
        start: {
          line: 1096,
          column: 4
        },
        end: {
          line: 1096,
          column: 81
        }
      },
      '459': {
        start: {
          line: 1097,
          column: 4
        },
        end: {
          line: 1097,
          column: 47
        }
      },
      '460': {
        start: {
          line: 1099,
          column: 4
        },
        end: {
          line: 1099,
          column: 79
        }
      },
      '461': {
        start: {
          line: 1101,
          column: 4
        },
        end: {
          line: 1101,
          column: 32
        }
      },
      '462': {
        start: {
          line: 1106,
          column: 2
        },
        end: {
          line: 1119,
          column: 5
        }
      },
      '463': {
        start: {
          line: 1107,
          column: 22
        },
        end: {
          line: 1109,
          column: 6
        }
      },
      '464': {
        start: {
          line: 1108,
          column: 6
        },
        end: {
          line: 1108,
          column: 36
        }
      },
      '465': {
        start: {
          line: 1111,
          column: 4
        },
        end: {
          line: 1113,
          column: 5
        }
      },
      '466': {
        start: {
          line: 1115,
          column: 4
        },
        end: {
          line: 1115,
          column: 43
        }
      },
      '467': {
        start: {
          line: 1117,
          column: 4
        },
        end: {
          line: 1117,
          column: 75
        }
      },
      '468': {
        start: {
          line: 1117,
          column: 55
        },
        end: {
          line: 1117,
          column: 72
        }
      },
      '469': {
        start: {
          line: 1118,
          column: 4
        },
        end: {
          line: 1118,
          column: 73
        }
      },
      '470': {
        start: {
          line: 1118,
          column: 53
        },
        end: {
          line: 1118,
          column: 70
        }
      },
      '471': {
        start: {
          line: 1121,
          column: 2
        },
        end: {
          line: 1186,
          column: 5
        }
      },
      '472': {
        start: {
          line: 1122,
          column: 4
        },
        end: {
          line: 1160,
          column: 11
        }
      },
      '473': {
        start: {
          line: 1123,
          column: 16
        },
        end: {
          line: 1123,
          column: 30
        }
      },
      '474': {
        start: {
          line: 1125,
          column: 6
        },
        end: {
          line: 1153,
          column: 7
        }
      },
      '475': {
        start: {
          line: 1127,
          column: 10
        },
        end: {
          line: 1127,
          column: 60
        }
      },
      '476': {
        start: {
          line: 1128,
          column: 10
        },
        end: {
          line: 1128,
          column: 16
        }
      },
      '477': {
        start: {
          line: 1130,
          column: 10
        },
        end: {
          line: 1130,
          column: 56
        }
      },
      '478': {
        start: {
          line: 1131,
          column: 10
        },
        end: {
          line: 1131,
          column: 16
        }
      },
      '479': {
        start: {
          line: 1133,
          column: 10
        },
        end: {
          line: 1133,
          column: 56
        }
      },
      '480': {
        start: {
          line: 1134,
          column: 10
        },
        end: {
          line: 1134,
          column: 16
        }
      },
      '481': {
        start: {
          line: 1136,
          column: 10
        },
        end: {
          line: 1136,
          column: 23
        }
      },
      '482': {
        start: {
          line: 1137,
          column: 10
        },
        end: {
          line: 1137,
          column: 16
        }
      },
      '483': {
        start: {
          line: 1139,
          column: 10
        },
        end: {
          line: 1139,
          column: 59
        }
      },
      '484': {
        start: {
          line: 1140,
          column: 10
        },
        end: {
          line: 1140,
          column: 16
        }
      },
      '485': {
        start: {
          line: 1142,
          column: 10
        },
        end: {
          line: 1142,
          column: 57
        }
      },
      '486': {
        start: {
          line: 1143,
          column: 10
        },
        end: {
          line: 1143,
          column: 16
        }
      },
      '487': {
        start: {
          line: 1145,
          column: 10
        },
        end: {
          line: 1145,
          column: 56
        }
      },
      '488': {
        start: {
          line: 1146,
          column: 10
        },
        end: {
          line: 1146,
          column: 16
        }
      },
      '489': {
        start: {
          line: 1148,
          column: 10
        },
        end: {
          line: 1148,
          column: 65
        }
      },
      '490': {
        start: {
          line: 1149,
          column: 10
        },
        end: {
          line: 1149,
          column: 16
        }
      },
      '491': {
        start: {
          line: 1152,
          column: 10
        },
        end: {
          line: 1152,
          column: 39
        }
      },
      '492': {
        start: {
          line: 1154,
          column: 6
        },
        end: {
          line: 1154,
          column: 33
        }
      },
      '493': {
        start: {
          line: 1155,
          column: 6
        },
        end: {
          line: 1155,
          column: 15
        }
      },
      '494': {
        start: {
          line: 1162,
          column: 4
        },
        end: {
          line: 1164,
          column: 7
        }
      },
      '495': {
        start: {
          line: 1163,
          column: 6
        },
        end: {
          line: 1163,
          column: 25
        }
      },
      '496': {
        start: {
          line: 1166,
          column: 4
        },
        end: {
          line: 1170,
          column: 7
        }
      },
      '497': {
        start: {
          line: 1172,
          column: 4
        },
        end: {
          line: 1176,
          column: 7
        }
      },
      '498': {
        start: {
          line: 1179,
          column: 4
        },
        end: {
          line: 1183,
          column: 6
        }
      },
      '499': {
        start: {
          line: 1190,
          column: 15
        },
        end: {
          line: 1190,
          column: 21
        }
      },
      '500': {
        start: {
          line: 1191,
          column: 19
        },
        end: {
          line: 1191,
          column: 67
        }
      },
      '501': {
        start: {
          line: 1192,
          column: 2
        },
        end: {
          line: 1192,
          column: 34
        }
      },
      '502': {
        start: {
          line: 1194,
          column: 2
        },
        end: {
          line: 1194,
          column: 30
        }
      },
      '503': {
        start: {
          line: 1195,
          column: 2
        },
        end: {
          line: 1195,
          column: 30
        }
      },
      '504': {
        start: {
          line: 1196,
          column: 2
        },
        end: {
          line: 1198,
          column: 4
        }
      },
      '505': {
        start: {
          line: 1199,
          column: 2
        },
        end: {
          line: 1209,
          column: 5
        }
      },
      '506': {
        start: {
          line: 1200,
          column: 19
        },
        end: {
          line: 1200,
          column: 21
        }
      },
      '507': {
        start: {
          line: 1201,
          column: 4
        },
        end: {
          line: 1206,
          column: 5
        }
      },
      '508': {
        start: {
          line: 1202,
          column: 6
        },
        end: {
          line: 1205,
          column: 8
        }
      },
      '509': {
        start: {
          line: 1207,
          column: 4
        },
        end: {
          line: 1207,
          column: 35
        }
      },
      '510': {
        start: {
          line: 1208,
          column: 4
        },
        end: {
          line: 1208,
          column: 37
        }
      },
      '511': {
        start: {
          line: 1210,
          column: 2
        },
        end: {
          line: 1228,
          column: 4
        }
      },
      '512': {
        start: {
          line: 1211,
          column: 19
        },
        end: {
          line: 1211,
          column: 21
        }
      },
      '513': {
        start: {
          line: 1212,
          column: 4
        },
        end: {
          line: 1222,
          column: 5
        }
      },
      '514': {
        start: {
          line: 1213,
          column: 18
        },
        end: {
          line: 1213,
          column: 97
        }
      },
      '515': {
        start: {
          line: 1214,
          column: 6
        },
        end: {
          line: 1216,
          column: 7
        }
      },
      '516': {
        start: {
          line: 1215,
          column: 8
        },
        end: {
          line: 1215,
          column: 17
        }
      },
      '517': {
        start: {
          line: 1217,
          column: 6
        },
        end: {
          line: 1221,
          column: 9
        }
      },
      '518': {
        start: {
          line: 1223,
          column: 4
        },
        end: {
          line: 1223,
          column: 36
        }
      },
      '519': {
        start: {
          line: 1224,
          column: 4
        },
        end: {
          line: 1227,
          column: 7
        }
      },
      '520': {
        start: {
          line: 1225,
          column: 6
        },
        end: {
          line: 1225,
          column: 39
        }
      },
      '521': {
        start: {
          line: 1226,
          column: 6
        },
        end: {
          line: 1226,
          column: 26
        }
      },
      '522': {
        start: {
          line: 1229,
          column: 2
        },
        end: {
          line: 1261,
          column: 4
        }
      },
      '523': {
        start: {
          line: 1233,
          column: 6
        },
        end: {
          line: 1239,
          column: 7
        }
      },
      '524': {
        start: {
          line: 1234,
          column: 8
        },
        end: {
          line: 1238,
          column: 9
        }
      },
      '525': {
        start: {
          line: 1235,
          column: 10
        },
        end: {
          line: 1235,
          column: 37
        }
      },
      '526': {
        start: {
          line: 1237,
          column: 10
        },
        end: {
          line: 1237,
          column: 37
        }
      },
      '527': {
        start: {
          line: 1242,
          column: 16
        },
        end: {
          line: 1242,
          column: 19
        }
      },
      '528': {
        start: {
          line: 1243,
          column: 18
        },
        end: {
          line: 1243,
          column: 36
        }
      },
      '529': {
        start: {
          line: 1244,
          column: 6
        },
        end: {
          line: 1247,
          column: 7
        }
      },
      '530': {
        start: {
          line: 1245,
          column: 8
        },
        end: {
          line: 1245,
          column: 18
        }
      },
      '531': {
        start: {
          line: 1246,
          column: 8
        },
        end: {
          line: 1246,
          column: 35
        }
      },
      '532': {
        start: {
          line: 1248,
          column: 6
        },
        end: {
          line: 1259,
          column: 7
        }
      },
      '533': {
        start: {
          line: 1249,
          column: 8
        },
        end: {
          line: 1251,
          column: 9
        }
      },
      '534': {
        start: {
          line: 1250,
          column: 10
        },
        end: {
          line: 1250,
          column: 19
        }
      },
      '535': {
        start: {
          line: 1252,
          column: 8
        },
        end: {
          line: 1257,
          column: 9
        }
      },
      '536': {
        start: {
          line: 1253,
          column: 10
        },
        end: {
          line: 1256,
          column: 12
        }
      },
      '537': {
        start: {
          line: 1258,
          column: 8
        },
        end: {
          line: 1258,
          column: 50
        }
      },
      '538': {
        start: {
          line: 1263,
          column: 2
        },
        end: {
          line: 1265,
          column: 4
        }
      },
      '539': {
        start: {
          line: 1264,
          column: 4
        },
        end: {
          line: 1264,
          column: 40
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 5,
            column: 45
          },
          end: {
            line: 5,
            column: 46
          }
        },
        loc: {
          start: {
            line: 5,
            column: 197
          },
          end: {
            line: 1187,
            column: 1
          }
        },
        line: 5
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 44,
            column: 22
          },
          end: {
            line: 44,
            column: 23
          }
        },
        loc: {
          start: {
            line: 44,
            column: 33
          },
          end: {
            line: 59,
            column: 5
          }
        },
        line: 44
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 64,
            column: 20
          },
          end: {
            line: 64,
            column: 21
          }
        },
        loc: {
          start: {
            line: 64,
            column: 31
          },
          end: {
            line: 82,
            column: 5
          }
        },
        line: 64
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 75,
            column: 28
          },
          end: {
            line: 75,
            column: 29
          }
        },
        loc: {
          start: {
            line: 75,
            column: 43
          },
          end: {
            line: 80,
            column: 7
          }
        },
        line: 75
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 87,
            column: 22
          },
          end: {
            line: 87,
            column: 23
          }
        },
        loc: {
          start: {
            line: 87,
            column: 33
          },
          end: {
            line: 90,
            column: 5
          }
        },
        line: 87
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 95,
            column: 23
          },
          end: {
            line: 95,
            column: 24
          }
        },
        loc: {
          start: {
            line: 95,
            column: 34
          },
          end: {
            line: 115,
            column: 5
          }
        },
        line: 95
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 102,
            column: 35
          },
          end: {
            line: 102,
            column: 36
          }
        },
        loc: {
          start: {
            line: 102,
            column: 55
          },
          end: {
            line: 105,
            column: 9
          }
        },
        line: 102
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 109,
            column: 33
          },
          end: {
            line: 109,
            column: 34
          }
        },
        loc: {
          start: {
            line: 109,
            column: 51
          },
          end: {
            line: 112,
            column: 9
          }
        },
        line: 109
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 120,
            column: 25
          },
          end: {
            line: 120,
            column: 26
          }
        },
        loc: {
          start: {
            line: 120,
            column: 36
          },
          end: {
            line: 123,
            column: 5
          }
        },
        line: 120
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 128,
            column: 20
          },
          end: {
            line: 128,
            column: 21
          }
        },
        loc: {
          start: {
            line: 128,
            column: 31
          },
          end: {
            line: 135,
            column: 5
          }
        },
        line: 128
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 140,
            column: 23
          },
          end: {
            line: 140,
            column: 24
          }
        },
        loc: {
          start: {
            line: 140,
            column: 34
          },
          end: {
            line: 147,
            column: 5
          }
        },
        line: 140
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 152,
            column: 27
          },
          end: {
            line: 152,
            column: 28
          }
        },
        loc: {
          start: {
            line: 152,
            column: 38
          },
          end: {
            line: 157,
            column: 5
          }
        },
        line: 152
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 154,
            column: 67
          },
          end: {
            line: 154,
            column: 68
          }
        },
        loc: {
          start: {
            line: 154,
            column: 81
          },
          end: {
            line: 156,
            column: 7
          }
        },
        line: 154
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 162,
            column: 30
          },
          end: {
            line: 162,
            column: 31
          }
        },
        loc: {
          start: {
            line: 162,
            column: 41
          },
          end: {
            line: 167,
            column: 5
          }
        },
        line: 162
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 164,
            column: 70
          },
          end: {
            line: 164,
            column: 71
          }
        },
        loc: {
          start: {
            line: 164,
            column: 84
          },
          end: {
            line: 166,
            column: 7
          }
        },
        line: 164
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 172,
            column: 14
          },
          end: {
            line: 172,
            column: 15
          }
        },
        loc: {
          start: {
            line: 172,
            column: 25
          },
          end: {
            line: 182,
            column: 5
          }
        },
        line: 172
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 187,
            column: 25
          },
          end: {
            line: 187,
            column: 26
          }
        },
        loc: {
          start: {
            line: 187,
            column: 36
          },
          end: {
            line: 229,
            column: 5
          }
        },
        line: 187
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 197,
            column: 16
          },
          end: {
            line: 197,
            column: 17
          }
        },
        loc: {
          start: {
            line: 197,
            column: 30
          },
          end: {
            line: 197,
            column: 89
          }
        },
        line: 197
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 198,
            column: 14
          }
        },
        loc: {
          start: {
            line: 198,
            column: 26
          },
          end: {
            line: 198,
            column: 50
          }
        },
        line: 198
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 203,
            column: 18
          },
          end: {
            line: 203,
            column: 19
          }
        },
        loc: {
          start: {
            line: 203,
            column: 32
          },
          end: {
            line: 203,
            column: 94
          }
        },
        line: 203
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 204,
            column: 15
          },
          end: {
            line: 204,
            column: 16
          }
        },
        loc: {
          start: {
            line: 204,
            column: 28
          },
          end: {
            line: 204,
            column: 52
          }
        },
        line: 204
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 224,
            column: 9
          },
          end: {
            line: 224,
            column: 10
          }
        },
        loc: {
          start: {
            line: 224,
            column: 29
          },
          end: {
            line: 228,
            column: 7
          }
        },
        line: 224
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 234,
            column: 27
          },
          end: {
            line: 234,
            column: 28
          }
        },
        loc: {
          start: {
            line: 234,
            column: 68
          },
          end: {
            line: 300,
            column: 5
          }
        },
        line: 234
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 246,
            column: 9
          },
          end: {
            line: 246,
            column: 10
          }
        },
        loc: {
          start: {
            line: 246,
            column: 28
          },
          end: {
            line: 291,
            column: 7
          }
        },
        line: 246
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 261,
            column: 13
          },
          end: {
            line: 261,
            column: 14
          }
        },
        loc: {
          start: {
            line: 261,
            column: 33
          },
          end: {
            line: 267,
            column: 11
          }
        },
        line: 261
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 291,
            column: 9
          },
          end: {
            line: 291,
            column: 10
          }
        },
        loc: {
          start: {
            line: 291,
            column: 25
          },
          end: {
            line: 299,
            column: 7
          }
        },
        line: 291
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 346,
            column: 81
          },
          end: {
            line: 346,
            column: 82
          }
        },
        loc: {
          start: {
            line: 346,
            column: 90
          },
          end: {
            line: 351,
            column: 9
          }
        },
        line: 346
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 359,
            column: 53
          },
          end: {
            line: 359,
            column: 54
          }
        },
        loc: {
          start: {
            line: 359,
            column: 61
          },
          end: {
            line: 365,
            column: 7
          }
        },
        line: 359
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 360,
            column: 44
          },
          end: {
            line: 360,
            column: 45
          }
        },
        loc: {
          start: {
            line: 360,
            column: 54
          },
          end: {
            line: 364,
            column: 9
          }
        },
        line: 360
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 377,
            column: 57
          },
          end: {
            line: 377,
            column: 58
          }
        },
        loc: {
          start: {
            line: 377,
            column: 66
          },
          end: {
            line: 377,
            column: 71
          }
        },
        line: 377
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 383,
            column: 51
          },
          end: {
            line: 383,
            column: 52
          }
        },
        loc: {
          start: {
            line: 383,
            column: 59
          },
          end: {
            line: 389,
            column: 7
          }
        },
        line: 383
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 384,
            column: 44
          },
          end: {
            line: 384,
            column: 45
          }
        },
        loc: {
          start: {
            line: 384,
            column: 54
          },
          end: {
            line: 388,
            column: 9
          }
        },
        line: 384
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 396,
            column: 48
          },
          end: {
            line: 396,
            column: 49
          }
        },
        loc: {
          start: {
            line: 396,
            column: 57
          },
          end: {
            line: 396,
            column: 62
          }
        },
        line: 396
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 404,
            column: 87
          },
          end: {
            line: 404,
            column: 88
          }
        },
        loc: {
          start: {
            line: 404,
            column: 96
          },
          end: {
            line: 409,
            column: 9
          }
        },
        line: 404
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 424,
            column: 48
          },
          end: {
            line: 424,
            column: 49
          }
        },
        loc: {
          start: {
            line: 424,
            column: 57
          },
          end: {
            line: 424,
            column: 65
          }
        },
        line: 424
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 432,
            column: 63
          },
          end: {
            line: 432,
            column: 64
          }
        },
        loc: {
          start: {
            line: 432,
            column: 72
          },
          end: {
            line: 437,
            column: 9
          }
        },
        line: 432
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 479,
            column: 71
          },
          end: {
            line: 479,
            column: 72
          }
        },
        loc: {
          start: {
            line: 479,
            column: 78
          },
          end: {
            line: 481,
            column: 7
          }
        },
        line: 479
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 671,
            column: 50
          },
          end: {
            line: 671,
            column: 51
          }
        },
        loc: {
          start: {
            line: 671,
            column: 58
          },
          end: {
            line: 673,
            column: 7
          }
        },
        line: 671
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 680,
            column: 72
          },
          end: {
            line: 680,
            column: 73
          }
        },
        loc: {
          start: {
            line: 680,
            column: 79
          },
          end: {
            line: 682,
            column: 7
          }
        },
        line: 680
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 684,
            column: 71
          },
          end: {
            line: 684,
            column: 72
          }
        },
        loc: {
          start: {
            line: 684,
            column: 78
          },
          end: {
            line: 686,
            column: 7
          }
        },
        line: 684
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 687,
            column: 178
          },
          end: {
            line: 687,
            column: 179
          }
        },
        loc: {
          start: {
            line: 687,
            column: 186
          },
          end: {
            line: 698,
            column: 7
          }
        },
        line: 687
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 693,
            column: 102
          },
          end: {
            line: 693,
            column: 103
          }
        },
        loc: {
          start: {
            line: 693,
            column: 110
          },
          end: {
            line: 695,
            column: 9
          }
        },
        line: 693
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 771,
            column: 62
          },
          end: {
            line: 771,
            column: 63
          }
        },
        loc: {
          start: {
            line: 771,
            column: 67
          },
          end: {
            line: 773,
            column: 7
          }
        },
        line: 771
      },
      '43': {
        name: '(anonymous_43)',
        decl: {
          start: {
            line: 779,
            column: 86
          },
          end: {
            line: 779,
            column: 87
          }
        },
        loc: {
          start: {
            line: 779,
            column: 94
          },
          end: {
            line: 786,
            column: 7
          }
        },
        line: 779
      },
      '44': {
        name: '(anonymous_44)',
        decl: {
          start: {
            line: 781,
            column: 67
          },
          end: {
            line: 781,
            column: 68
          }
        },
        loc: {
          start: {
            line: 781,
            column: 72
          },
          end: {
            line: 783,
            column: 11
          }
        },
        line: 781
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 851,
            column: 51
          },
          end: {
            line: 851,
            column: 52
          }
        },
        loc: {
          start: {
            line: 851,
            column: 60
          },
          end: {
            line: 854,
            column: 7
          }
        },
        line: 851
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 913,
            column: 89
          },
          end: {
            line: 913,
            column: 90
          }
        },
        loc: {
          start: {
            line: 913,
            column: 97
          },
          end: {
            line: 920,
            column: 7
          }
        },
        line: 913
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 934,
            column: 9
          },
          end: {
            line: 934,
            column: 10
          }
        },
        loc: {
          start: {
            line: 934,
            column: 22
          },
          end: {
            line: 951,
            column: 7
          }
        },
        line: 934
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 939,
            column: 143
          },
          end: {
            line: 939,
            column: 144
          }
        },
        loc: {
          start: {
            line: 939,
            column: 151
          },
          end: {
            line: 950,
            column: 9
          }
        },
        line: 939
      },
      '49': {
        name: '(anonymous_49)',
        decl: {
          start: {
            line: 987,
            column: 122
          },
          end: {
            line: 987,
            column: 123
          }
        },
        loc: {
          start: {
            line: 987,
            column: 130
          },
          end: {
            line: 989,
            column: 7
          }
        },
        line: 987
      },
      '50': {
        name: '(anonymous_50)',
        decl: {
          start: {
            line: 1032,
            column: 82
          },
          end: {
            line: 1032,
            column: 83
          }
        },
        loc: {
          start: {
            line: 1032,
            column: 90
          },
          end: {
            line: 1034,
            column: 7
          }
        },
        line: 1032
      },
      '51': {
        name: '(anonymous_51)',
        decl: {
          start: {
            line: 1078,
            column: 31
          },
          end: {
            line: 1078,
            column: 32
          }
        },
        loc: {
          start: {
            line: 1078,
            column: 66
          },
          end: {
            line: 1081,
            column: 3
          }
        },
        line: 1078
      },
      '52': {
        name: '(anonymous_52)',
        decl: {
          start: {
            line: 1082,
            column: 27
          },
          end: {
            line: 1082,
            column: 28
          }
        },
        loc: {
          start: {
            line: 1082,
            column: 74
          },
          end: {
            line: 1088,
            column: 3
          }
        },
        line: 1082
      },
      '53': {
        name: '(anonymous_53)',
        decl: {
          start: {
            line: 1089,
            column: 25
          },
          end: {
            line: 1089,
            column: 26
          }
        },
        loc: {
          start: {
            line: 1089,
            column: 72
          },
          end: {
            line: 1091,
            column: 3
          }
        },
        line: 1089
      },
      '54': {
        name: '(anonymous_54)',
        decl: {
          start: {
            line: 1093,
            column: 55
          },
          end: {
            line: 1093,
            column: 56
          }
        },
        loc: {
          start: {
            line: 1093,
            column: 63
          },
          end: {
            line: 1102,
            column: 3
          }
        },
        line: 1093
      },
      '55': {
        name: '(anonymous_55)',
        decl: {
          start: {
            line: 1095,
            column: 38
          },
          end: {
            line: 1095,
            column: 39
          }
        },
        loc: {
          start: {
            line: 1095,
            column: 48
          },
          end: {
            line: 1095,
            column: 86
          }
        },
        line: 1095
      },
      '56': {
        name: '(anonymous_56)',
        decl: {
          start: {
            line: 1106,
            column: 66
          },
          end: {
            line: 1106,
            column: 67
          }
        },
        loc: {
          start: {
            line: 1106,
            column: 74
          },
          end: {
            line: 1119,
            column: 3
          }
        },
        line: 1106
      },
      '57': {
        name: '(anonymous_57)',
        decl: {
          start: {
            line: 1107,
            column: 37
          },
          end: {
            line: 1107,
            column: 38
          }
        },
        loc: {
          start: {
            line: 1107,
            column: 48
          },
          end: {
            line: 1109,
            column: 5
          }
        },
        line: 1107
      },
      '58': {
        name: '(anonymous_58)',
        decl: {
          start: {
            line: 1117,
            column: 48
          },
          end: {
            line: 1117,
            column: 49
          }
        },
        loc: {
          start: {
            line: 1117,
            column: 55
          },
          end: {
            line: 1117,
            column: 72
          }
        },
        line: 1117
      },
      '59': {
        name: '(anonymous_59)',
        decl: {
          start: {
            line: 1118,
            column: 46
          },
          end: {
            line: 1118,
            column: 47
          }
        },
        loc: {
          start: {
            line: 1118,
            column: 53
          },
          end: {
            line: 1118,
            column: 70
          }
        },
        line: 1118
      },
      '60': {
        name: '(anonymous_60)',
        decl: {
          start: {
            line: 1121,
            column: 57
          },
          end: {
            line: 1121,
            column: 58
          }
        },
        loc: {
          start: {
            line: 1121,
            column: 65
          },
          end: {
            line: 1186,
            column: 3
          }
        },
        line: 1121
      },
      '61': {
        name: '(anonymous_61)',
        decl: {
          start: {
            line: 1122,
            column: 59
          },
          end: {
            line: 1122,
            column: 60
          }
        },
        loc: {
          start: {
            line: 1122,
            column: 68
          },
          end: {
            line: 1156,
            column: 5
          }
        },
        line: 1122
      },
      '62': {
        name: '(anonymous_62)',
        decl: {
          start: {
            line: 1162,
            column: 92
          },
          end: {
            line: 1162,
            column: 93
          }
        },
        loc: {
          start: {
            line: 1162,
            column: 97
          },
          end: {
            line: 1164,
            column: 5
          }
        },
        line: 1162
      },
      '63': {
        name: 'UserValidationCtrl',
        decl: {
          start: {
            line: 1189,
            column: 9
          },
          end: {
            line: 1189,
            column: 27
          }
        },
        loc: {
          start: {
            line: 1189,
            column: 114
          },
          end: {
            line: 1267,
            column: 1
          }
        },
        line: 1189
      },
      '64': {
        name: '(anonymous_64)',
        decl: {
          start: {
            line: 1199,
            column: 87
          },
          end: {
            line: 1199,
            column: 88
          }
        },
        loc: {
          start: {
            line: 1199,
            column: 95
          },
          end: {
            line: 1209,
            column: 3
          }
        },
        line: 1199
      },
      '65': {
        name: '(anonymous_65)',
        decl: {
          start: {
            line: 1210,
            column: 20
          },
          end: {
            line: 1210,
            column: 21
          }
        },
        loc: {
          start: {
            line: 1210,
            column: 32
          },
          end: {
            line: 1228,
            column: 3
          }
        },
        line: 1210
      },
      '66': {
        name: '(anonymous_66)',
        decl: {
          start: {
            line: 1224,
            column: 128
          },
          end: {
            line: 1224,
            column: 129
          }
        },
        loc: {
          start: {
            line: 1224,
            column: 136
          },
          end: {
            line: 1227,
            column: 5
          }
        },
        line: 1224
      },
      '67': {
        name: '(anonymous_67)',
        decl: {
          start: {
            line: 1263,
            column: 22
          },
          end: {
            line: 1263,
            column: 23
          }
        },
        loc: {
          start: {
            line: 1263,
            column: 34
          },
          end: {
            line: 1265,
            column: 3
          }
        },
        line: 1263
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }, {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 71,
            column: 7
          }
        }],
        line: 68
      },
      '1': {
        loc: {
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 61
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 68,
            column: 10
          },
          end: {
            line: 68,
            column: 29
          }
        }, {
          start: {
            line: 68,
            column: 33
          },
          end: {
            line: 68,
            column: 61
          }
        }],
        line: 68
      },
      '2': {
        loc: {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        }],
        line: 76
      },
      '3': {
        loc: {
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 97,
            column: 38
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 97,
            column: 38
          }
        }, {
          start: {
            line: 97,
            column: 6
          },
          end: {
            line: 97,
            column: 38
          }
        }],
        line: 97
      },
      '4': {
        loc: {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 106,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 106,
            column: 7
          }
        }, {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 106,
            column: 7
          }
        }],
        line: 100
      },
      '5': {
        loc: {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }, {
          start: {
            line: 107,
            column: 6
          },
          end: {
            line: 113,
            column: 7
          }
        }],
        line: 107
      },
      '6': {
        loc: {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }, {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }],
        line: 130
      },
      '7': {
        loc: {
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 146,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 146,
            column: 7
          }
        }, {
          start: {
            line: 142,
            column: 6
          },
          end: {
            line: 146,
            column: 7
          }
        }],
        line: 142
      },
      '8': {
        loc: {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 153,
            column: 79
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 153,
            column: 79
          }
        }, {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 153,
            column: 79
          }
        }],
        line: 153
      },
      '9': {
        loc: {
          start: {
            line: 153,
            column: 10
          },
          end: {
            line: 153,
            column: 68
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 153,
            column: 10
          },
          end: {
            line: 153,
            column: 30
          }
        }, {
          start: {
            line: 153,
            column: 34
          },
          end: {
            line: 153,
            column: 68
          }
        }],
        line: 153
      },
      '10': {
        loc: {
          start: {
            line: 163,
            column: 6
          },
          end: {
            line: 163,
            column: 82
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 163,
            column: 6
          },
          end: {
            line: 163,
            column: 82
          }
        }, {
          start: {
            line: 163,
            column: 6
          },
          end: {
            line: 163,
            column: 82
          }
        }],
        line: 163
      },
      '11': {
        loc: {
          start: {
            line: 163,
            column: 10
          },
          end: {
            line: 163,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 163,
            column: 10
          },
          end: {
            line: 163,
            column: 30
          }
        }, {
          start: {
            line: 163,
            column: 34
          },
          end: {
            line: 163,
            column: 71
          }
        }],
        line: 163
      },
      '12': {
        loc: {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 45
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 45
          }
        }, {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 45
          }
        }],
        line: 173
      },
      '13': {
        loc: {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 174,
            column: 83
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 174,
            column: 83
          }
        }, {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 174,
            column: 83
          }
        }],
        line: 174
      },
      '14': {
        loc: {
          start: {
            line: 174,
            column: 10
          },
          end: {
            line: 174,
            column: 68
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 174,
            column: 10
          },
          end: {
            line: 174,
            column: 33
          }
        }, {
          start: {
            line: 174,
            column: 37
          },
          end: {
            line: 174,
            column: 68
          }
        }],
        line: 174
      },
      '15': {
        loc: {
          start: {
            line: 177,
            column: 24
          },
          end: {
            line: 177,
            column: 80
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 177,
            column: 38
          },
          end: {
            line: 177,
            column: 73
          }
        }, {
          start: {
            line: 177,
            column: 76
          },
          end: {
            line: 177,
            column: 80
          }
        }],
        line: 177
      },
      '16': {
        loc: {
          start: {
            line: 179,
            column: 13
          },
          end: {
            line: 181,
            column: 24
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 179,
            column: 13
          },
          end: {
            line: 179,
            column: 48
          }
        }, {
          start: {
            line: 180,
            column: 13
          },
          end: {
            line: 180,
            column: 45
          }
        }, {
          start: {
            line: 181,
            column: 13
          },
          end: {
            line: 181,
            column: 24
          }
        }],
        line: 179
      },
      '17': {
        loc: {
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 194,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 194,
            column: 7
          }
        }, {
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 194,
            column: 7
          }
        }],
        line: 191
      },
      '18': {
        loc: {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 207,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 207,
            column: 7
          }
        }, {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 207,
            column: 7
          }
        }],
        line: 201
      },
      '19': {
        loc: {
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 227,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 227,
            column: 9
          }
        }, {
          start: {
            line: 225,
            column: 8
          },
          end: {
            line: 227,
            column: 9
          }
        }],
        line: 225
      },
      '20': {
        loc: {
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 290,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 290,
            column: 9
          }
        }, {
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 290,
            column: 9
          }
        }],
        line: 248
      },
      '21': {
        loc: {
          start: {
            line: 253,
            column: 20
          },
          end: {
            line: 253,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 253,
            column: 20
          },
          end: {
            line: 253,
            column: 35
          }
        }, {
          start: {
            line: 253,
            column: 39
          },
          end: {
            line: 253,
            column: 41
          }
        }],
        line: 253
      },
      '22': {
        loc: {
          start: {
            line: 262,
            column: 12
          },
          end: {
            line: 266,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 262,
            column: 12
          },
          end: {
            line: 266,
            column: 13
          }
        }, {
          start: {
            line: 262,
            column: 12
          },
          end: {
            line: 266,
            column: 13
          }
        }],
        line: 262
      },
      '23': {
        loc: {
          start: {
            line: 286,
            column: 18
          },
          end: {
            line: 286,
            column: 72
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 286,
            column: 18
          },
          end: {
            line: 286,
            column: 34
          }
        }, {
          start: {
            line: 286,
            column: 38
          },
          end: {
            line: 286,
            column: 72
          }
        }],
        line: 286
      },
      '24': {
        loc: {
          start: {
            line: 342,
            column: 6
          },
          end: {
            line: 344,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 342,
            column: 6
          },
          end: {
            line: 344,
            column: 7
          }
        }, {
          start: {
            line: 342,
            column: 6
          },
          end: {
            line: 344,
            column: 7
          }
        }],
        line: 342
      },
      '25': {
        loc: {
          start: {
            line: 345,
            column: 6
          },
          end: {
            line: 354,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 345,
            column: 6
          },
          end: {
            line: 354,
            column: 7
          }
        }, {
          start: {
            line: 345,
            column: 6
          },
          end: {
            line: 354,
            column: 7
          }
        }],
        line: 345
      },
      '26': {
        loc: {
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 349,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 349,
            column: 11
          }
        }, {
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 349,
            column: 11
          }
        }],
        line: 347
      },
      '27': {
        loc: {
          start: {
            line: 363,
            column: 21
          },
          end: {
            line: 363,
            column: 41
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 363,
            column: 21
          },
          end: {
            line: 363,
            column: 35
          }
        }, {
          start: {
            line: 363,
            column: 39
          },
          end: {
            line: 363,
            column: 41
          }
        }],
        line: 363
      },
      '28': {
        loc: {
          start: {
            line: 369,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 369,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        }, {
          start: {
            line: 369,
            column: 6
          },
          end: {
            line: 373,
            column: 7
          }
        }],
        line: 369
      },
      '29': {
        loc: {
          start: {
            line: 387,
            column: 22
          },
          end: {
            line: 387,
            column: 43
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 387,
            column: 22
          },
          end: {
            line: 387,
            column: 37
          }
        }, {
          start: {
            line: 387,
            column: 41
          },
          end: {
            line: 387,
            column: 43
          }
        }],
        line: 387
      },
      '30': {
        loc: {
          start: {
            line: 400,
            column: 6
          },
          end: {
            line: 402,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 400,
            column: 6
          },
          end: {
            line: 402,
            column: 7
          }
        }, {
          start: {
            line: 400,
            column: 6
          },
          end: {
            line: 402,
            column: 7
          }
        }],
        line: 400
      },
      '31': {
        loc: {
          start: {
            line: 403,
            column: 6
          },
          end: {
            line: 412,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 403,
            column: 6
          },
          end: {
            line: 412,
            column: 7
          }
        }, {
          start: {
            line: 403,
            column: 6
          },
          end: {
            line: 412,
            column: 7
          }
        }],
        line: 403
      },
      '32': {
        loc: {
          start: {
            line: 405,
            column: 10
          },
          end: {
            line: 407,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 405,
            column: 10
          },
          end: {
            line: 407,
            column: 11
          }
        }, {
          start: {
            line: 405,
            column: 10
          },
          end: {
            line: 407,
            column: 11
          }
        }],
        line: 405
      },
      '33': {
        loc: {
          start: {
            line: 417,
            column: 6
          },
          end: {
            line: 421,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 417,
            column: 6
          },
          end: {
            line: 421,
            column: 7
          }
        }, {
          start: {
            line: 417,
            column: 6
          },
          end: {
            line: 421,
            column: 7
          }
        }],
        line: 417
      },
      '34': {
        loc: {
          start: {
            line: 428,
            column: 6
          },
          end: {
            line: 430,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 428,
            column: 6
          },
          end: {
            line: 430,
            column: 7
          }
        }, {
          start: {
            line: 428,
            column: 6
          },
          end: {
            line: 430,
            column: 7
          }
        }],
        line: 428
      },
      '35': {
        loc: {
          start: {
            line: 431,
            column: 6
          },
          end: {
            line: 440,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 431,
            column: 6
          },
          end: {
            line: 440,
            column: 7
          }
        }, {
          start: {
            line: 431,
            column: 6
          },
          end: {
            line: 440,
            column: 7
          }
        }],
        line: 431
      },
      '36': {
        loc: {
          start: {
            line: 433,
            column: 10
          },
          end: {
            line: 435,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 433,
            column: 10
          },
          end: {
            line: 435,
            column: 11
          }
        }, {
          start: {
            line: 433,
            column: 10
          },
          end: {
            line: 435,
            column: 11
          }
        }],
        line: 433
      },
      '37': {
        loc: {
          start: {
            line: 445,
            column: 6
          },
          end: {
            line: 458,
            column: 7
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 446,
            column: 8
          },
          end: {
            line: 448,
            column: 16
          }
        }, {
          start: {
            line: 449,
            column: 8
          },
          end: {
            line: 452,
            column: 16
          }
        }, {
          start: {
            line: 453,
            column: 8
          },
          end: {
            line: 455,
            column: 16
          }
        }, {
          start: {
            line: 456,
            column: 8
          },
          end: {
            line: 456,
            column: 16
          }
        }],
        line: 445
      },
      '38': {
        loc: {
          start: {
            line: 463,
            column: 6
          },
          end: {
            line: 467,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 463,
            column: 6
          },
          end: {
            line: 467,
            column: 7
          }
        }, {
          start: {
            line: 463,
            column: 6
          },
          end: {
            line: 467,
            column: 7
          }
        }],
        line: 463
      },
      '39': {
        loc: {
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 466,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 466,
            column: 9
          }
        }, {
          start: {
            line: 464,
            column: 8
          },
          end: {
            line: 466,
            column: 9
          }
        }],
        line: 464
      },
      '40': {
        loc: {
          start: {
            line: 469,
            column: 6
          },
          end: {
            line: 477,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 469,
            column: 6
          },
          end: {
            line: 477,
            column: 7
          }
        }, {
          start: {
            line: 469,
            column: 6
          },
          end: {
            line: 477,
            column: 7
          }
        }],
        line: 469
      },
      '41': {
        loc: {
          start: {
            line: 471,
            column: 8
          },
          end: {
            line: 476,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 471,
            column: 8
          },
          end: {
            line: 476,
            column: 9
          }
        }, {
          start: {
            line: 471,
            column: 8
          },
          end: {
            line: 476,
            column: 9
          }
        }],
        line: 471
      },
      '42': {
        loc: {
          start: {
            line: 473,
            column: 10
          },
          end: {
            line: 475,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 473,
            column: 10
          },
          end: {
            line: 475,
            column: 11
          }
        }, {
          start: {
            line: 473,
            column: 10
          },
          end: {
            line: 475,
            column: 11
          }
        }],
        line: 473
      },
      '43': {
        loc: {
          start: {
            line: 483,
            column: 6
          },
          end: {
            line: 488,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 483,
            column: 6
          },
          end: {
            line: 488,
            column: 7
          }
        }, {
          start: {
            line: 483,
            column: 6
          },
          end: {
            line: 488,
            column: 7
          }
        }],
        line: 483
      },
      '44': {
        loc: {
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 486,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 486,
            column: 9
          }
        }, {
          start: {
            line: 484,
            column: 8
          },
          end: {
            line: 486,
            column: 9
          }
        }],
        line: 484
      },
      '45': {
        loc: {
          start: {
            line: 490,
            column: 6
          },
          end: {
            line: 494,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 490,
            column: 6
          },
          end: {
            line: 494,
            column: 7
          }
        }, {
          start: {
            line: 490,
            column: 6
          },
          end: {
            line: 494,
            column: 7
          }
        }],
        line: 490
      },
      '46': {
        loc: {
          start: {
            line: 491,
            column: 8
          },
          end: {
            line: 493,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 491,
            column: 8
          },
          end: {
            line: 493,
            column: 9
          }
        }, {
          start: {
            line: 491,
            column: 8
          },
          end: {
            line: 493,
            column: 9
          }
        }],
        line: 491
      },
      '47': {
        loc: {
          start: {
            line: 510,
            column: 8
          },
          end: {
            line: 514,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 510,
            column: 8
          },
          end: {
            line: 514,
            column: 9
          }
        }, {
          start: {
            line: 510,
            column: 8
          },
          end: {
            line: 514,
            column: 9
          }
        }],
        line: 510
      },
      '48': {
        loc: {
          start: {
            line: 510,
            column: 22
          },
          end: {
            line: 510,
            column: 46
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 510,
            column: 22
          },
          end: {
            line: 510,
            column: 40
          }
        }, {
          start: {
            line: 510,
            column: 44
          },
          end: {
            line: 510,
            column: 46
          }
        }],
        line: 510
      },
      '49': {
        loc: {
          start: {
            line: 511,
            column: 10
          },
          end: {
            line: 513,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 511,
            column: 10
          },
          end: {
            line: 513,
            column: 11
          }
        }, {
          start: {
            line: 511,
            column: 10
          },
          end: {
            line: 513,
            column: 11
          }
        }],
        line: 511
      },
      '50': {
        loc: {
          start: {
            line: 511,
            column: 15
          },
          end: {
            line: 511,
            column: 39
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 511,
            column: 15
          },
          end: {
            line: 511,
            column: 33
          }
        }, {
          start: {
            line: 511,
            column: 37
          },
          end: {
            line: 511,
            column: 39
          }
        }],
        line: 511
      },
      '51': {
        loc: {
          start: {
            line: 524,
            column: 40
          },
          end: {
            line: 524,
            column: 65
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 524,
            column: 56
          },
          end: {
            line: 524,
            column: 59
          }
        }, {
          start: {
            line: 524,
            column: 62
          },
          end: {
            line: 524,
            column: 65
          }
        }],
        line: 524
      },
      '52': {
        loc: {
          start: {
            line: 532,
            column: 6
          },
          end: {
            line: 534,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 532,
            column: 6
          },
          end: {
            line: 534,
            column: 7
          }
        }, {
          start: {
            line: 532,
            column: 6
          },
          end: {
            line: 534,
            column: 7
          }
        }],
        line: 532
      },
      '53': {
        loc: {
          start: {
            line: 532,
            column: 10
          },
          end: {
            line: 532,
            column: 59
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 532,
            column: 10
          },
          end: {
            line: 532,
            column: 27
          }
        }, {
          start: {
            line: 532,
            column: 31
          },
          end: {
            line: 532,
            column: 59
          }
        }],
        line: 532
      },
      '54': {
        loc: {
          start: {
            line: 536,
            column: 13
          },
          end: {
            line: 536,
            column: 95
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 536,
            column: 13
          },
          end: {
            line: 536,
            column: 24
          }
        }, {
          start: {
            line: 536,
            column: 29
          },
          end: {
            line: 536,
            column: 53
          }
        }, {
          start: {
            line: 536,
            column: 57
          },
          end: {
            line: 536,
            column: 68
          }
        }, {
          start: {
            line: 536,
            column: 72
          },
          end: {
            line: 536,
            column: 94
          }
        }],
        line: 536
      },
      '55': {
        loc: {
          start: {
            line: 539,
            column: 6
          },
          end: {
            line: 541,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 539,
            column: 6
          },
          end: {
            line: 541,
            column: 7
          }
        }, {
          start: {
            line: 539,
            column: 6
          },
          end: {
            line: 541,
            column: 7
          }
        }],
        line: 539
      },
      '56': {
        loc: {
          start: {
            line: 543,
            column: 6
          },
          end: {
            line: 545,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 543,
            column: 6
          },
          end: {
            line: 545,
            column: 7
          }
        }, {
          start: {
            line: 543,
            column: 6
          },
          end: {
            line: 545,
            column: 7
          }
        }],
        line: 543
      },
      '57': {
        loc: {
          start: {
            line: 547,
            column: 6
          },
          end: {
            line: 549,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 547,
            column: 6
          },
          end: {
            line: 549,
            column: 7
          }
        }, {
          start: {
            line: 547,
            column: 6
          },
          end: {
            line: 549,
            column: 7
          }
        }],
        line: 547
      },
      '58': {
        loc: {
          start: {
            line: 603,
            column: 8
          },
          end: {
            line: 606,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 603,
            column: 8
          },
          end: {
            line: 606,
            column: 9
          }
        }, {
          start: {
            line: 603,
            column: 8
          },
          end: {
            line: 606,
            column: 9
          }
        }],
        line: 603
      },
      '59': {
        loc: {
          start: {
            line: 611,
            column: 6
          },
          end: {
            line: 631,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 611,
            column: 6
          },
          end: {
            line: 631,
            column: 7
          }
        }, {
          start: {
            line: 611,
            column: 6
          },
          end: {
            line: 631,
            column: 7
          }
        }],
        line: 611
      },
      '60': {
        loc: {
          start: {
            line: 612,
            column: 8
          },
          end: {
            line: 618,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 612,
            column: 8
          },
          end: {
            line: 618,
            column: 9
          }
        }, {
          start: {
            line: 612,
            column: 8
          },
          end: {
            line: 618,
            column: 9
          }
        }],
        line: 612
      },
      '61': {
        loc: {
          start: {
            line: 613,
            column: 10
          },
          end: {
            line: 615,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 613,
            column: 10
          },
          end: {
            line: 615,
            column: 11
          }
        }, {
          start: {
            line: 613,
            column: 10
          },
          end: {
            line: 615,
            column: 11
          }
        }],
        line: 613
      },
      '62': {
        loc: {
          start: {
            line: 620,
            column: 8
          },
          end: {
            line: 624,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 620,
            column: 8
          },
          end: {
            line: 624,
            column: 9
          }
        }, {
          start: {
            line: 620,
            column: 8
          },
          end: {
            line: 624,
            column: 9
          }
        }],
        line: 620
      },
      '63': {
        loc: {
          start: {
            line: 625,
            column: 13
          },
          end: {
            line: 631,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 625,
            column: 13
          },
          end: {
            line: 631,
            column: 7
          }
        }, {
          start: {
            line: 625,
            column: 13
          },
          end: {
            line: 631,
            column: 7
          }
        }],
        line: 625
      },
      '64': {
        loc: {
          start: {
            line: 626,
            column: 8
          },
          end: {
            line: 628,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 626,
            column: 8
          },
          end: {
            line: 628,
            column: 9
          }
        }, {
          start: {
            line: 626,
            column: 8
          },
          end: {
            line: 628,
            column: 9
          }
        }],
        line: 626
      },
      '65': {
        loc: {
          start: {
            line: 634,
            column: 6
          },
          end: {
            line: 636,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 634,
            column: 6
          },
          end: {
            line: 636,
            column: 7
          }
        }, {
          start: {
            line: 634,
            column: 6
          },
          end: {
            line: 636,
            column: 7
          }
        }],
        line: 634
      },
      '66': {
        loc: {
          start: {
            line: 637,
            column: 6
          },
          end: {
            line: 639,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 637,
            column: 6
          },
          end: {
            line: 639,
            column: 7
          }
        }, {
          start: {
            line: 637,
            column: 6
          },
          end: {
            line: 639,
            column: 7
          }
        }],
        line: 637
      },
      '67': {
        loc: {
          start: {
            line: 643,
            column: 8
          },
          end: {
            line: 645,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 643,
            column: 8
          },
          end: {
            line: 645,
            column: 9
          }
        }, {
          start: {
            line: 643,
            column: 8
          },
          end: {
            line: 645,
            column: 9
          }
        }],
        line: 643
      },
      '68': {
        loc: {
          start: {
            line: 687,
            column: 53
          },
          end: {
            line: 687,
            column: 109
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 687,
            column: 74
          },
          end: {
            line: 687,
            column: 97
          }
        }, {
          start: {
            line: 687,
            column: 100
          },
          end: {
            line: 687,
            column: 109
          }
        }],
        line: 687
      },
      '69': {
        loc: {
          start: {
            line: 687,
            column: 119
          },
          end: {
            line: 687,
            column: 175
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 687,
            column: 140
          },
          end: {
            line: 687,
            column: 163
          }
        }, {
          start: {
            line: 687,
            column: 166
          },
          end: {
            line: 687,
            column: 175
          }
        }],
        line: 687
      },
      '70': {
        loc: {
          start: {
            line: 693,
            column: 38
          },
          end: {
            line: 695,
            column: 10
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 693,
            column: 83
          },
          end: {
            line: 693,
            column: 87
          }
        }, {
          start: {
            line: 693,
            column: 90
          },
          end: {
            line: 695,
            column: 10
          }
        }],
        line: 693
      },
      '71': {
        loc: {
          start: {
            line: 723,
            column: 6
          },
          end: {
            line: 735,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 723,
            column: 6
          },
          end: {
            line: 735,
            column: 7
          }
        }, {
          start: {
            line: 723,
            column: 6
          },
          end: {
            line: 735,
            column: 7
          }
        }],
        line: 723
      },
      '72': {
        loc: {
          start: {
            line: 723,
            column: 10
          },
          end: {
            line: 723,
            column: 71
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 723,
            column: 10
          },
          end: {
            line: 723,
            column: 34
          }
        }, {
          start: {
            line: 723,
            column: 38
          },
          end: {
            line: 723,
            column: 71
          }
        }],
        line: 723
      },
      '73': {
        loc: {
          start: {
            line: 728,
            column: 8
          },
          end: {
            line: 730,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 728,
            column: 8
          },
          end: {
            line: 730,
            column: 9
          }
        }, {
          start: {
            line: 728,
            column: 8
          },
          end: {
            line: 730,
            column: 9
          }
        }],
        line: 728
      },
      '74': {
        loc: {
          start: {
            line: 738,
            column: 6
          },
          end: {
            line: 740,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 738,
            column: 6
          },
          end: {
            line: 740,
            column: 7
          }
        }, {
          start: {
            line: 738,
            column: 6
          },
          end: {
            line: 740,
            column: 7
          }
        }],
        line: 738
      },
      '75': {
        loc: {
          start: {
            line: 741,
            column: 6
          },
          end: {
            line: 743,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 741,
            column: 6
          },
          end: {
            line: 743,
            column: 7
          }
        }, {
          start: {
            line: 741,
            column: 6
          },
          end: {
            line: 743,
            column: 7
          }
        }],
        line: 741
      },
      '76': {
        loc: {
          start: {
            line: 744,
            column: 6
          },
          end: {
            line: 746,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 744,
            column: 6
          },
          end: {
            line: 746,
            column: 7
          }
        }, {
          start: {
            line: 744,
            column: 6
          },
          end: {
            line: 746,
            column: 7
          }
        }],
        line: 744
      },
      '77': {
        loc: {
          start: {
            line: 748,
            column: 8
          },
          end: {
            line: 750,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 748,
            column: 8
          },
          end: {
            line: 750,
            column: 9
          }
        }, {
          start: {
            line: 748,
            column: 8
          },
          end: {
            line: 750,
            column: 9
          }
        }],
        line: 748
      },
      '78': {
        loc: {
          start: {
            line: 761,
            column: 6
          },
          end: {
            line: 766,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 761,
            column: 6
          },
          end: {
            line: 766,
            column: 7
          }
        }, {
          start: {
            line: 761,
            column: 6
          },
          end: {
            line: 766,
            column: 7
          }
        }],
        line: 761
      },
      '79': {
        loc: {
          start: {
            line: 765,
            column: 38
          },
          end: {
            line: 765,
            column: 73
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 765,
            column: 63
          },
          end: {
            line: 765,
            column: 65
          }
        }, {
          start: {
            line: 765,
            column: 68
          },
          end: {
            line: 765,
            column: 73
          }
        }],
        line: 765
      },
      '80': {
        loc: {
          start: {
            line: 792,
            column: 6
          },
          end: {
            line: 794,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 792,
            column: 6
          },
          end: {
            line: 794,
            column: 7
          }
        }, {
          start: {
            line: 792,
            column: 6
          },
          end: {
            line: 794,
            column: 7
          }
        }],
        line: 792
      },
      '81': {
        loc: {
          start: {
            line: 793,
            column: 37
          },
          end: {
            line: 793,
            column: 65
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 793,
            column: 37
          },
          end: {
            line: 793,
            column: 54
          }
        }, {
          start: {
            line: 793,
            column: 58
          },
          end: {
            line: 793,
            column: 65
          }
        }],
        line: 793
      },
      '82': {
        loc: {
          start: {
            line: 797,
            column: 6
          },
          end: {
            line: 799,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 797,
            column: 6
          },
          end: {
            line: 799,
            column: 7
          }
        }, {
          start: {
            line: 797,
            column: 6
          },
          end: {
            line: 799,
            column: 7
          }
        }],
        line: 797
      },
      '83': {
        loc: {
          start: {
            line: 801,
            column: 6
          },
          end: {
            line: 806,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 801,
            column: 6
          },
          end: {
            line: 806,
            column: 7
          }
        }, {
          start: {
            line: 801,
            column: 6
          },
          end: {
            line: 806,
            column: 7
          }
        }],
        line: 801
      },
      '84': {
        loc: {
          start: {
            line: 801,
            column: 10
          },
          end: {
            line: 801,
            column: 86
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 801,
            column: 10
          },
          end: {
            line: 801,
            column: 39
          }
        }, {
          start: {
            line: 801,
            column: 43
          },
          end: {
            line: 801,
            column: 86
          }
        }],
        line: 801
      },
      '85': {
        loc: {
          start: {
            line: 808,
            column: 6
          },
          end: {
            line: 810,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 808,
            column: 6
          },
          end: {
            line: 810,
            column: 7
          }
        }, {
          start: {
            line: 808,
            column: 6
          },
          end: {
            line: 810,
            column: 7
          }
        }],
        line: 808
      },
      '86': {
        loc: {
          start: {
            line: 835,
            column: 51
          },
          end: {
            line: 835,
            column: 86
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 835,
            column: 81
          },
          end: {
            line: 835,
            column: 82
          }
        }, {
          start: {
            line: 835,
            column: 85
          },
          end: {
            line: 835,
            column: 86
          }
        }],
        line: 835
      },
      '87': {
        loc: {
          start: {
            line: 836,
            column: 46
          },
          end: {
            line: 836,
            column: 88
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 836,
            column: 46
          },
          end: {
            line: 836,
            column: 82
          }
        }, {
          start: {
            line: 836,
            column: 86
          },
          end: {
            line: 836,
            column: 88
          }
        }],
        line: 836
      },
      '88': {
        loc: {
          start: {
            line: 837,
            column: 51
          },
          end: {
            line: 837,
            column: 98
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 837,
            column: 51
          },
          end: {
            line: 837,
            column: 92
          }
        }, {
          start: {
            line: 837,
            column: 96
          },
          end: {
            line: 837,
            column: 98
          }
        }],
        line: 837
      },
      '89': {
        loc: {
          start: {
            line: 838,
            column: 6
          },
          end: {
            line: 842,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 838,
            column: 6
          },
          end: {
            line: 842,
            column: 7
          }
        }, {
          start: {
            line: 838,
            column: 6
          },
          end: {
            line: 842,
            column: 7
          }
        }],
        line: 838
      },
      '90': {
        loc: {
          start: {
            line: 844,
            column: 6
          },
          end: {
            line: 848,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 844,
            column: 6
          },
          end: {
            line: 848,
            column: 7
          }
        }, {
          start: {
            line: 844,
            column: 6
          },
          end: {
            line: 848,
            column: 7
          }
        }],
        line: 844
      },
      '91': {
        loc: {
          start: {
            line: 852,
            column: 15
          },
          end: {
            line: 853,
            column: 89
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 852,
            column: 15
          },
          end: {
            line: 852,
            column: 60
          }
        }, {
          start: {
            line: 853,
            column: 10
          },
          end: {
            line: 853,
            column: 89
          }
        }],
        line: 852
      },
      '92': {
        loc: {
          start: {
            line: 856,
            column: 6
          },
          end: {
            line: 860,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 856,
            column: 6
          },
          end: {
            line: 860,
            column: 7
          }
        }, {
          start: {
            line: 856,
            column: 6
          },
          end: {
            line: 860,
            column: 7
          }
        }],
        line: 856
      },
      '93': {
        loc: {
          start: {
            line: 863,
            column: 6
          },
          end: {
            line: 867,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 863,
            column: 6
          },
          end: {
            line: 867,
            column: 7
          }
        }, {
          start: {
            line: 863,
            column: 6
          },
          end: {
            line: 867,
            column: 7
          }
        }],
        line: 863
      },
      '94': {
        loc: {
          start: {
            line: 868,
            column: 6
          },
          end: {
            line: 872,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 868,
            column: 6
          },
          end: {
            line: 872,
            column: 7
          }
        }, {
          start: {
            line: 868,
            column: 6
          },
          end: {
            line: 872,
            column: 7
          }
        }],
        line: 868
      },
      '95': {
        loc: {
          start: {
            line: 878,
            column: 6
          },
          end: {
            line: 880,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 878,
            column: 6
          },
          end: {
            line: 880,
            column: 7
          }
        }, {
          start: {
            line: 878,
            column: 6
          },
          end: {
            line: 880,
            column: 7
          }
        }],
        line: 878
      },
      '96': {
        loc: {
          start: {
            line: 881,
            column: 6
          },
          end: {
            line: 885,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 881,
            column: 6
          },
          end: {
            line: 885,
            column: 7
          }
        }, {
          start: {
            line: 881,
            column: 6
          },
          end: {
            line: 885,
            column: 7
          }
        }],
        line: 881
      },
      '97': {
        loc: {
          start: {
            line: 886,
            column: 6
          },
          end: {
            line: 888,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 886,
            column: 6
          },
          end: {
            line: 888,
            column: 7
          }
        }, {
          start: {
            line: 886,
            column: 6
          },
          end: {
            line: 888,
            column: 7
          }
        }],
        line: 886
      },
      '98': {
        loc: {
          start: {
            line: 890,
            column: 6
          },
          end: {
            line: 892,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 890,
            column: 6
          },
          end: {
            line: 892,
            column: 7
          }
        }, {
          start: {
            line: 890,
            column: 6
          },
          end: {
            line: 892,
            column: 7
          }
        }],
        line: 890
      },
      '99': {
        loc: {
          start: {
            line: 893,
            column: 6
          },
          end: {
            line: 908,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 893,
            column: 6
          },
          end: {
            line: 908,
            column: 7
          }
        }, {
          start: {
            line: 893,
            column: 6
          },
          end: {
            line: 908,
            column: 7
          }
        }],
        line: 893
      },
      '100': {
        loc: {
          start: {
            line: 894,
            column: 8
          },
          end: {
            line: 907,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 894,
            column: 8
          },
          end: {
            line: 907,
            column: 9
          }
        }, {
          start: {
            line: 894,
            column: 8
          },
          end: {
            line: 907,
            column: 9
          }
        }],
        line: 894
      },
      '101': {
        loc: {
          start: {
            line: 896,
            column: 12
          },
          end: {
            line: 898,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 896,
            column: 12
          },
          end: {
            line: 898,
            column: 13
          }
        }, {
          start: {
            line: 896,
            column: 12
          },
          end: {
            line: 898,
            column: 13
          }
        }],
        line: 896
      },
      '102': {
        loc: {
          start: {
            line: 899,
            column: 12
          },
          end: {
            line: 901,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 899,
            column: 12
          },
          end: {
            line: 901,
            column: 13
          }
        }, {
          start: {
            line: 899,
            column: 12
          },
          end: {
            line: 901,
            column: 13
          }
        }],
        line: 899
      },
      '103': {
        loc: {
          start: {
            line: 902,
            column: 12
          },
          end: {
            line: 904,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 902,
            column: 12
          },
          end: {
            line: 904,
            column: 13
          }
        }, {
          start: {
            line: 902,
            column: 12
          },
          end: {
            line: 904,
            column: 13
          }
        }],
        line: 902
      },
      '104': {
        loc: {
          start: {
            line: 910,
            column: 25
          },
          end: {
            line: 910,
            column: 49
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 910,
            column: 44
          },
          end: {
            line: 910,
            column: 45
          }
        }, {
          start: {
            line: 910,
            column: 48
          },
          end: {
            line: 910,
            column: 49
          }
        }],
        line: 910
      },
      '105': {
        loc: {
          start: {
            line: 911,
            column: 31
          },
          end: {
            line: 911,
            column: 61
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 911,
            column: 56
          },
          end: {
            line: 911,
            column: 57
          }
        }, {
          start: {
            line: 911,
            column: 60
          },
          end: {
            line: 911,
            column: 61
          }
        }],
        line: 911
      },
      '106': {
        loc: {
          start: {
            line: 915,
            column: 8
          },
          end: {
            line: 918,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 915,
            column: 8
          },
          end: {
            line: 918,
            column: 9
          }
        }, {
          start: {
            line: 915,
            column: 8
          },
          end: {
            line: 918,
            column: 9
          }
        }],
        line: 915
      },
      '107': {
        loc: {
          start: {
            line: 935,
            column: 8
          },
          end: {
            line: 937,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 935,
            column: 8
          },
          end: {
            line: 937,
            column: 9
          }
        }, {
          start: {
            line: 935,
            column: 8
          },
          end: {
            line: 937,
            column: 9
          }
        }],
        line: 935
      },
      '108': {
        loc: {
          start: {
            line: 940,
            column: 10
          },
          end: {
            line: 947,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 940,
            column: 10
          },
          end: {
            line: 947,
            column: 11
          }
        }, {
          start: {
            line: 940,
            column: 10
          },
          end: {
            line: 947,
            column: 11
          }
        }],
        line: 940
      },
      '109': {
        loc: {
          start: {
            line: 959,
            column: 8
          },
          end: {
            line: 961,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 959,
            column: 8
          },
          end: {
            line: 961,
            column: 9
          }
        }, {
          start: {
            line: 959,
            column: 8
          },
          end: {
            line: 961,
            column: 9
          }
        }],
        line: 959
      },
      '110': {
        loc: {
          start: {
            line: 963,
            column: 8
          },
          end: {
            line: 965,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 963,
            column: 8
          },
          end: {
            line: 965,
            column: 9
          }
        }, {
          start: {
            line: 963,
            column: 8
          },
          end: {
            line: 965,
            column: 9
          }
        }],
        line: 963
      },
      '111': {
        loc: {
          start: {
            line: 981,
            column: 8
          },
          end: {
            line: 983,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 981,
            column: 8
          },
          end: {
            line: 983,
            column: 9
          }
        }, {
          start: {
            line: 981,
            column: 8
          },
          end: {
            line: 983,
            column: 9
          }
        }],
        line: 981
      },
      '112': {
        loc: {
          start: {
            line: 1003,
            column: 6
          },
          end: {
            line: 1007,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1003,
            column: 6
          },
          end: {
            line: 1007,
            column: 7
          }
        }, {
          start: {
            line: 1003,
            column: 6
          },
          end: {
            line: 1007,
            column: 7
          }
        }],
        line: 1003
      },
      '113': {
        loc: {
          start: {
            line: 1004,
            column: 8
          },
          end: {
            line: 1006,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1004,
            column: 8
          },
          end: {
            line: 1006,
            column: 9
          }
        }, {
          start: {
            line: 1004,
            column: 8
          },
          end: {
            line: 1006,
            column: 9
          }
        }],
        line: 1004
      },
      '114': {
        loc: {
          start: {
            line: 1008,
            column: 6
          },
          end: {
            line: 1010,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1008,
            column: 6
          },
          end: {
            line: 1010,
            column: 7
          }
        }, {
          start: {
            line: 1008,
            column: 6
          },
          end: {
            line: 1010,
            column: 7
          }
        }],
        line: 1008
      },
      '115': {
        loc: {
          start: {
            line: 1012,
            column: 8
          },
          end: {
            line: 1014,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1012,
            column: 8
          },
          end: {
            line: 1014,
            column: 9
          }
        }, {
          start: {
            line: 1012,
            column: 8
          },
          end: {
            line: 1014,
            column: 9
          }
        }],
        line: 1012
      },
      '116': {
        loc: {
          start: {
            line: 1022,
            column: 21
          },
          end: {
            line: 1022,
            column: 66
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 1022,
            column: 47
          },
          end: {
            line: 1022,
            column: 48
          }
        }, {
          start: {
            line: 1022,
            column: 51
          },
          end: {
            line: 1022,
            column: 66
          }
        }],
        line: 1022
      },
      '117': {
        loc: {
          start: {
            line: 1027,
            column: 6
          },
          end: {
            line: 1029,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1027,
            column: 6
          },
          end: {
            line: 1029,
            column: 7
          }
        }, {
          start: {
            line: 1027,
            column: 6
          },
          end: {
            line: 1029,
            column: 7
          }
        }],
        line: 1027
      },
      '118': {
        loc: {
          start: {
            line: 1040,
            column: 6
          },
          end: {
            line: 1042,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1040,
            column: 6
          },
          end: {
            line: 1042,
            column: 7
          }
        }, {
          start: {
            line: 1040,
            column: 6
          },
          end: {
            line: 1042,
            column: 7
          }
        }],
        line: 1040
      },
      '119': {
        loc: {
          start: {
            line: 1046,
            column: 6
          },
          end: {
            line: 1048,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1046,
            column: 6
          },
          end: {
            line: 1048,
            column: 7
          }
        }, {
          start: {
            line: 1046,
            column: 6
          },
          end: {
            line: 1048,
            column: 7
          }
        }],
        line: 1046
      },
      '120': {
        loc: {
          start: {
            line: 1049,
            column: 6
          },
          end: {
            line: 1051,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1049,
            column: 6
          },
          end: {
            line: 1051,
            column: 7
          }
        }, {
          start: {
            line: 1049,
            column: 6
          },
          end: {
            line: 1051,
            column: 7
          }
        }],
        line: 1049
      },
      '121': {
        loc: {
          start: {
            line: 1061,
            column: 8
          },
          end: {
            line: 1063,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1061,
            column: 8
          },
          end: {
            line: 1063,
            column: 9
          }
        }, {
          start: {
            line: 1061,
            column: 8
          },
          end: {
            line: 1063,
            column: 9
          }
        }],
        line: 1061
      },
      '122': {
        loc: {
          start: {
            line: 1083,
            column: 4
          },
          end: {
            line: 1085,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1083,
            column: 4
          },
          end: {
            line: 1085,
            column: 5
          }
        }, {
          start: {
            line: 1083,
            column: 4
          },
          end: {
            line: 1085,
            column: 5
          }
        }],
        line: 1083
      },
      '123': {
        loc: {
          start: {
            line: 1111,
            column: 4
          },
          end: {
            line: 1113,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1111,
            column: 4
          },
          end: {
            line: 1113,
            column: 5
          }
        }, {
          start: {
            line: 1111,
            column: 4
          },
          end: {
            line: 1113,
            column: 5
          }
        }],
        line: 1111
      },
      '124': {
        loc: {
          start: {
            line: 1125,
            column: 6
          },
          end: {
            line: 1153,
            column: 7
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 1126,
            column: 8
          },
          end: {
            line: 1128,
            column: 16
          }
        }, {
          start: {
            line: 1129,
            column: 8
          },
          end: {
            line: 1131,
            column: 16
          }
        }, {
          start: {
            line: 1132,
            column: 8
          },
          end: {
            line: 1134,
            column: 16
          }
        }, {
          start: {
            line: 1135,
            column: 8
          },
          end: {
            line: 1137,
            column: 16
          }
        }, {
          start: {
            line: 1138,
            column: 8
          },
          end: {
            line: 1140,
            column: 16
          }
        }, {
          start: {
            line: 1141,
            column: 8
          },
          end: {
            line: 1143,
            column: 16
          }
        }, {
          start: {
            line: 1144,
            column: 8
          },
          end: {
            line: 1146,
            column: 16
          }
        }, {
          start: {
            line: 1147,
            column: 8
          },
          end: {
            line: 1149,
            column: 16
          }
        }, {
          start: {
            line: 1151,
            column: 8
          },
          end: {
            line: 1152,
            column: 39
          }
        }],
        line: 1125
      },
      '125': {
        loc: {
          start: {
            line: 1203,
            column: 12
          },
          end: {
            line: 1203,
            column: 40
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1203,
            column: 12
          },
          end: {
            line: 1203,
            column: 24
          }
        }, {
          start: {
            line: 1203,
            column: 28
          },
          end: {
            line: 1203,
            column: 40
          }
        }],
        line: 1203
      },
      '126': {
        loc: {
          start: {
            line: 1204,
            column: 12
          },
          end: {
            line: 1204,
            column: 40
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1204,
            column: 12
          },
          end: {
            line: 1204,
            column: 24
          }
        }, {
          start: {
            line: 1204,
            column: 28
          },
          end: {
            line: 1204,
            column: 40
          }
        }],
        line: 1204
      },
      '127': {
        loc: {
          start: {
            line: 1213,
            column: 19
          },
          end: {
            line: 1213,
            column: 55
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 1213,
            column: 50
          },
          end: {
            line: 1213,
            column: 51
          }
        }, {
          start: {
            line: 1213,
            column: 54
          },
          end: {
            line: 1213,
            column: 55
          }
        }],
        line: 1213
      },
      '128': {
        loc: {
          start: {
            line: 1213,
            column: 60
          },
          end: {
            line: 1213,
            column: 96
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 1213,
            column: 91
          },
          end: {
            line: 1213,
            column: 92
          }
        }, {
          start: {
            line: 1213,
            column: 95
          },
          end: {
            line: 1213,
            column: 96
          }
        }],
        line: 1213
      },
      '129': {
        loc: {
          start: {
            line: 1214,
            column: 6
          },
          end: {
            line: 1216,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1214,
            column: 6
          },
          end: {
            line: 1216,
            column: 7
          }
        }, {
          start: {
            line: 1214,
            column: 6
          },
          end: {
            line: 1216,
            column: 7
          }
        }],
        line: 1214
      },
      '130': {
        loc: {
          start: {
            line: 1214,
            column: 10
          },
          end: {
            line: 1214,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 1214,
            column: 10
          },
          end: {
            line: 1214,
            column: 18
          }
        }, {
          start: {
            line: 1214,
            column: 22
          },
          end: {
            line: 1214,
            column: 57
          }
        }],
        line: 1214
      },
      '131': {
        loc: {
          start: {
            line: 1233,
            column: 6
          },
          end: {
            line: 1239,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1233,
            column: 6
          },
          end: {
            line: 1239,
            column: 7
          }
        }, {
          start: {
            line: 1233,
            column: 6
          },
          end: {
            line: 1239,
            column: 7
          }
        }],
        line: 1233
      },
      '132': {
        loc: {
          start: {
            line: 1234,
            column: 8
          },
          end: {
            line: 1238,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1234,
            column: 8
          },
          end: {
            line: 1238,
            column: 9
          }
        }, {
          start: {
            line: 1234,
            column: 8
          },
          end: {
            line: 1238,
            column: 9
          }
        }],
        line: 1234
      },
      '133': {
        loc: {
          start: {
            line: 1244,
            column: 6
          },
          end: {
            line: 1247,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1244,
            column: 6
          },
          end: {
            line: 1247,
            column: 7
          }
        }, {
          start: {
            line: 1244,
            column: 6
          },
          end: {
            line: 1247,
            column: 7
          }
        }],
        line: 1244
      },
      '134': {
        loc: {
          start: {
            line: 1249,
            column: 8
          },
          end: {
            line: 1251,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1249,
            column: 8
          },
          end: {
            line: 1251,
            column: 9
          }
        }, {
          start: {
            line: 1249,
            column: 8
          },
          end: {
            line: 1251,
            column: 9
          }
        }],
        line: 1249
      },
      '135': {
        loc: {
          start: {
            line: 1252,
            column: 8
          },
          end: {
            line: 1257,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 1252,
            column: 8
          },
          end: {
            line: 1257,
            column: 9
          }
        }, {
          start: {
            line: 1252,
            column: 8
          },
          end: {
            line: 1257,
            column: 9
          }
        }],
        line: 1252
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0,
      '225': 0,
      '226': 0,
      '227': 0,
      '228': 0,
      '229': 0,
      '230': 0,
      '231': 0,
      '232': 0,
      '233': 0,
      '234': 0,
      '235': 0,
      '236': 0,
      '237': 0,
      '238': 0,
      '239': 0,
      '240': 0,
      '241': 0,
      '242': 0,
      '243': 0,
      '244': 0,
      '245': 0,
      '246': 0,
      '247': 0,
      '248': 0,
      '249': 0,
      '250': 0,
      '251': 0,
      '252': 0,
      '253': 0,
      '254': 0,
      '255': 0,
      '256': 0,
      '257': 0,
      '258': 0,
      '259': 0,
      '260': 0,
      '261': 0,
      '262': 0,
      '263': 0,
      '264': 0,
      '265': 0,
      '266': 0,
      '267': 0,
      '268': 0,
      '269': 0,
      '270': 0,
      '271': 0,
      '272': 0,
      '273': 0,
      '274': 0,
      '275': 0,
      '276': 0,
      '277': 0,
      '278': 0,
      '279': 0,
      '280': 0,
      '281': 0,
      '282': 0,
      '283': 0,
      '284': 0,
      '285': 0,
      '286': 0,
      '287': 0,
      '288': 0,
      '289': 0,
      '290': 0,
      '291': 0,
      '292': 0,
      '293': 0,
      '294': 0,
      '295': 0,
      '296': 0,
      '297': 0,
      '298': 0,
      '299': 0,
      '300': 0,
      '301': 0,
      '302': 0,
      '303': 0,
      '304': 0,
      '305': 0,
      '306': 0,
      '307': 0,
      '308': 0,
      '309': 0,
      '310': 0,
      '311': 0,
      '312': 0,
      '313': 0,
      '314': 0,
      '315': 0,
      '316': 0,
      '317': 0,
      '318': 0,
      '319': 0,
      '320': 0,
      '321': 0,
      '322': 0,
      '323': 0,
      '324': 0,
      '325': 0,
      '326': 0,
      '327': 0,
      '328': 0,
      '329': 0,
      '330': 0,
      '331': 0,
      '332': 0,
      '333': 0,
      '334': 0,
      '335': 0,
      '336': 0,
      '337': 0,
      '338': 0,
      '339': 0,
      '340': 0,
      '341': 0,
      '342': 0,
      '343': 0,
      '344': 0,
      '345': 0,
      '346': 0,
      '347': 0,
      '348': 0,
      '349': 0,
      '350': 0,
      '351': 0,
      '352': 0,
      '353': 0,
      '354': 0,
      '355': 0,
      '356': 0,
      '357': 0,
      '358': 0,
      '359': 0,
      '360': 0,
      '361': 0,
      '362': 0,
      '363': 0,
      '364': 0,
      '365': 0,
      '366': 0,
      '367': 0,
      '368': 0,
      '369': 0,
      '370': 0,
      '371': 0,
      '372': 0,
      '373': 0,
      '374': 0,
      '375': 0,
      '376': 0,
      '377': 0,
      '378': 0,
      '379': 0,
      '380': 0,
      '381': 0,
      '382': 0,
      '383': 0,
      '384': 0,
      '385': 0,
      '386': 0,
      '387': 0,
      '388': 0,
      '389': 0,
      '390': 0,
      '391': 0,
      '392': 0,
      '393': 0,
      '394': 0,
      '395': 0,
      '396': 0,
      '397': 0,
      '398': 0,
      '399': 0,
      '400': 0,
      '401': 0,
      '402': 0,
      '403': 0,
      '404': 0,
      '405': 0,
      '406': 0,
      '407': 0,
      '408': 0,
      '409': 0,
      '410': 0,
      '411': 0,
      '412': 0,
      '413': 0,
      '414': 0,
      '415': 0,
      '416': 0,
      '417': 0,
      '418': 0,
      '419': 0,
      '420': 0,
      '421': 0,
      '422': 0,
      '423': 0,
      '424': 0,
      '425': 0,
      '426': 0,
      '427': 0,
      '428': 0,
      '429': 0,
      '430': 0,
      '431': 0,
      '432': 0,
      '433': 0,
      '434': 0,
      '435': 0,
      '436': 0,
      '437': 0,
      '438': 0,
      '439': 0,
      '440': 0,
      '441': 0,
      '442': 0,
      '443': 0,
      '444': 0,
      '445': 0,
      '446': 0,
      '447': 0,
      '448': 0,
      '449': 0,
      '450': 0,
      '451': 0,
      '452': 0,
      '453': 0,
      '454': 0,
      '455': 0,
      '456': 0,
      '457': 0,
      '458': 0,
      '459': 0,
      '460': 0,
      '461': 0,
      '462': 0,
      '463': 0,
      '464': 0,
      '465': 0,
      '466': 0,
      '467': 0,
      '468': 0,
      '469': 0,
      '470': 0,
      '471': 0,
      '472': 0,
      '473': 0,
      '474': 0,
      '475': 0,
      '476': 0,
      '477': 0,
      '478': 0,
      '479': 0,
      '480': 0,
      '481': 0,
      '482': 0,
      '483': 0,
      '484': 0,
      '485': 0,
      '486': 0,
      '487': 0,
      '488': 0,
      '489': 0,
      '490': 0,
      '491': 0,
      '492': 0,
      '493': 0,
      '494': 0,
      '495': 0,
      '496': 0,
      '497': 0,
      '498': 0,
      '499': 0,
      '500': 0,
      '501': 0,
      '502': 0,
      '503': 0,
      '504': 0,
      '505': 0,
      '506': 0,
      '507': 0,
      '508': 0,
      '509': 0,
      '510': 0,
      '511': 0,
      '512': 0,
      '513': 0,
      '514': 0,
      '515': 0,
      '516': 0,
      '517': 0,
      '518': 0,
      '519': 0,
      '520': 0,
      '521': 0,
      '522': 0,
      '523': 0,
      '524': 0,
      '525': 0,
      '526': 0,
      '527': 0,
      '528': 0,
      '529': 0,
      '530': 0,
      '531': 0,
      '532': 0,
      '533': 0,
      '534': 0,
      '535': 0,
      '536': 0,
      '537': 0,
      '538': 0,
      '539': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0, 0, 0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0],
      '48': [0, 0],
      '49': [0, 0],
      '50': [0, 0],
      '51': [0, 0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0, 0, 0],
      '55': [0, 0],
      '56': [0, 0],
      '57': [0, 0],
      '58': [0, 0],
      '59': [0, 0],
      '60': [0, 0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0],
      '64': [0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0, 0],
      '73': [0, 0],
      '74': [0, 0],
      '75': [0, 0],
      '76': [0, 0],
      '77': [0, 0],
      '78': [0, 0],
      '79': [0, 0],
      '80': [0, 0],
      '81': [0, 0],
      '82': [0, 0],
      '83': [0, 0],
      '84': [0, 0],
      '85': [0, 0],
      '86': [0, 0],
      '87': [0, 0],
      '88': [0, 0],
      '89': [0, 0],
      '90': [0, 0],
      '91': [0, 0],
      '92': [0, 0],
      '93': [0, 0],
      '94': [0, 0],
      '95': [0, 0],
      '96': [0, 0],
      '97': [0, 0],
      '98': [0, 0],
      '99': [0, 0],
      '100': [0, 0],
      '101': [0, 0],
      '102': [0, 0],
      '103': [0, 0],
      '104': [0, 0],
      '105': [0, 0],
      '106': [0, 0],
      '107': [0, 0],
      '108': [0, 0],
      '109': [0, 0],
      '110': [0, 0],
      '111': [0, 0],
      '112': [0, 0],
      '113': [0, 0],
      '114': [0, 0],
      '115': [0, 0],
      '116': [0, 0],
      '117': [0, 0],
      '118': [0, 0],
      '119': [0, 0],
      '120': [0, 0],
      '121': [0, 0],
      '122': [0, 0],
      '123': [0, 0],
      '124': [0, 0, 0, 0, 0, 0, 0, 0, 0],
      '125': [0, 0],
      '126': [0, 0],
      '127': [0, 0],
      '128': [0, 0],
      '129': [0, 0],
      '130': [0, 0],
      '131': [0, 0],
      '132': [0, 0],
      '133': [0, 0],
      '134': [0, 0],
      '135': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1jnbbceoql.s[0]++;


angular.module('app').controller('userCtrl', function ($scope, $rootScope, SweetAlert, $translate, $deltaActor, $CRUDService, $deltadate, $otherHttpService, $deltahttp, $filter, FileUploader, $uibModal) {
  cov_1jnbbceoql.f[0]++;

  var PATH = (cov_1jnbbceoql.s[1]++, 'User');
  var PATH_PROFIL = (cov_1jnbbceoql.s[2]++, 'Profils');
  cov_1jnbbceoql.s[3]++;
  $deltaActor.addController($scope);
  cov_1jnbbceoql.s[4]++;
  $scope.step = 1;
  cov_1jnbbceoql.s[5]++;
  $scope.showBulkProfile = false;

  cov_1jnbbceoql.s[6]++;

  $scope.bulkEditProfile = {
    searchUser: '',
    searchProject: '',

    bulkAssignment: {
      selectedProfile: null,
      selectedUsers: {},
      selectedProjects: {},
      checkAllUsers: false,
      checkAllProjects: false
    },

    isProcessing: false,

    result: {
      shown: false,
      successCount: 0,
      errorCount: 0,
      errors: []
    },

    closeBulkProfile: function closeBulkProfile() {
      cov_1jnbbceoql.f[1]++;
      cov_1jnbbceoql.s[7]++;

      $scope.showBulkProfile = false;
      cov_1jnbbceoql.s[8]++;

      this.bulkAssignment.selectedProfile = {
        id: 0,
        type: -1,
        label: $translate.instant('G_U.NO_ACCESS_PORTFOLIO')
      };
      cov_1jnbbceoql.s[9]++;
      this.bulkAssignment.selectedUsers = {};
      cov_1jnbbceoql.s[10]++;
      this.bulkAssignment.selectedProjects = {};
      cov_1jnbbceoql.s[11]++;
      this.bulkAssignment.checkAllUsers = false;
      cov_1jnbbceoql.s[12]++;
      this.bulkAssignment.checkAllProjects = false;
      cov_1jnbbceoql.s[13]++;

      this.searchUser = '';
      cov_1jnbbceoql.s[14]++;
      this.searchProject = '';
    },

    selectAllUsers: function selectAllUsers() {
      cov_1jnbbceoql.f[2]++;

      var self = (cov_1jnbbceoql.s[15]++, this);
      cov_1jnbbceoql.s[16]++;
      console.log('=== selectAllUsers called ===');

      cov_1jnbbceoql.s[17]++;
      if ((cov_1jnbbceoql.b[1][0]++, !$scope.userManager) || (cov_1jnbbceoql.b[1][1]++, !$scope.userManager.listUser)) {
        cov_1jnbbceoql.b[0][0]++;
        cov_1jnbbceoql.s[18]++;

        console.log('ERROR: userManager or listUser not available');
        cov_1jnbbceoql.s[19]++;
        return;
      } else {
        cov_1jnbbceoql.b[0][1]++;
      }

      var filteredUsers = (cov_1jnbbceoql.s[20]++, $filter('filter')($scope.userManager.listUser, self.searchUser));
      var selectedCount = (cov_1jnbbceoql.s[21]++, 0);
      cov_1jnbbceoql.s[22]++;
      filteredUsers.forEach(function (user) {
        cov_1jnbbceoql.f[3]++;
        cov_1jnbbceoql.s[23]++;

        if (!user.TYPEUSER) {
          cov_1jnbbceoql.b[2][0]++;
          cov_1jnbbceoql.s[24]++;

          self.bulkAssignment.selectedUsers[user.id] = true;
          cov_1jnbbceoql.s[25]++;
          selectedCount++;
        } else {
          cov_1jnbbceoql.b[2][1]++;
        }
      });
      cov_1jnbbceoql.s[26]++;
      console.log('Users selected:', selectedCount);
    },

    deselectAllUsers: function deselectAllUsers() {
      cov_1jnbbceoql.f[4]++;
      cov_1jnbbceoql.s[27]++;

      this.bulkAssignment.selectedUsers = {};
      cov_1jnbbceoql.s[28]++;
      console.log('All users deselected');
    },

    selectAllProjects: function selectAllProjects() {
      cov_1jnbbceoql.f[5]++;

      var self = (cov_1jnbbceoql.s[29]++, this);
      cov_1jnbbceoql.s[30]++;
      if (!$scope.userManager) {
          cov_1jnbbceoql.b[3][0]++;
          cov_1jnbbceoql.s[31]++;
          return;
        } else {
        cov_1jnbbceoql.b[3][1]++;
      }var selectedCount = (cov_1jnbbceoql.s[32]++, 0);
      cov_1jnbbceoql.s[33]++;
      if ($scope.userManager.portfolios) {
        cov_1jnbbceoql.b[4][0]++;

        var filteredPortfolios = (cov_1jnbbceoql.s[34]++, $filter('filter')($scope.userManager.portfolios, self.searchProject));
        cov_1jnbbceoql.s[35]++;
        filteredPortfolios.forEach(function (portfolio) {
          cov_1jnbbceoql.f[6]++;
          cov_1jnbbceoql.s[36]++;

          self.bulkAssignment.selectedProjects[portfolio.id] = true;
          cov_1jnbbceoql.s[37]++;
          selectedCount++;
        });
      } else {
        cov_1jnbbceoql.b[4][1]++;
      }
      cov_1jnbbceoql.s[38]++;
      if ($scope.userManager.projects) {
        cov_1jnbbceoql.b[5][0]++;

        var filteredProjects = (cov_1jnbbceoql.s[39]++, $filter('filter')($scope.userManager.projects, self.searchProject));
        cov_1jnbbceoql.s[40]++;
        filteredProjects.forEach(function (project) {
          cov_1jnbbceoql.f[7]++;
          cov_1jnbbceoql.s[41]++;

          self.bulkAssignment.selectedProjects[project.id] = true;
          cov_1jnbbceoql.s[42]++;
          selectedCount++;
        });
      } else {
        cov_1jnbbceoql.b[5][1]++;
      }
      cov_1jnbbceoql.s[43]++;
      console.log('Total items selected:', selectedCount);
    },

    deselectAllProjects: function deselectAllProjects() {
      cov_1jnbbceoql.f[8]++;
      cov_1jnbbceoql.s[44]++;

      this.bulkAssignment.selectedProjects = {};
      cov_1jnbbceoql.s[45]++;
      console.log('All projects deselected');
    },

    toggleAllUsers: function toggleAllUsers() {
      cov_1jnbbceoql.f[9]++;
      cov_1jnbbceoql.s[46]++;

      console.log('=== toggleAllUsers called ===', this.bulkAssignment.checkAllUsers);
      cov_1jnbbceoql.s[47]++;
      if (this.bulkAssignment.checkAllUsers) {
        cov_1jnbbceoql.b[6][0]++;
        cov_1jnbbceoql.s[48]++;

        this.selectAllUsers();
      } else {
        cov_1jnbbceoql.b[6][1]++;
        cov_1jnbbceoql.s[49]++;

        this.deselectAllUsers();
      }
    },

    toggleAllProjects: function toggleAllProjects() {
      cov_1jnbbceoql.f[10]++;
      cov_1jnbbceoql.s[50]++;

      console.log('=== toggleAllProjects called ===', this.bulkAssignment.checkAllProjects);
      cov_1jnbbceoql.s[51]++;
      if (this.bulkAssignment.checkAllProjects) {
        cov_1jnbbceoql.b[7][0]++;
        cov_1jnbbceoql.s[52]++;

        this.selectAllProjects();
      } else {
        cov_1jnbbceoql.b[7][1]++;
        cov_1jnbbceoql.s[53]++;

        this.deselectAllProjects();
      }
    },

    getSelectedUsersCount: function getSelectedUsersCount() {
      cov_1jnbbceoql.f[11]++;
      cov_1jnbbceoql.s[54]++;

      if ((cov_1jnbbceoql.b[9][0]++, !this.bulkAssignment) || (cov_1jnbbceoql.b[9][1]++, !this.bulkAssignment.selectedUsers)) {
          cov_1jnbbceoql.b[8][0]++;
          cov_1jnbbceoql.s[55]++;
          return 0;
        } else {
        cov_1jnbbceoql.b[8][1]++;
      }cov_1jnbbceoql.s[56]++;
      return Object.keys(this.bulkAssignment.selectedUsers).filter(function (key) {
        cov_1jnbbceoql.f[12]++;
        cov_1jnbbceoql.s[57]++;

        return $scope.bulkEditProfile.bulkAssignment.selectedUsers[key] === true;
      }).length;
    },

    getSelectedProjectsCount: function getSelectedProjectsCount() {
      cov_1jnbbceoql.f[13]++;
      cov_1jnbbceoql.s[58]++;

      if ((cov_1jnbbceoql.b[11][0]++, !this.bulkAssignment) || (cov_1jnbbceoql.b[11][1]++, !this.bulkAssignment.selectedProjects)) {
          cov_1jnbbceoql.b[10][0]++;
          cov_1jnbbceoql.s[59]++;
          return 0;
        } else {
        cov_1jnbbceoql.b[10][1]++;
      }cov_1jnbbceoql.s[60]++;
      return Object.keys(this.bulkAssignment.selectedProjects).filter(function (key) {
        cov_1jnbbceoql.f[14]++;
        cov_1jnbbceoql.s[61]++;

        return $scope.bulkEditProfile.bulkAssignment.selectedProjects[key] === true;
      }).length;
    },

    canApply: function canApply() {
      cov_1jnbbceoql.f[15]++;
      cov_1jnbbceoql.s[62]++;

      if (!this.bulkAssignment) {
          cov_1jnbbceoql.b[12][0]++;
          cov_1jnbbceoql.s[63]++;
          return false;
        } else {
        cov_1jnbbceoql.b[12][1]++;
      }cov_1jnbbceoql.s[64]++;
      if ((cov_1jnbbceoql.b[14][0]++, !$scope.selectedProject) || (cov_1jnbbceoql.b[14][1]++, !$scope.selectedProject.project)) {
          cov_1jnbbceoql.b[13][0]++;
          cov_1jnbbceoql.s[65]++;
          return false;
        } else {
        cov_1jnbbceoql.b[13][1]++;
      }var isPortfolio = (cov_1jnbbceoql.s[66]++, $scope.selectedProject.project.PORTFOLIO == 1);
      var hasProjects = (cov_1jnbbceoql.s[67]++, isPortfolio ? (cov_1jnbbceoql.b[15][0]++, this.getSelectedProjectsCount() > 0) : (cov_1jnbbceoql.b[15][1]++, true));

      cov_1jnbbceoql.s[68]++;
      return (cov_1jnbbceoql.b[16][0]++, this.bulkAssignment.selectedProfile) && (cov_1jnbbceoql.b[16][1]++, this.getSelectedUsersCount() > 0) && (cov_1jnbbceoql.b[16][2]++, hasProjects);
    },

    applyBulkAssignment: function applyBulkAssignment() {
      cov_1jnbbceoql.f[16]++;

      var self = (cov_1jnbbceoql.s[69]++, this);
      cov_1jnbbceoql.s[70]++;
      console.log('=== applyBulkAssignment called ===');

      cov_1jnbbceoql.s[71]++;
      if (!self.canApply()) {
        cov_1jnbbceoql.b[17][0]++;
        cov_1jnbbceoql.s[72]++;

        console.log('=== canApply returns false ===');
        cov_1jnbbceoql.s[73]++;
        return;
      } else {
        cov_1jnbbceoql.b[17][1]++;
      }

      var userIds = (cov_1jnbbceoql.s[74]++, Object.keys(self.bulkAssignment.selectedUsers).filter(function (key) {
        cov_1jnbbceoql.f[17]++;
        cov_1jnbbceoql.s[75]++;
        return self.bulkAssignment.selectedUsers[key] === true;
      }).map(function (id) {
        cov_1jnbbceoql.f[18]++;
        cov_1jnbbceoql.s[76]++;
        return parseInt(id);
      }));

      var projectIds;
      cov_1jnbbceoql.s[77]++;
      if ($scope.selectedProject.project.PORTFOLIO == 1) {
        cov_1jnbbceoql.b[18][0]++;
        cov_1jnbbceoql.s[78]++;

        projectIds = Object.keys(self.bulkAssignment.selectedProjects).filter(function (key) {
          cov_1jnbbceoql.f[19]++;
          cov_1jnbbceoql.s[79]++;
          return self.bulkAssignment.selectedProjects[key] === true;
        }).map(function (id) {
          cov_1jnbbceoql.f[20]++;
          cov_1jnbbceoql.s[80]++;
          return parseInt(id);
        });
      } else {
        cov_1jnbbceoql.b[18][1]++;
        cov_1jnbbceoql.s[81]++;

        projectIds = [parseInt($scope.selectedProject.project.id)];
      }

      var profileId = (cov_1jnbbceoql.s[82]++, self.bulkAssignment.selectedProfile.id);
      var profileLabel = (cov_1jnbbceoql.s[83]++, self.bulkAssignment.selectedProfile.label);

      cov_1jnbbceoql.s[84]++;
      SweetAlert.swal({
        title: $translate.instant('BULK_PROFILE.CONFIRM_TITLE'),
        text: $translate.instant('BULK_PROFILE.CONFIRM_MESSAGE_SIMPLE', {
          profile: profileLabel
        }),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        confirmButtonText: $translate.instant('COMMON.YES'),
        cancelButtonText: $translate.instant('COMMON.NO'),
        closeOnConfirm: false,
        closeOnCancel: true
      }, function (isConfirm) {
        cov_1jnbbceoql.f[21]++;
        cov_1jnbbceoql.s[85]++;

        if (isConfirm) {
          cov_1jnbbceoql.b[19][0]++;
          cov_1jnbbceoql.s[86]++;

          self.performBulkAssignment(userIds, projectIds, profileId);
        } else {
          cov_1jnbbceoql.b[19][1]++;
        }
      });
    },

    performBulkAssignment: function performBulkAssignment(userIds, projectIds, profileId) {
      cov_1jnbbceoql.f[22]++;

      var self = (cov_1jnbbceoql.s[87]++, this);
      cov_1jnbbceoql.s[88]++;
      self.isProcessing = true;
      cov_1jnbbceoql.s[89]++;
      self.result.shown = false;

      cov_1jnbbceoql.s[90]++;
      $otherHttpService.post(PATH, {
        action: 'bulkAssignProfile',
        valeur: JSON.stringify({
          userIds: userIds,
          projectIds: projectIds,
          profileId: profileId
        })
      }, function (response) {
        cov_1jnbbceoql.f[23]++;
        cov_1jnbbceoql.s[91]++;

        self.isProcessing = false;
        cov_1jnbbceoql.s[92]++;
        if (response.status === 'success') {
          cov_1jnbbceoql.b[20][0]++;
          cov_1jnbbceoql.s[93]++;

          self.result = {
            shown: true,
            successCount: response.successCount,
            errorCount: response.errorCount,
            errors: (cov_1jnbbceoql.b[21][0]++, response.errors) || (cov_1jnbbceoql.b[21][1]++, [])
          };

          cov_1jnbbceoql.s[94]++;
          SweetAlert.swal({
            title: $translate.instant('BULK_PROFILE.SUCCESS_TITLE'),
            text: $translate.instant('BULK_PROFILE.SUCCESS_MESSAGE_SIMPLE'),
            type: 'success',
            confirmButtonText: $translate.instant('COMMON.VALIDATE')
          }, function (isConfirm) {
            cov_1jnbbceoql.f[24]++;
            cov_1jnbbceoql.s[95]++;

            if (isConfirm) {
              cov_1jnbbceoql.b[22][0]++;
              cov_1jnbbceoql.s[96]++;

              $scope.showBulkProfile = false;
              cov_1jnbbceoql.s[97]++;
              $scope.$apply();
            } else {
              cov_1jnbbceoql.b[22][1]++;
            }
          });

          cov_1jnbbceoql.s[98]++;
          self.bulkAssignment = {
            selectedProfile: {
              id: 0,
              type: -1,
              label: $translate.instant('G_U.NO_ACCESS_PORTFOLIO')
            },
            selectedUsers: {},
            selectedProjects: {},
            checkAllUsers: false,
            checkAllProjects: false
          };
          cov_1jnbbceoql.s[99]++;

          self.searchUser = '';
          cov_1jnbbceoql.s[100]++;
          self.searchProject = '';
        } else {
          cov_1jnbbceoql.b[20][1]++;
          cov_1jnbbceoql.s[101]++;

          SweetAlert.swal({
            title: $translate.instant('BULK_PROFILE.ERROR_TITLE'),
            text: (cov_1jnbbceoql.b[23][0]++, response.message) || (cov_1jnbbceoql.b[23][1]++, $translate.instant('COMMON.ERROR')),
            type: 'error',
            confirmButtonText: $translate.instant('COMMON.VALIDATE')
          });
        }
      }, function (error) {
        cov_1jnbbceoql.f[25]++;
        cov_1jnbbceoql.s[102]++;

        self.isProcessing = false;
        cov_1jnbbceoql.s[103]++;
        SweetAlert.swal({
          title: $translate.instant('BULK_PROFILE.ERROR_TITLE'),
          text: $translate.instant('COMMON.ERROR'),
          type: 'error',
          confirmButtonText: $translate.instant('COMMON.VALIDATE')
        });
      });
    }
  };

  cov_1jnbbceoql.s[104]++;
  $scope.__labels = {
    EDIT: $translate.instant('COMMON.EDIT'),
    DELETE: $translate.instant('COMMON.DELETE'),
    USER: $translate.instant('G_U.ACTORLIST')
  };

  cov_1jnbbceoql.s[105]++;
  $scope.filter = {
    DisplayFilterForm: false,
    searchText: '',
    superUser: false,
    GroupsList: [],
    selectedGroups: [],
    selectedProfil: {},
    ProfilList: [],
    searchProfil: '',
    clone_profils_bksb: null,
    selectedAgencies: [],
    searchAgency: '',
    clone_listData_agence_bksb: null,
    selectedProject: {},
    searchProject: '',
    clone_projects_bksb: null,
    addProject: function addProject(item) {
      cov_1jnbbceoql.s[106]++;

      this.selectedProject[item.id] = !this.selectedProject[item.id];
      cov_1jnbbceoql.s[107]++;
      $scope.userManager.getAll();
    },
    selectAllProject: function selectAllProject() {
      cov_1jnbbceoql.s[108]++;

      for (var _iterator = $scope.userManager.listProjects, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var project = _ref;
        cov_1jnbbceoql.s[109]++;

        this.selectedProject[project.id] = true;
      }
      cov_1jnbbceoql.s[110]++;
      $scope.userManager.getAll();
    },
    unSelectedAllProject: function unSelectedAllProject() {
      cov_1jnbbceoql.s[111]++;

      for (var _iterator2 = $scope.userManager.listProjects, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
          if (_i2 >= _iterator2.length) break;
          _ref2 = _iterator2[_i2++];
        } else {
          _i2 = _iterator2.next();
          if (_i2.done) break;
          _ref2 = _i2.value;
        }

        var project = _ref2;
        cov_1jnbbceoql.s[112]++;

        this.selectedProject[project.id] = false;
      }
      cov_1jnbbceoql.s[113]++;
      $scope.userManager.getAll();
    },
    filtreProject: function filtreProject() {
      var _this = this;

      cov_1jnbbceoql.s[114]++;

      if (this.clone_projects_bksb == null) {
        cov_1jnbbceoql.b[24][0]++;
        cov_1jnbbceoql.s[115]++;

        this.clone_projects_bksb = angular.copy($scope.userManager.listProjects);
      } else {
        cov_1jnbbceoql.b[24][1]++;
      }
      cov_1jnbbceoql.s[116]++;
      if (this.searchProject != '') {
        cov_1jnbbceoql.b[25][0]++;
        cov_1jnbbceoql.s[117]++;

        $scope.userManager.listProjects = $scope.userManager.listProjects.filter(function (value) {
          cov_1jnbbceoql.f[26]++;
          cov_1jnbbceoql.s[118]++;

          if (value.id == 0) {
            cov_1jnbbceoql.b[26][0]++;
            cov_1jnbbceoql.s[119]++;

            return true;
          } else {
            cov_1jnbbceoql.b[26][1]++;
          }
          cov_1jnbbceoql.s[120]++;
          return value.LIBELLE_PROJET.toLowerCase().includes(_this.searchProject.toLowerCase());
        });
      } else {
        cov_1jnbbceoql.b[25][1]++;
        cov_1jnbbceoql.s[121]++;

        $scope.userManager.listProjects = angular.copy(this.clone_projects_bksb);
      }
    },
    getAllGroup: function getAllGroup() {
      cov_1jnbbceoql.s[122]++;

      $CRUDService.getAll('UserGroup', { get: 'all' }, function (data) {
        cov_1jnbbceoql.f[27]++;
        cov_1jnbbceoql.s[123]++;

        $scope.filter.GroupsList = data.map(function (value) {
          cov_1jnbbceoql.f[28]++;
          cov_1jnbbceoql.s[124]++;
          return {
            id: value.id,
            LABEL: value.LABEL,
            USERLIST: ((cov_1jnbbceoql.b[27][0]++, value.USERLIST) || (cov_1jnbbceoql.b[27][1]++, '')).split(';')
          };
        });
      });
    },
    addGroup: function addGroup(group) {
      var index = (cov_1jnbbceoql.s[125]++, this.selectedGroups.indexOf(group));
      cov_1jnbbceoql.s[126]++;
      if (index < 0) {
        cov_1jnbbceoql.b[28][0]++;
        cov_1jnbbceoql.s[127]++;

        this.selectedGroups.push(group);
      } else {
        cov_1jnbbceoql.b[28][1]++;
        cov_1jnbbceoql.s[128]++;

        this.selectedGroups.splice(index, 1);
      }
    },
    selectAllGroups: function selectAllGroups() {
      cov_1jnbbceoql.s[129]++;

      this.selectedGroups = $scope.filter.GroupsList.map(function (value) {
        cov_1jnbbceoql.f[29]++;
        cov_1jnbbceoql.s[130]++;
        return value;
      });
    },
    getAllProfil: function getAllProfil() {
      cov_1jnbbceoql.s[131]++;

      $CRUDService.getAll('Profils', { get: 'all' }, function (data) {
        cov_1jnbbceoql.f[30]++;
        cov_1jnbbceoql.s[132]++;

        $scope.filter.ProfilList = data.map(function (value) {
          cov_1jnbbceoql.f[31]++;
          cov_1jnbbceoql.s[133]++;
          return {
            id: value.id,
            LABEL_PROFIL: value.LABEL_PROFIL,
            USER_LIST: ((cov_1jnbbceoql.b[29][0]++, value.USER_LIST) || (cov_1jnbbceoql.b[29][1]++, '')).split(';')
          };
        });
      });
    },
    addProfil: function addProfil(profil) {
      cov_1jnbbceoql.s[134]++;

      this.selectedProfil[profil.id] = !this.selectedProfil[profil.id];
      cov_1jnbbceoql.s[135]++;
      $scope.userManager.getAll();
    },
    selectAllProfils: function selectAllProfils() {
      cov_1jnbbceoql.s[136]++;

      this.selectedProfil = this.ProfilList.map(function (value) {
        cov_1jnbbceoql.f[32]++;
        cov_1jnbbceoql.s[137]++;
        return value;
      });
    },
    filtreProfil: function filtreProfil() {
      var _this2 = this;

      cov_1jnbbceoql.s[138]++;

      if (this.clone_profils_bksb == null) {
        cov_1jnbbceoql.b[30][0]++;
        cov_1jnbbceoql.s[139]++;

        this.clone_profils_bksb = angular.copy($scope.userManager.predefinedGroup);
      } else {
        cov_1jnbbceoql.b[30][1]++;
      }
      cov_1jnbbceoql.s[140]++;
      if (this.searchProfil != '') {
        cov_1jnbbceoql.b[31][0]++;
        cov_1jnbbceoql.s[141]++;

        $scope.userManager.predefinedGroup = $scope.userManager.predefinedGroup.filter(function (value) {
          cov_1jnbbceoql.f[33]++;
          cov_1jnbbceoql.s[142]++;

          if (value.id == 0) {
            cov_1jnbbceoql.b[32][0]++;
            cov_1jnbbceoql.s[143]++;

            return true;
          } else {
            cov_1jnbbceoql.b[32][1]++;
          }
          cov_1jnbbceoql.s[144]++;
          return value.label.toLowerCase().includes(_this2.searchProfil.toLowerCase());
        });
      } else {
        cov_1jnbbceoql.b[31][1]++;
        cov_1jnbbceoql.s[145]++;

        $scope.userManager.predefinedGroup = angular.copy(this.clone_profils_bksb);
      }
    },
    addAgence: function addAgence(agency) {
      var index = (cov_1jnbbceoql.s[146]++, this.selectedAgencies.indexOf(agency.id));
      cov_1jnbbceoql.s[147]++;
      if (index < 0) {
        cov_1jnbbceoql.b[33][0]++;
        cov_1jnbbceoql.s[148]++;

        this.selectedAgencies.push(agency.id);
      } else {
        cov_1jnbbceoql.b[33][1]++;
        cov_1jnbbceoql.s[149]++;

        this.selectedAgencies.splice(index, 1);
      }
    },
    selectAllAgencies: function selectAllAgencies() {
      cov_1jnbbceoql.s[150]++;

      this.selectedAgencies = this.agencies.map(function (value) {
        cov_1jnbbceoql.f[34]++;
        cov_1jnbbceoql.s[151]++;
        return value.id;
      });
    },
    filtreAgency: function filtreAgency(event) {
      var _this3 = this;

      cov_1jnbbceoql.s[152]++;

      if (this.clone_listData_agence_bksb == null) {
        cov_1jnbbceoql.b[34][0]++;
        cov_1jnbbceoql.s[153]++;

        this.clone_listData_agence_bksb = angular.copy($scope.filter.agencies);
      } else {
        cov_1jnbbceoql.b[34][1]++;
      }
      cov_1jnbbceoql.s[154]++;
      if (this.searchAgency != '') {
        cov_1jnbbceoql.b[35][0]++;
        cov_1jnbbceoql.s[155]++;

        $scope.filter.agencies = $scope.filter.agencies.filter(function (value) {
          cov_1jnbbceoql.f[35]++;
          cov_1jnbbceoql.s[156]++;

          if (value.id == 0) {
            cov_1jnbbceoql.b[36][0]++;
            cov_1jnbbceoql.s[157]++;

            return true;
          } else {
            cov_1jnbbceoql.b[36][1]++;
          }
          cov_1jnbbceoql.s[158]++;
          return value.NAME_AG.toLowerCase().includes(_this3.searchAgency.toLowerCase());
        });
      } else {
        cov_1jnbbceoql.b[35][1]++;
        cov_1jnbbceoql.s[159]++;

        $scope.filter.agencies = angular.copy(this.clone_listData_agence_bksb);
      }
    },
    UnselectedAll: function UnselectedAll(condition) {
      cov_1jnbbceoql.s[160]++;

      switch (condition) {
        case 1:
          cov_1jnbbceoql.b[37][0]++;
          cov_1jnbbceoql.s[161]++;

          this.selectedGroups = [];
          cov_1jnbbceoql.s[162]++;
          break;
        case 2:
          cov_1jnbbceoql.b[37][1]++;
          cov_1jnbbceoql.s[163]++;

          this.selectedProfil = [];
          cov_1jnbbceoql.s[164]++;
          $scope.userManager.getAll();
          cov_1jnbbceoql.s[165]++;
          break;
        case 3:
          cov_1jnbbceoql.b[37][2]++;
          cov_1jnbbceoql.s[166]++;

          this.selectedAgencies = [];
          cov_1jnbbceoql.s[167]++;
          break;
        default:
          cov_1jnbbceoql.b[37][3]++;


      }
    },
    processFilter: function processFilter(value) {
      cov_1jnbbceoql.s[168]++;

      if ($scope.filter.selectedAgencies.length > 0) {
        cov_1jnbbceoql.b[38][0]++;
        cov_1jnbbceoql.s[169]++;

        if ($scope.filter.selectedAgencies.indexOf(value.ID_AGENCY) < 0) {
          cov_1jnbbceoql.b[39][0]++;
          cov_1jnbbceoql.s[170]++;

          return false;
        } else {
          cov_1jnbbceoql.b[39][1]++;
        }
      } else {
        cov_1jnbbceoql.b[38][1]++;
      }
      var rest = (cov_1jnbbceoql.s[171]++, $filter('filter')([value], { LOGIN: $scope.filter.searchText }));
      cov_1jnbbceoql.s[172]++;
      if (rest.length == 0) {
        cov_1jnbbceoql.b[40][0]++;
        cov_1jnbbceoql.s[173]++;

        rest = $filter('filter')([value], { NOMUSER: $scope.filter.searchText });
        cov_1jnbbceoql.s[174]++;
        if (rest.length == 0) {
          cov_1jnbbceoql.b[41][0]++;
          cov_1jnbbceoql.s[175]++;

          rest = $filter('filter')([value], { PRENOMUSER: $scope.filter.searchText });
          cov_1jnbbceoql.s[176]++;
          if (rest.length == 0) {
            cov_1jnbbceoql.b[42][0]++;
            cov_1jnbbceoql.s[177]++;

            return false;
          } else {
            cov_1jnbbceoql.b[42][1]++;
          }
        } else {
          cov_1jnbbceoql.b[41][1]++;
        }
      } else {
        cov_1jnbbceoql.b[40][1]++;
      }

      var profils = (cov_1jnbbceoql.s[178]++, Object.keys($scope.filter.selectedProfil).filter(function (key) {
        cov_1jnbbceoql.f[36]++;
        cov_1jnbbceoql.s[179]++;

        return $scope.filter.selectedProfil[key];
      }));

      cov_1jnbbceoql.s[180]++;
      if ($scope.filter.superUser) {
        cov_1jnbbceoql.b[43][0]++;
        cov_1jnbbceoql.s[181]++;

        if (profils.length == 0) {
          cov_1jnbbceoql.b[44][0]++;
          cov_1jnbbceoql.s[182]++;

          return value.TYPEUSER == 1;
        } else {
          cov_1jnbbceoql.b[44][1]++;
        }
        cov_1jnbbceoql.s[183]++;
        return true;
      } else {
        cov_1jnbbceoql.b[43][1]++;
      }

      cov_1jnbbceoql.s[184]++;
      if (profils.length > 0) {
        cov_1jnbbceoql.b[45][0]++;
        cov_1jnbbceoql.s[185]++;

        if (value.TYPEUSER == 1) {
          cov_1jnbbceoql.b[46][0]++;
          cov_1jnbbceoql.s[186]++;

          return false;
        } else {
          cov_1jnbbceoql.b[46][1]++;
        }
      } else {
        cov_1jnbbceoql.b[45][1]++;
      }

      cov_1jnbbceoql.s[187]++;
      return true;
    }
  };

  cov_1jnbbceoql.s[188]++;
  $scope.autoCompleteFunctionOptions = {
    minimumChars: 0,
    containerCssClass: 'white-bg',
    selectedCssClass: 'selected-item-auto-complete',
    noMatchTemplateEnabled: false,
    activateOnFocus: true,
    data: function data(searchText) {
      var data = (cov_1jnbbceoql.s[189]++, $scope.userManager.listUser);
      var _ = (cov_1jnbbceoql.s[190]++, []);
      cov_1jnbbceoql.s[191]++;
      for (var _iterator3 = data, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref3 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref3 = _i3.value;
        }

        var user = _ref3;
        cov_1jnbbceoql.s[192]++;

        if (_.indexOf((cov_1jnbbceoql.b[48][0]++, user.FUNCTION_USER) || (cov_1jnbbceoql.b[48][1]++, '')) < 0) {
          cov_1jnbbceoql.b[47][0]++;
          cov_1jnbbceoql.s[193]++;

          if (((cov_1jnbbceoql.b[50][0]++, user.FUNCTION_USER) || (cov_1jnbbceoql.b[50][1]++, '')).trim() != '') {
            cov_1jnbbceoql.b[49][0]++;
            cov_1jnbbceoql.s[194]++;

            _.push(user.FUNCTION_USER);
          } else {
            cov_1jnbbceoql.b[49][1]++;
          }
        } else {
          cov_1jnbbceoql.b[47][1]++;
        }
      }
      cov_1jnbbceoql.s[195]++;
      return _;
    }
  };

  cov_1jnbbceoql.s[196]++;
  $scope.userManager = {
    listView: localStorage.getItem('USER_VIEW') === '1',
    changeView: function changeView() {
      cov_1jnbbceoql.s[197]++;

      this.listView = !this.listView;
      cov_1jnbbceoql.s[198]++;
      localStorage.setItem('USER_VIEW', this.listView ? (cov_1jnbbceoql.b[51][0]++, '1') : (cov_1jnbbceoql.b[51][1]++, '0'));
    },
    isUserAdminInPortfolio: function isUserAdminInPortfolio(portfolioId) {
      cov_1jnbbceoql.s[199]++;

      if ((cov_1jnbbceoql.b[53][0]++, !this.editingUser) || (cov_1jnbbceoql.b[53][1]++, !this.editingUser.GROUP_USER)) {
        cov_1jnbbceoql.b[52][0]++;
        cov_1jnbbceoql.s[200]++;

        return false;
      } else {
        cov_1jnbbceoql.b[52][1]++;
      }
      var userProfile = (cov_1jnbbceoql.s[201]++, this.editingUser.GROUP_USER[portfolioId]);
      cov_1jnbbceoql.s[202]++;
      return (cov_1jnbbceoql.b[54][0]++, userProfile) && ((cov_1jnbbceoql.b[54][1]++, userProfile.type === "6") || (cov_1jnbbceoql.b[54][2]++, userProfile) && (cov_1jnbbceoql.b[54][3]++, userProfile.type === 6));
    },
    shouldDisableProfileSelect: function shouldDisableProfileSelect(item) {
      cov_1jnbbceoql.s[203]++;

      if (!item) {
        cov_1jnbbceoql.b[55][0]++;
        cov_1jnbbceoql.s[204]++;

        return false;
      } else {
        cov_1jnbbceoql.b[55][1]++;
      }
      cov_1jnbbceoql.s[205]++;

      if (item.PORTFOLIO == 1) {
        cov_1jnbbceoql.b[56][0]++;
        cov_1jnbbceoql.s[206]++;

        return this.isUserAdminInPortfolio(item.id);
      } else {
        cov_1jnbbceoql.b[56][1]++;
      }
      cov_1jnbbceoql.s[207]++;

      if (item.ID_PARENT) {
        cov_1jnbbceoql.b[57][0]++;
        cov_1jnbbceoql.s[208]++;

        return this.isUserAdminInPortfolio(item.ID_PARENT);
      } else {
        cov_1jnbbceoql.b[57][1]++;
      }
      cov_1jnbbceoql.s[209]++;
      return false;
    },

    predefinedGroup: [{
      id: 6,
      label: $translate.instant('G_U.ADMIN_USER')
    }, {
      id: 1,
      label: $translate.instant('G_U.STANDARD_USER')
    }, {
      id: 2,
      label: $translate.instant('G_U.VIEW_USER')
    }, {
      id: 5,
      label: $translate.instant('G_U.COLLECT_USER')
    }, {
      id: 4,
      label: $translate.instant('G_U.CUSTOM_USER')
    }, {
      id: 3,
      label: $translate.instant('G_U.NO_ACCESS')
    }],
    predefinedPortfolioGroup: [{
      id: 6,
      label: $translate.instant('G_U.ADMIN_USER')
    }, {
      id: 1,
      label: $translate.instant('G_U.STANDARD_USER')
    }, {
      id: 2,
      label: $translate.instant('G_U.VIEW_USER')
    }, {
      id: 5,
      label: $translate.instant('G_U.COLLECT_USER')
    }, {
      id: 4,
      label: $translate.instant('G_U.CUSTOM_USER')
    }, {
      id: 3,
      label: $translate.instant('G_U.NO_ACCESS_PORTFOLIO')
    }, {
      id: 7,
      label: $translate.instant('G_U.NO_ACCESS')
    }],

    edition_tab: 1,
    setLock: function setLock(item, type) {
      cov_1jnbbceoql.s[210]++;

      item.LOCK_USER = type;
      cov_1jnbbceoql.s[211]++;
      $CRUDService.save(PATH, { id: item.id, action: 'lock', type: type });
      cov_1jnbbceoql.s[212]++;
      for (var _iterator4 = $scope.userManager.listUser, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
          if (_i4 >= _iterator4.length) break;
          _ref4 = _iterator4[_i4++];
        } else {
          _i4 = _iterator4.next();
          if (_i4.done) break;
          _ref4 = _i4.value;
        }

        var user = _ref4;
        cov_1jnbbceoql.s[213]++;

        if (user.id == item.id) {
          cov_1jnbbceoql.b[58][0]++;
          cov_1jnbbceoql.s[214]++;

          user.LOCK_USER = type;
          cov_1jnbbceoql.s[215]++;
          break;
        } else {
          cov_1jnbbceoql.b[58][1]++;
        }
      }
    },

    listAgencyUser: [],
    changeAgency: function changeAgency(type) {
      cov_1jnbbceoql.s[216]++;

      if (!type) {
        cov_1jnbbceoql.b[59][0]++;
        cov_1jnbbceoql.s[217]++;

        if (this.agency) {
          cov_1jnbbceoql.b[60][0]++;
          cov_1jnbbceoql.s[218]++;

          if (this.agency.id <= 0) {
            cov_1jnbbceoql.b[61][0]++;
            cov_1jnbbceoql.s[219]++;

            this.agency = $scope.agencies[$scope.agencies.length - 1];
          } else {
            cov_1jnbbceoql.b[61][1]++;
          }
        } else {
          cov_1jnbbceoql.b[60][1]++;
          cov_1jnbbceoql.s[220]++;

          this.agency = $scope.agencies[$scope.agencies.length - 1];
        }

        cov_1jnbbceoql.s[221]++;
        if (this.agency.id <= 0) {
          cov_1jnbbceoql.b[62][0]++;
          cov_1jnbbceoql.s[222]++;

          this.listAgencyUser = this.listUser;
        } else {
          cov_1jnbbceoql.b[62][1]++;
          cov_1jnbbceoql.s[223]++;

          this.listAgencyUser = $filter('filter')(this.listUser, { ID_AGENCY: this.agency.id }, true);
        }
      } else {
          cov_1jnbbceoql.b[59][1]++;
          cov_1jnbbceoql.s[224]++;
          if ($scope.userManager.editingUser.ID_AGENCY) {
            cov_1jnbbceoql.b[63][0]++;
            cov_1jnbbceoql.s[225]++;

            if ($scope.userManager.editingUser.ID_AGENCY.id <= 0) {
              cov_1jnbbceoql.b[64][0]++;
              cov_1jnbbceoql.s[226]++;

              $scope.userManager.editingUser.ID_AGENCY = $scope.agencies[$scope.agencies.length - 1];
            } else {
              cov_1jnbbceoql.b[64][1]++;
            }
          } else {
            cov_1jnbbceoql.b[63][1]++;
            cov_1jnbbceoql.s[227]++;

            this.agency = $scope.agencies[$scope.agencies.length - 1];
          }
        }
    },
    getAgencies: function getAgencies() {
      cov_1jnbbceoql.s[228]++;

      if (!this.agency) {
        cov_1jnbbceoql.b[65][0]++;
        cov_1jnbbceoql.s[229]++;

        return this.listUser;
      } else {
        cov_1jnbbceoql.b[65][1]++;
      }
      cov_1jnbbceoql.s[230]++;
      if (this.agency.id <= 0) {
        cov_1jnbbceoql.b[66][0]++;
        cov_1jnbbceoql.s[231]++;

        return this.listUser;
      } else {
        cov_1jnbbceoql.b[66][1]++;
      }
      var data = (cov_1jnbbceoql.s[232]++, []);

      cov_1jnbbceoql.s[233]++;
      for (var _iterator5 = this.listUser, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray5) {
          if (_i5 >= _iterator5.length) break;
          _ref5 = _iterator5[_i5++];
        } else {
          _i5 = _iterator5.next();
          if (_i5.done) break;
          _ref5 = _i5.value;
        }

        var el = _ref5;
        cov_1jnbbceoql.s[234]++;

        if (el.ID_AGENCY == this.agency.id) {
          cov_1jnbbceoql.b[67][0]++;
          cov_1jnbbceoql.s[235]++;

          data.push(el);
        } else {
          cov_1jnbbceoql.b[67][1]++;
        }
      }
      cov_1jnbbceoql.s[236]++;
      return data;
    },

    isedited: false,
    editingUser: null,
    listUser: [],
    editLoading: false,
    picteurUpdated: null,
    actorList: [],
    actorListLink: [],
    error: {
      psw: false,
      email: false
    },
    openValidation: function openValidation(item) {
      cov_1jnbbceoql.s[237]++;

      $scope.selectedValidation = item;
      cov_1jnbbceoql.s[238]++;
      $uibModal.open({
        templateUrl: 'app/views/user/validation/view.html',
        controller: UserValidationCtrl,
        scope: $scope,
        size: 'md_',
        windowClass: 'animated fadeInRight left-modal '
      });
    },
    getUserMax: function getUserMax() {
      cov_1jnbbceoql.s[239]++;

      $CRUDService.getAll(PATH, { get: 'nb_user' }, function (data) {
        cov_1jnbbceoql.f[37]++;
        cov_1jnbbceoql.s[240]++;

        $scope.userManager.userMax = data;
      });
    },
    getAll: function getAll() {
      cov_1jnbbceoql.s[241]++;

      $scope.isloading = true;

      var projets = (cov_1jnbbceoql.s[242]++, Object.keys($scope.filter.selectedProject).filter(function (key) {
        cov_1jnbbceoql.f[38]++;
        cov_1jnbbceoql.s[243]++;

        return $scope.filter.selectedProject[key];
      }));

      var profils = (cov_1jnbbceoql.s[244]++, Object.keys($scope.filter.selectedProfil).filter(function (key) {
        cov_1jnbbceoql.f[39]++;
        cov_1jnbbceoql.s[245]++;

        return $scope.filter.selectedProfil[key];
      }));
      cov_1jnbbceoql.s[246]++;
      $CRUDService.getAll(PATH, { get: 'all', projet: projets.length > 0 ? (cov_1jnbbceoql.b[68][0]++, angular.toJson(projets)) : (cov_1jnbbceoql.b[68][1]++, undefined), profil: profils.length > 0 ? (cov_1jnbbceoql.b[69][0]++, angular.toJson(profils)) : (cov_1jnbbceoql.b[69][1]++, undefined) }, function (data) {
        cov_1jnbbceoql.f[40]++;
        cov_1jnbbceoql.s[247]++;

        for (var _iterator6 = data, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
          var _ref6;

          if (_isArray6) {
            if (_i6 >= _iterator6.length) break;
            _ref6 = _iterator6[_i6++];
          } else {
            _i6 = _iterator6.next();
            if (_i6.done) break;
            _ref6 = _i6.value;
          }

          var el = _ref6;
          cov_1jnbbceoql.s[248]++;

          el.TYPEUSER = el.TYPEUSER == 1;
          cov_1jnbbceoql.s[249]++;
          el.LOCK_USER = el.LOCK_USER == 1;
          cov_1jnbbceoql.s[250]++;
          el.picture = $deltahttp.getUserPicture(el.id);
        }
        cov_1jnbbceoql.s[251]++;
        $scope.userManager.listUser = $rootScope.connectedUser.finalSuperAdmin ? (cov_1jnbbceoql.b[70][0]++, data) : (cov_1jnbbceoql.b[70][1]++, data.filter(function (user) {
          cov_1jnbbceoql.f[41]++;
          cov_1jnbbceoql.s[252]++;

          return user.TYPEUSER != 1;
        }));
        cov_1jnbbceoql.s[253]++;
        $scope.userManager.changeAgency();
        cov_1jnbbceoql.s[254]++;
        $scope.isloading = false;
      });
      cov_1jnbbceoql.s[255]++;
      this.getUserMax();
    },
    newItem: function newItem() {
      cov_1jnbbceoql.s[256]++;

      this.edit({
        NOMUSER: '',
        PRENOMUSER: '',
        LOGIN: '',
        PASSWORD: '',
        SEXE: '1',
        PORTFOLIO: 1,
        TYPEUSER: false,
        MIDDLE_SUP: false,
        id: 0,
        ID_AGENCY: 0
      });
    },
    openBulkProfile: function openBulkProfile() {
      cov_1jnbbceoql.s[257]++;

      $scope.showBulkProfile = true;
    },
    updateUserInformation: function updateUserInformation() {
      cov_1jnbbceoql.s[258]++;

      if ((cov_1jnbbceoql.b[72][0]++, this.editingUser.id == 0) && (cov_1jnbbceoql.b[72][1]++, this.editingUser.IDACTEURS.id > 0)) {
        cov_1jnbbceoql.b[71][0]++;
        cov_1jnbbceoql.s[259]++;

        this.editingUser.PRENOMUSER = this.editingUser.IDACTEURS.PRENOM_ACTEUR;
        cov_1jnbbceoql.s[260]++;
        this.editingUser.NOMUSER = this.editingUser.IDACTEURS.NOM_ACTEUR;
        cov_1jnbbceoql.s[261]++;
        this.editingUser.LOGIN = this.editingUser.IDACTEURS.EMAIL_ACTEUR;
        var d = (cov_1jnbbceoql.s[262]++, $filter('filter')($scope.agencies, { id: this.editingUser.IDACTEURS.ID_AGENCY }));
        cov_1jnbbceoql.s[263]++;
        if (d.length > 0) {
          cov_1jnbbceoql.b[73][0]++;
          cov_1jnbbceoql.s[264]++;

          this.editingUser.ID_AGENCY = d[0];
        } else {
          cov_1jnbbceoql.b[73][1]++;
        }
        cov_1jnbbceoql.s[265]++;

        this.editingUser.photo = true;
      } else {
        cov_1jnbbceoql.b[71][1]++;
        cov_1jnbbceoql.s[266]++;

        this.editingUser.photo = false;
      }
    },
    __filterActor: function __filterActor(value) {
      cov_1jnbbceoql.s[267]++;

      if (value.id == -100) {
        cov_1jnbbceoql.b[74][0]++;
        cov_1jnbbceoql.s[268]++;

        return true;
      } else {
        cov_1jnbbceoql.b[74][1]++;
      }
      cov_1jnbbceoql.s[269]++;
      if (value.id < 0) {
        cov_1jnbbceoql.b[75][0]++;
        cov_1jnbbceoql.s[270]++;

        return false;
      } else {
        cov_1jnbbceoql.b[75][1]++;
      }
      cov_1jnbbceoql.s[271]++;
      if ($scope.userManager.editingUser.IDACTEURS == value.id) {
        cov_1jnbbceoql.b[76][0]++;
        cov_1jnbbceoql.s[272]++;

        return true;
      } else {
        cov_1jnbbceoql.b[76][1]++;
      }
      cov_1jnbbceoql.s[273]++;
      for (var _iterator7 = $scope.userManager.listUser, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
          if (_i7 >= _iterator7.length) break;
          _ref7 = _iterator7[_i7++];
        } else {
          _i7 = _iterator7.next();
          if (_i7.done) break;
          _ref7 = _i7.value;
        }

        var el = _ref7;
        cov_1jnbbceoql.s[274]++;

        if (el.IDACTEURS == value.id) {
          cov_1jnbbceoql.b[77][0]++;
          cov_1jnbbceoql.s[275]++;

          return false;
        } else {
          cov_1jnbbceoql.b[77][1]++;
        }
      }
      cov_1jnbbceoql.s[276]++;
      return true;
    },
    edit: function edit(item) {
      var _this4 = this;

      cov_1jnbbceoql.s[277]++;

      this.error = {
        psw: false,
        email: false
      };

      cov_1jnbbceoql.s[278]++;
      this.editingUser = angular.copy(item);
      cov_1jnbbceoql.s[279]++;
      if (!this.editingUser.GROUP_USER) {
        cov_1jnbbceoql.b[78][0]++;
        cov_1jnbbceoql.s[280]++;

        this.editingUser.GROUP_USER = {};
      } else {
        cov_1jnbbceoql.b[78][1]++;

        var group = (cov_1jnbbceoql.s[281]++, angular.fromJson(this.editingUser.GROUP_USER));
        cov_1jnbbceoql.s[282]++;
        this.editingUser.GROUP_USER = angular.isArray(group) ? (cov_1jnbbceoql.b[79][0]++, {}) : (cov_1jnbbceoql.b[79][1]++, group);
      }

      cov_1jnbbceoql.s[283]++;
      this.editingUser.GROUP_USER = null;
      var right = (cov_1jnbbceoql.s[284]++, {});

      var defaultGroup = (cov_1jnbbceoql.s[285]++, this.portfolioPredefinedGroup.find(function (i) {
        cov_1jnbbceoql.f[42]++;
        cov_1jnbbceoql.s[286]++;

        return i.type < 0;
      }));

      cov_1jnbbceoql.s[287]++;
      for (var _iterator8 = $scope.userManager.listProjects, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray8) {
          if (_i8 >= _iterator8.length) break;
          _ref8 = _iterator8[_i8++];
        } else {
          _i8 = _iterator8.next();
          if (_i8.done) break;
          _ref8 = _i8.value;
        }

        var project = _ref8;
        cov_1jnbbceoql.s[288]++;

        right[project.id] = defaultGroup;
      }

      cov_1jnbbceoql.s[289]++;
      $CRUDService.getAll(PATH_PROFIL, { id: this.editingUser.id, get: 'all_by_user' }, function (data) {
        cov_1jnbbceoql.f[43]++;
        cov_1jnbbceoql.s[290]++;

        var _loop = function _loop() {
          if (_isArray9) {
            if (_i9 >= _iterator9.length) return 'break';
            _ref9 = _iterator9[_i9++];
          } else {
            _i9 = _iterator9.next();
            if (_i9.done) return 'break';
            _ref9 = _i9.value;
          }

          var it = _ref9;
          cov_1jnbbceoql.s[291]++;

          right[it.ID_PROJET] = _this4.portfolioPredefinedGroup.find(function (i) {
            cov_1jnbbceoql.f[44]++;
            cov_1jnbbceoql.s[292]++;

            return i.id == it.ID_PROFIL;
          });
        };

        for (var _iterator9 = data, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
          var _ref9;

          var _ret = _loop();

          if (_ret === 'break') break;
        }
        cov_1jnbbceoql.s[293]++;
        _this4.editingUser.GROUP_USER = right;
      });

      cov_1jnbbceoql.s[294]++;
      this.editingUser.PORTFOLIO = this.editingUser.PORTFOLIO == 1;
      cov_1jnbbceoql.s[295]++;
      this.editingUser.MIDDLE_SUP = this.editingUser.MIDDLE_SUP == 1;
      cov_1jnbbceoql.s[296]++;
      this.actorList = $filter('filter')($scope.listData_actors_bksb, this.__filterActor);
      cov_1jnbbceoql.s[297]++;
      this.editingUser.IDACTEURS = $filter('filter')($scope.listData_actors_bksb, { id: this.editingUser.IDACTEURS }, true)[0];
      cov_1jnbbceoql.s[298]++;
      if (!this.editingUser.IDACTEURS) {
        cov_1jnbbceoql.b[80][0]++;
        cov_1jnbbceoql.s[299]++;

        this.editingUser.IDACTEURS = (cov_1jnbbceoql.b[81][0]++, this.actorList[0]) || (cov_1jnbbceoql.b[81][1]++, { id: 0 });
      } else {
        cov_1jnbbceoql.b[80][1]++;
      }

      cov_1jnbbceoql.s[300]++;
      this.editingUser.ID_AGENCY = $filter('filter')($scope.agencies, { id: this.editingUser.ID_AGENCY }, true)[0];
      cov_1jnbbceoql.s[301]++;
      if (!this.editingUser.ID_AGENCY) {
        cov_1jnbbceoql.b[82][0]++;
        cov_1jnbbceoql.s[302]++;

        this.editingUser.ID_AGENCY = $scope.agencies[$scope.agencies.length - 0];
      } else {
        cov_1jnbbceoql.b[82][1]++;
      }

      cov_1jnbbceoql.s[303]++;
      if ((cov_1jnbbceoql.b[84][0]++, !this.editingUser.EXPIRE_DATE) || (cov_1jnbbceoql.b[84][1]++, this.editingUser.EXPIRE_DATE < '1970-01-01')) {
        cov_1jnbbceoql.b[83][0]++;
        cov_1jnbbceoql.s[304]++;

        this.editingUser.EXPIRE_DATE = Date.newDate();
        cov_1jnbbceoql.s[305]++;
        this.editingUser.EXPIRE_DATE.setFullYear(this.editingUser.EXPIRE_DATE.getFullYear() + 1);
      } else {
        cov_1jnbbceoql.b[83][1]++;
        cov_1jnbbceoql.s[306]++;

        this.editingUser.EXPIRE_DATE = Date.newDate(this.editingUser.EXPIRE_DATE);
      }

      cov_1jnbbceoql.s[307]++;
      if (this.editingUser.id != 0) {
        cov_1jnbbceoql.b[85][0]++;
        cov_1jnbbceoql.s[308]++;

        this.editingUser.PASSWORD = '&&&&&&&&&&';
      } else {
        cov_1jnbbceoql.b[85][1]++;
      }
      cov_1jnbbceoql.s[309]++;
      this.editingUser.CONFPSW = this.editingUser.PASSWORD;
      cov_1jnbbceoql.s[310]++;
      this.editingUser.DISPLAY_MAP = this.editingUser.DISPLAY_MAP == 1;
      cov_1jnbbceoql.s[311]++;
      this.editingUser.DISPLAY_DASHBOARD = this.editingUser.DISPLAY_DASHBOARD == 1;

      cov_1jnbbceoql.s[312]++;
      this.editingUser.linkediting = $deltahttp.getUserPicture(this.editingUser.id, new Date().getTime());
      cov_1jnbbceoql.s[313]++;

      this.picteurUpdated = null;
    },
    cancelItem: function cancelItem() {
      cov_1jnbbceoql.s[314]++;

      this.editingUser = null;
    },
    validate: function validate() {
      cov_1jnbbceoql.s[315]++;

      console.log('Editing User : ', $scope.userManager.editingUser);
      cov_1jnbbceoql.s[316]++;
      $scope.userManager.error = {
        psw: false,
        firstName: false,
        email: false,
        emailRequired: false,
        conf: false
      };

      cov_1jnbbceoql.s[317]++;
      $scope.userManager.editingUser.MIDDLE_SUP = this.editingUser.MIDDLE_SUP ? (cov_1jnbbceoql.b[86][0]++, 1) : (cov_1jnbbceoql.b[86][1]++, 0);
      cov_1jnbbceoql.s[318]++;
      $scope.userManager.editingUser.LOGIN = ((cov_1jnbbceoql.b[87][0]++, $scope.userManager.editingUser.LOGIN) || (cov_1jnbbceoql.b[87][1]++, '')).trim();
      cov_1jnbbceoql.s[319]++;
      $scope.userManager.editingUser.PRENOMUSER = ((cov_1jnbbceoql.b[88][0]++, $scope.userManager.editingUser.PRENOMUSER) || (cov_1jnbbceoql.b[88][1]++, '')).trim();
      cov_1jnbbceoql.s[320]++;
      if ($scope.userManager.editingUser.LOGIN === '') {
        cov_1jnbbceoql.b[89][0]++;
        cov_1jnbbceoql.s[321]++;

        this.error.emailRequired = true;
        cov_1jnbbceoql.s[322]++;
        $scope.userManager.edition_tab = 1;
        cov_1jnbbceoql.s[323]++;
        return;
      } else {
        cov_1jnbbceoql.b[89][1]++;
      }

      cov_1jnbbceoql.s[324]++;
      if ($scope.userManager.editingUser.PRENOMUSER === '') {
        cov_1jnbbceoql.b[90][0]++;
        cov_1jnbbceoql.s[325]++;

        this.error.firstName = true;
        cov_1jnbbceoql.s[326]++;
        $scope.userManager.edition_tab = 1;
        cov_1jnbbceoql.s[327]++;
        return;
      } else {
        cov_1jnbbceoql.b[90][1]++;
      }

      var dbl = (cov_1jnbbceoql.s[328]++, $scope.userManager.listUser.find(function (cUser) {
        cov_1jnbbceoql.f[45]++;
        cov_1jnbbceoql.s[329]++;

        return (cov_1jnbbceoql.b[91][0]++, cUser.id != $scope.userManager.editingUser.id) && (cov_1jnbbceoql.b[91][1]++, cUser.LOGIN.toLowerCase() == $scope.userManager.editingUser.LOGIN.toLowerCase());
      }));

      cov_1jnbbceoql.s[330]++;
      if (dbl) {
        cov_1jnbbceoql.b[92][0]++;
        cov_1jnbbceoql.s[331]++;

        this.error.email = true;
        cov_1jnbbceoql.s[332]++;
        $scope.userManager.edition_tab = 1;
        cov_1jnbbceoql.s[333]++;
        return;
      } else {
        cov_1jnbbceoql.b[92][1]++;
      }

      cov_1jnbbceoql.s[334]++;

      if ($scope.userManager.editingUser.PASSWORD.length < 8) {
        cov_1jnbbceoql.b[93][0]++;
        cov_1jnbbceoql.s[335]++;

        this.error.psw = true;
        cov_1jnbbceoql.s[336]++;
        $scope.userManager.edition_tab = 1;
        cov_1jnbbceoql.s[337]++;
        return;
      } else {
        cov_1jnbbceoql.b[93][1]++;
      }
      cov_1jnbbceoql.s[338]++;
      if ($scope.userManager.editingUser.PASSWORD !== $scope.userManager.editingUser.CONFPSW) {
        cov_1jnbbceoql.b[94][0]++;
        cov_1jnbbceoql.s[339]++;

        this.error.conf = true;
        cov_1jnbbceoql.s[340]++;
        $scope.userManager.edition_tab = 1;
        cov_1jnbbceoql.s[341]++;
        return;
      } else {
        cov_1jnbbceoql.b[94][1]++;
      }
      var user = (cov_1jnbbceoql.s[342]++, angular.copy($scope.userManager.editingUser));
      cov_1jnbbceoql.s[343]++;
      user.LOGIN = $scope.userManager.editingUser.LOGIN.toLowerCase();
      cov_1jnbbceoql.s[344]++;

      user.PORTFOLIO = 1;
      cov_1jnbbceoql.s[345]++;
      user.IDACTEURS = user.IDACTEURS.id;
      cov_1jnbbceoql.s[346]++;
      if (user.IDACTEURS < 0) {
        cov_1jnbbceoql.b[95][0]++;
        cov_1jnbbceoql.s[347]++;

        user.IDACTEURS = 0;
      } else {
        cov_1jnbbceoql.b[95][1]++;
      }
      cov_1jnbbceoql.s[348]++;
      if (user.ID_AGENCY) {
        cov_1jnbbceoql.b[96][0]++;
        cov_1jnbbceoql.s[349]++;

        user.ID_AGENCY = user.ID_AGENCY.id;
      } else {
        cov_1jnbbceoql.b[96][1]++;
        cov_1jnbbceoql.s[350]++;

        user.ID_AGENCY = 0;
      }
      cov_1jnbbceoql.s[351]++;
      if (user.ID_AGENCY <= 0) {
        cov_1jnbbceoql.b[97][0]++;
        cov_1jnbbceoql.s[352]++;

        user.ID_AGENCY = 0;
      } else {
        cov_1jnbbceoql.b[97][1]++;
      }

      cov_1jnbbceoql.s[353]++;
      if (user.EXPIRE_DATE) {
        cov_1jnbbceoql.b[98][0]++;
        cov_1jnbbceoql.s[354]++;

        user.EXPIRE_DATE = $deltadate.format(user.EXPIRE_DATE, 'yyyy-mm-dd');
      } else {
        cov_1jnbbceoql.b[98][1]++;
      }
      cov_1jnbbceoql.s[355]++;
      if (user.GROUP_USER) {
        cov_1jnbbceoql.b[99][0]++;
        cov_1jnbbceoql.s[356]++;

        if (angular.isObject(user.GROUP_USER)) {
          cov_1jnbbceoql.b[100][0]++;
          cov_1jnbbceoql.s[357]++;

          for (var key in user.GROUP_USER) {
            cov_1jnbbceoql.s[358]++;

            if (!user.GROUP_USER.hasOwnProperty(key)) {
              cov_1jnbbceoql.b[101][0]++;
              cov_1jnbbceoql.s[359]++;

              continue;
            } else {
              cov_1jnbbceoql.b[101][1]++;
            }
            cov_1jnbbceoql.s[360]++;
            if (!user.GROUP_USER[key]) {
              cov_1jnbbceoql.b[102][0]++;
              cov_1jnbbceoql.s[361]++;

              continue;
            } else {
              cov_1jnbbceoql.b[102][1]++;
            }
            cov_1jnbbceoql.s[362]++;
            if (user.GROUP_USER[key].id < 0) {
              cov_1jnbbceoql.b[103][0]++;
              cov_1jnbbceoql.s[363]++;

              continue;
            } else {
              cov_1jnbbceoql.b[103][1]++;
            }
            cov_1jnbbceoql.s[364]++;
            user.GROUP_USER[key] = user.GROUP_USER[key].id;
          }
        } else {
          cov_1jnbbceoql.b[100][1]++;
        }
      } else {
        cov_1jnbbceoql.b[99][1]++;
      }

      cov_1jnbbceoql.s[365]++;
      user.DISPLAY_MAP = user.DISPLAY_MAP ? (cov_1jnbbceoql.b[104][0]++, 1) : (cov_1jnbbceoql.b[104][1]++, 0);
      cov_1jnbbceoql.s[366]++;
      user.DISPLAY_DASHBOARD = user.DISPLAY_DASHBOARD ? (cov_1jnbbceoql.b[105][0]++, 1) : (cov_1jnbbceoql.b[105][1]++, 0);

      cov_1jnbbceoql.s[367]++;
      $CRUDService.save(PATH, { action: 'miseAJourAdmin', valeur: $filter('json')(user) }, function (data) {
        cov_1jnbbceoql.f[46]++;
        cov_1jnbbceoql.s[368]++;

        $scope.userManager.cancelItem();
        cov_1jnbbceoql.s[369]++;
        if (data == -2) {
          cov_1jnbbceoql.b[106][0]++;
          cov_1jnbbceoql.s[370]++;

          $scope.userManager.edition_tab = 1;
          cov_1jnbbceoql.s[371]++;
          return;
        } else {
          cov_1jnbbceoql.b[106][1]++;
        }
        cov_1jnbbceoql.s[372]++;
        $scope.userManager.getAll();
      });
    },
    deleteItem: function deleteItem(item) {
      cov_1jnbbceoql.s[373]++;

      SweetAlert.swal({
        title: $translate.instant('COMMON.CONFIRM'),

        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#c8c8c8',

        confirmButtonText: $translate.instant('COMMON.NO'),
        cancelButtonText: $translate.instant('COMMON.YES'),
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isconfirm) {
        cov_1jnbbceoql.f[47]++;
        cov_1jnbbceoql.s[374]++;

        if (isconfirm) {
          cov_1jnbbceoql.b[107][0]++;
          cov_1jnbbceoql.s[375]++;

          return;
        } else {
          cov_1jnbbceoql.b[107][1]++;
        }
        cov_1jnbbceoql.s[376]++;
        $scope.isloading = true;
        cov_1jnbbceoql.s[377]++;
        $CRUDService.delet(PATH, { action: 'delete', valeur: $filter('json')({ id: item.id, LOGIN: item.LOGIN, CODE_ESPACE: item.CODE_ESPACE }) }, function (data) {
          cov_1jnbbceoql.f[48]++;
          cov_1jnbbceoql.s[378]++;

          if (data < 0) {
            cov_1jnbbceoql.b[108][0]++;
            cov_1jnbbceoql.s[379]++;

            SweetAlert.swal({
              title: $translate.instant('COMMON.ERROR_DELETE'),
              text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
            });
            cov_1jnbbceoql.s[380]++;
            $scope.isloading = false;
            cov_1jnbbceoql.s[381]++;
            return;
          } else {
            cov_1jnbbceoql.b[108][1]++;
          }
          cov_1jnbbceoql.s[382]++;
          $scope.userManager.editingUser = null;
          cov_1jnbbceoql.s[383]++;
          $scope.userManager.getAll();
        });
      });
    },
    listactor: function listactor(item) {
      cov_1jnbbceoql.s[384]++;

      this.userSelected = item;

      cov_1jnbbceoql.s[385]++;
      this.actorListLink = [];
      cov_1jnbbceoql.s[386]++;
      for (var _iterator10 = $scope.listData_actors_bksb, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray10) {
          if (_i10 >= _iterator10.length) break;
          _ref10 = _iterator10[_i10++];
        } else {
          _i10 = _iterator10.next();
          if (_i10.done) break;
          _ref10 = _i10.value;
        }

        var el = _ref10;
        cov_1jnbbceoql.s[387]++;

        if (el.id < 1) {
          cov_1jnbbceoql.b[109][0]++;
          cov_1jnbbceoql.s[388]++;

          continue;
        } else {
          cov_1jnbbceoql.b[109][1]++;
        }
        var checkedvar = (cov_1jnbbceoql.s[389]++, false);
        cov_1jnbbceoql.s[390]++;
        if (item.LIST_ACTEURS != null) {
          cov_1jnbbceoql.b[110][0]++;
          cov_1jnbbceoql.s[391]++;

          checkedvar = item.LIST_ACTEURS.replace(el.id, '') != item.LIST_ACTEURS;
        } else {
          cov_1jnbbceoql.b[110][1]++;
        }
        cov_1jnbbceoql.s[392]++;
        this.actorListLink.push({
          name: el.FONCTION_ACTEUR + ' (' + el.CODE_ACTEUR + ')',
          id: el.id,
          checked: checkedvar
        });
      }
      cov_1jnbbceoql.s[393]++;
      $scope.step = 3;
    },
    cancelList: function cancelList() {
      cov_1jnbbceoql.s[394]++;

      this.actorListLink = [];
      cov_1jnbbceoql.s[395]++;
      $scope.step = 1;
    },
    valideList: function valideList() {
      var tabEl = (cov_1jnbbceoql.s[396]++, []);
      cov_1jnbbceoql.s[397]++;
      for (var _iterator11 = this.actorListLink, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
        var _ref11;

        if (_isArray11) {
          if (_i11 >= _iterator11.length) break;
          _ref11 = _iterator11[_i11++];
        } else {
          _i11 = _iterator11.next();
          if (_i11.done) break;
          _ref11 = _i11.value;
        }

        var el = _ref11;
        cov_1jnbbceoql.s[398]++;

        if (el.checked) {
          cov_1jnbbceoql.b[111][0]++;
          cov_1jnbbceoql.s[399]++;

          tabEl.push(el.id);
        } else {
          cov_1jnbbceoql.b[111][1]++;
        }
      }

      cov_1jnbbceoql.s[400]++;
      this.userSelected.LIST_ACTEURS = tabEl.join(' , ');
      cov_1jnbbceoql.s[401]++;
      $CRUDService.save(PATH, { id: this.userSelected.id, action: 'setListA', valeur: $filter('json')(tabEl.join(' , ')) }, function (data) {
        cov_1jnbbceoql.f[49]++;
        cov_1jnbbceoql.s[402]++;

        $scope.userManager.cancelList();
      });
    }
  };

  cov_1jnbbceoql.s[403]++;
  $scope.stakeholders = {
    filtreActor: function filtreActor(item, itema) {
      cov_1jnbbceoql.s[404]++;

      if (item.IDACTEURS) {
        cov_1jnbbceoql.b[112][0]++;
        cov_1jnbbceoql.s[405]++;

        if (itema.id == item.IDACTEURS.id) {
          cov_1jnbbceoql.b[113][0]++;
          cov_1jnbbceoql.s[406]++;

          return true;
        } else {
          cov_1jnbbceoql.b[113][1]++;
        }
      } else {
        cov_1jnbbceoql.b[112][1]++;
      }
      cov_1jnbbceoql.s[407]++;
      if (itema.id == -100) {
        cov_1jnbbceoql.b[114][0]++;
        cov_1jnbbceoql.s[408]++;

        return true;
      } else {
        cov_1jnbbceoql.b[114][1]++;
      }
      cov_1jnbbceoql.s[409]++;
      for (var _iterator12 = $scope.stakeholders.listUser, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
        var _ref12;

        if (_isArray12) {
          if (_i12 >= _iterator12.length) break;
          _ref12 = _iterator12[_i12++];
        } else {
          _i12 = _iterator12.next();
          if (_i12.done) break;
          _ref12 = _i12.value;
        }

        var el = _ref12;
        cov_1jnbbceoql.s[410]++;

        if (el.IDACTEURS.id == itema.id) {
          cov_1jnbbceoql.b[115][0]++;
          cov_1jnbbceoql.s[411]++;

          return false;
        } else {
          cov_1jnbbceoql.b[115][1]++;
        }
      }
      cov_1jnbbceoql.s[412]++;
      return true;
    },
    validate: function validate() {
      var list = (cov_1jnbbceoql.s[413]++, []);
      cov_1jnbbceoql.s[414]++;
      for (var _iterator13 = this.listUser, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;) {
        var _ref13;

        if (_isArray13) {
          if (_i13 >= _iterator13.length) break;
          _ref13 = _iterator13[_i13++];
        } else {
          _i13 = _iterator13.next();
          if (_i13.done) break;
          _ref13 = _i13.value;
        }

        var el = _ref13;
        cov_1jnbbceoql.s[415]++;

        list.push({
          IDACTEURS: el.IDACTEURS.id == -100 ? (cov_1jnbbceoql.b[116][0]++, 0) : (cov_1jnbbceoql.b[116][1]++, el.IDACTEURS.id),
          IDUSER: el.id,
          id: 0
        });
      }
      cov_1jnbbceoql.s[416]++;
      if (list.length == 0) {
        cov_1jnbbceoql.b[117][0]++;
        cov_1jnbbceoql.s[417]++;

        return;
      } else {
        cov_1jnbbceoql.b[117][1]++;
      }
      cov_1jnbbceoql.s[418]++;
      this.update = true;
      cov_1jnbbceoql.s[419]++;
      $scope.isloading = true;
      cov_1jnbbceoql.s[420]++;
      $CRUDService.save(PATH, { action: 'setLink', valeur: $filter('json')(list) }, function (data) {
        cov_1jnbbceoql.f[50]++;
        cov_1jnbbceoql.s[421]++;

        $scope.isloading = false;
      });
      cov_1jnbbceoql.s[422]++;
      this.cancel();
    },
    cancel: function cancel() {
      cov_1jnbbceoql.s[423]++;

      this.actorList = [];
      cov_1jnbbceoql.s[424]++;
      this.listUser = [];
      cov_1jnbbceoql.s[425]++;
      if (this.update) {
        cov_1jnbbceoql.b[118][0]++;
        cov_1jnbbceoql.s[426]++;

        $scope.userManager.getAll();
      } else {
        cov_1jnbbceoql.b[118][1]++;
      }
      cov_1jnbbceoql.s[427]++;
      $scope.step = 1;
    },
    __filterActor: function __filterActor(value) {
      cov_1jnbbceoql.s[428]++;

      if (value.id == -100) {
        cov_1jnbbceoql.b[119][0]++;
        cov_1jnbbceoql.s[429]++;

        return true;
      } else {
        cov_1jnbbceoql.b[119][1]++;
      }
      cov_1jnbbceoql.s[430]++;
      if (value.id < 0) {
        cov_1jnbbceoql.b[120][0]++;
        cov_1jnbbceoql.s[431]++;

        return false;
      } else {
        cov_1jnbbceoql.b[120][1]++;
      }
      cov_1jnbbceoql.s[432]++;
      return true;
    },
    openList: function openList() {
      cov_1jnbbceoql.s[433]++;

      this.update = false;
      cov_1jnbbceoql.s[434]++;
      this.actorList = $filter('filter')($scope.listData_actors_bksb, this.__filterActor);
      cov_1jnbbceoql.s[435]++;
      this.listUser = [];
      cov_1jnbbceoql.s[436]++;
      for (var _iterator14 = $scope.userManager.listUser, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;) {
        var _ref14;

        if (_isArray14) {
          if (_i14 >= _iterator14.length) break;
          _ref14 = _iterator14[_i14++];
        } else {
          _i14 = _iterator14.next();
          if (_i14.done) break;
          _ref14 = _i14.value;
        }

        var u = _ref14;

        var el = (cov_1jnbbceoql.s[437]++, angular.copy(u));
        var acteur = (cov_1jnbbceoql.s[438]++, $filter('filter')($scope.listData_actors_bksb, { id: el.IDACTEURS }, true)[0]);
        cov_1jnbbceoql.s[439]++;
        if (!acteur) {
          cov_1jnbbceoql.b[121][0]++;
          cov_1jnbbceoql.s[440]++;

          acteur = $filter('filter')($scope.listData_actors_bksb, { id: -100 }, true)[0];
        } else {
          cov_1jnbbceoql.b[121][1]++;
        }
        cov_1jnbbceoql.s[441]++;
        el.IDACTEURS = acteur;
        cov_1jnbbceoql.s[442]++;
        this.listUser.push(el);
      }
      cov_1jnbbceoql.s[443]++;
      $scope.step = 2;
    }
  };

  var uploader = (cov_1jnbbceoql.s[444]++, $scope.uploader = new FileUploader({
    headers: $CRUDService.getHeader(),
    url: $CRUDService.getServerAdress() + 'web_server.php?action=chargePicture&' + $CRUDService.getComplement() + '&li_bksb=' + PATH,
    alias: 'photo_utilisateur',
    removeAfterUpload: true
  }));
  cov_1jnbbceoql.s[445]++;
  uploader.onAfterAddingFile = function (fileItem, a, b, c, d, e) {
    cov_1jnbbceoql.f[51]++;
    cov_1jnbbceoql.s[446]++;

    $scope.userManager.editLoading = true;
    cov_1jnbbceoql.s[447]++;
    fileItem.upload();
  };
  cov_1jnbbceoql.s[448]++;
  uploader.onSuccessItem = function (fileItem, response, status, headers) {
    cov_1jnbbceoql.f[52]++;
    cov_1jnbbceoql.s[449]++;

    if (response.file) {
      cov_1jnbbceoql.b[122][0]++;
      cov_1jnbbceoql.s[450]++;

      $scope.userManager.picteurUpdated = $deltahttp.getUserPicture(response.file);
    } else {
      cov_1jnbbceoql.b[122][1]++;
    }

    cov_1jnbbceoql.s[451]++;
    $scope.userManager.editLoading = false;
  };
  cov_1jnbbceoql.s[452]++;
  uploader.onErrorItem = function (fileItem, response, status, headers) {
    cov_1jnbbceoql.f[53]++;
    cov_1jnbbceoql.s[453]++;

    $scope.userManager.editLoading = false;
  };

  cov_1jnbbceoql.s[454]++;
  $CRUDService.getAll('AgenciesProject', { get: 'all' }, function (data) {
    cov_1jnbbceoql.f[54]++;
    cov_1jnbbceoql.s[455]++;

    $scope.agencies = data;
    cov_1jnbbceoql.s[456]++;
    $scope.filter.agencies = data.map(function (value) {
      cov_1jnbbceoql.f[55]++;
      cov_1jnbbceoql.s[457]++;
      return { id: value.id, NAME_AG: value.NAME_AG };
    });
    cov_1jnbbceoql.s[458]++;
    $scope.agencies.push({ id: -1, NAME_AG: $translate.instant('COMMON.NONE_E') });
    cov_1jnbbceoql.s[459]++;
    $scope.agencies.push({ id: 0, NAME_AG: '' });

    cov_1jnbbceoql.s[460]++;
    $scope.filter.selectedProject[$rootScope.currentProject.project.id] = true;

    cov_1jnbbceoql.s[461]++;
    $scope.userManager.getAll();
  });
  cov_1jnbbceoql.s[462]++;


  $CRUDService.getAll('Projet', { get: 'all_short', portfolio: 1 }, function (data) {
    cov_1jnbbceoql.f[56]++;

    var portfolio = (cov_1jnbbceoql.s[463]++, data.findIndex(function (project) {
      cov_1jnbbceoql.f[57]++;
      cov_1jnbbceoql.s[464]++;

      return project.PORTFOLIO == 1;
    }));

    cov_1jnbbceoql.s[465]++;
    if (portfolio >= 0) {
      cov_1jnbbceoql.b[123][0]++;
    } else {
      cov_1jnbbceoql.b[123][1]++;
    }

    cov_1jnbbceoql.s[466]++;
    $scope.userManager.listProjects = data;

    cov_1jnbbceoql.s[467]++;
    $scope.userManager.portfolios = data.filter(function (it) {
      cov_1jnbbceoql.f[58]++;
      cov_1jnbbceoql.s[468]++;
      return it.PORTFOLIO == 1;
    });
    cov_1jnbbceoql.s[469]++;
    $scope.userManager.projects = data.filter(function (it) {
      cov_1jnbbceoql.f[59]++;
      cov_1jnbbceoql.s[470]++;
      return it.PORTFOLIO == 0;
    });
  });

  cov_1jnbbceoql.s[471]++;
  $CRUDService.getAll(PATH_PROFIL, { get: 'all', all: 1 }, function (data) {
    cov_1jnbbceoql.f[60]++;
    cov_1jnbbceoql.s[472]++;

    $scope.userManager.portfolioPredefinedGroup = data.map(function (value) {
      cov_1jnbbceoql.f[61]++;

      var _ = (cov_1jnbbceoql.s[473]++, { id: value.id });
      cov_1jnbbceoql.s[474]++;

      switch (parseInt(value.NOT_DISPLAY)) {
        case 1:
          cov_1jnbbceoql.b[124][0]++;
          cov_1jnbbceoql.s[475]++;

          _.label = $translate.instant('G_U.STANDARD_USER');
          cov_1jnbbceoql.s[476]++;
          break;
        case 2:
          cov_1jnbbceoql.b[124][1]++;
          cov_1jnbbceoql.s[477]++;

          _.label = $translate.instant('G_U.VIEW_USER');
          cov_1jnbbceoql.s[478]++;
          break;
        case 3:
          cov_1jnbbceoql.b[124][2]++;
          cov_1jnbbceoql.s[479]++;

          _.label = $translate.instant('G_U.NO_ACCESS');
          cov_1jnbbceoql.s[480]++;
          break;
        case 4:
          cov_1jnbbceoql.b[124][3]++;
          cov_1jnbbceoql.s[481]++;

          _.label = '';cov_1jnbbceoql.s[482]++;

          break;
        case 5:
          cov_1jnbbceoql.b[124][4]++;
          cov_1jnbbceoql.s[483]++;

          _.label = $translate.instant('G_U.COLLECT_USER');
          cov_1jnbbceoql.s[484]++;
          break;
        case 6:
          cov_1jnbbceoql.b[124][5]++;
          cov_1jnbbceoql.s[485]++;

          _.label = $translate.instant('G_U.ADMIN_USER');
          cov_1jnbbceoql.s[486]++;
          break;
        case 7:
          cov_1jnbbceoql.b[124][6]++;
          cov_1jnbbceoql.s[487]++;

          _.label = $translate.instant('G_U.NO_ACCESS');
          cov_1jnbbceoql.s[488]++;
          break;
        case 8:
          cov_1jnbbceoql.b[124][7]++;
          cov_1jnbbceoql.s[489]++;

          _.label = $translate.instant('G_U.STANDARD_PLUS_USER');
          cov_1jnbbceoql.s[490]++;
          break;

        default:
          cov_1jnbbceoql.b[124][8]++;
          cov_1jnbbceoql.s[491]++;

          _.label = value.LABEL_PROFIL;
      }
      cov_1jnbbceoql.s[492]++;
      _.type = value.NOT_DISPLAY;
      cov_1jnbbceoql.s[493]++;
      return _;
    });

    cov_1jnbbceoql.s[494]++;
    $scope.userManager.predefinedGroup = $scope.userManager.portfolioPredefinedGroup.filter(function (p) {
      cov_1jnbbceoql.f[62]++;
      cov_1jnbbceoql.s[495]++;

      return p.type != 7;
    });

    cov_1jnbbceoql.s[496]++;
    $scope.userManager.predefinedGroup.push({
      id: 0,
      type: -1,
      label: $translate.instant('G_U.NO_ACCESS')
    });

    cov_1jnbbceoql.s[497]++;
    $scope.userManager.portfolioPredefinedGroup.push({
      id: 0,
      type: -1,
      label: $translate.instant('G_U.NO_ACCESS_PORTFOLIO')
    });

    cov_1jnbbceoql.s[498]++;

    $scope.bulkEditProfile.bulkAssignment.selectedProfile = {
      id: 0,
      type: -1,
      label: $translate.instant('G_U.NO_ACCESS_PORTFOLIO')
    };
  });
});

function UserValidationCtrl($scope, $uibModalInstance, $translate, $deltadate, $rootScope, $CRUDService, $filter) {
  cov_1jnbbceoql.f[63]++;

  var PATH = (cov_1jnbbceoql.s[499]++, 'User');
  var LISTFLAG = (cov_1jnbbceoql.s[500]++, $rootScope.getCurrentProject().project.getFlag());
  cov_1jnbbceoql.s[501]++;
  $scope.loadingValidation = true;

  cov_1jnbbceoql.s[502]++;
  $scope.allActivities = true;
  cov_1jnbbceoql.s[503]++;
  $scope.allIndicators = true;
  cov_1jnbbceoql.s[504]++;
  $scope.params = {
    users: $scope.selectedValidation
  };
  cov_1jnbbceoql.s[505]++;
  $CRUDService.getAll(PATH, { get: 'all_validation', id: $scope.selectedValidation.id }, function (data) {
    cov_1jnbbceoql.f[64]++;

    var values = (cov_1jnbbceoql.s[506]++, {});
    cov_1jnbbceoql.s[507]++;
    for (var _iterator15 = data, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;) {
      var _ref15;

      if (_isArray15) {
        if (_i15 >= _iterator15.length) break;
        _ref15 = _iterator15[_i15++];
      } else {
        _i15 = _iterator15.next();
        if (_i15.done) break;
        _ref15 = _i15.value;
      }

      var el = _ref15;
      cov_1jnbbceoql.s[508]++;

      values[el.ID_USER] = {
        i: (cov_1jnbbceoql.b[125][0]++, el.TYPE == 3) || (cov_1jnbbceoql.b[125][1]++, el.TYPE == 2),
        a: (cov_1jnbbceoql.b[126][0]++, el.TYPE == 3) || (cov_1jnbbceoql.b[126][1]++, el.TYPE == 1)
      };
    }
    cov_1jnbbceoql.s[509]++;
    $scope.listValidation = values;
    cov_1jnbbceoql.s[510]++;
    $scope.loadingValidation = false;
  });
  cov_1jnbbceoql.s[511]++;
  $scope.validate = function () {
    cov_1jnbbceoql.f[65]++;

    var values = (cov_1jnbbceoql.s[512]++, []);
    cov_1jnbbceoql.s[513]++;
    for (var key in $scope.listValidation) {
      var val = (cov_1jnbbceoql.s[514]++, ($scope.listValidation[key].a ? (cov_1jnbbceoql.b[127][0]++, 1) : (cov_1jnbbceoql.b[127][1]++, 0)) + ($scope.listValidation[key].i ? (cov_1jnbbceoql.b[128][0]++, 2) : (cov_1jnbbceoql.b[128][1]++, 0)));
      cov_1jnbbceoql.s[515]++;
      if ((cov_1jnbbceoql.b[130][0]++, val == 0) || (cov_1jnbbceoql.b[130][1]++, key == $scope.selectedValidation.id)) {
        cov_1jnbbceoql.b[129][0]++;
        cov_1jnbbceoql.s[516]++;

        continue;
      } else {
        cov_1jnbbceoql.b[129][1]++;
      }
      cov_1jnbbceoql.s[517]++;
      values.push({
        ID_USER: key,
        TYPE: val,
        ID_OWNER: $scope.selectedValidation.id
      });
    }
    cov_1jnbbceoql.s[518]++;
    $scope.loadingValidation = true;
    cov_1jnbbceoql.s[519]++;
    $CRUDService.save(PATH, { action: 'miseAJourValidation', valeur: $filter('json')(values), id: $scope.selectedValidation.id }, function (data) {
      cov_1jnbbceoql.f[66]++;
      cov_1jnbbceoql.s[520]++;

      $scope.loadingValidation = false;
      cov_1jnbbceoql.s[521]++;
      $scope.closeModal();
    });
  };
  cov_1jnbbceoql.s[522]++;
  $scope.checkValidation = {
    allActivities: false,
    allIndicators: false,
    deselected: function deselected(value, type) {
      cov_1jnbbceoql.s[523]++;

      if (!value) {
        cov_1jnbbceoql.b[131][0]++;
        cov_1jnbbceoql.s[524]++;

        if (type == 1) {
          cov_1jnbbceoql.b[132][0]++;
          cov_1jnbbceoql.s[525]++;

          this.allActivities = false;
        } else {
          cov_1jnbbceoql.b[132][1]++;
          cov_1jnbbceoql.s[526]++;

          this.allIndicators = false;
        }
      } else {
        cov_1jnbbceoql.b[131][1]++;
      }
    },
    check: function check(type, myId) {
      var key = (cov_1jnbbceoql.s[527]++, 'a');
      var value = (cov_1jnbbceoql.s[528]++, this.allActivities);
      cov_1jnbbceoql.s[529]++;
      if (type == 2) {
        cov_1jnbbceoql.b[133][0]++;
        cov_1jnbbceoql.s[530]++;

        key = 'i';
        cov_1jnbbceoql.s[531]++;
        value = this.allIndicators;
      } else {
        cov_1jnbbceoql.b[133][1]++;
      }
      cov_1jnbbceoql.s[532]++;
      for (var _iterator16 = $scope.userManager.listUser, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;) {
        var _ref16;

        if (_isArray16) {
          if (_i16 >= _iterator16.length) break;
          _ref16 = _iterator16[_i16++];
        } else {
          _i16 = _iterator16.next();
          if (_i16.done) break;
          _ref16 = _i16.value;
        }

        var el = _ref16;
        cov_1jnbbceoql.s[533]++;

        if (el.id == myId) {
          cov_1jnbbceoql.b[134][0]++;
          cov_1jnbbceoql.s[534]++;

          continue;
        } else {
          cov_1jnbbceoql.b[134][1]++;
        }
        cov_1jnbbceoql.s[535]++;
        if (angular.isUndefined($scope.listValidation[el.id])) {
          cov_1jnbbceoql.b[135][0]++;
          cov_1jnbbceoql.s[536]++;

          $scope.listValidation[el.id] = {
            a: false,
            i: false
          };
        } else {
          cov_1jnbbceoql.b[135][1]++;
        }
        cov_1jnbbceoql.s[537]++;
        $scope.listValidation[el.id][key] = value;
      }
    }
  };
  cov_1jnbbceoql.s[538]++;

  $scope.closeModal = function () {
    cov_1jnbbceoql.f[67]++;
    cov_1jnbbceoql.s[539]++;

    $uibModalInstance.dismiss('cancel');
  };
}